import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** A date-time string at UTC, such as 2019-12-03T09:54:33Z, compliant with the date-time format. */
  DateTime: any;
};

export type Account = {
  __typename?: 'Account';
  buildProjects: Array<BuildProject>;
  currentUser: User;
  id: Scalars['String'];
};

export type AccountManager = {
  __typename?: 'AccountManager';
  buildRegions: Array<BuildRegion>;
  consultCallUrl?: Maybe<Scalars['String']>;
  createdTs: Scalars['DateTime'];
  email: Scalars['String'];
  id: Scalars['String'];
  isActive?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  projectManagerId: Scalars['String'];
  slackChannelId?: Maybe<Scalars['String']>;
  thumbnailMediaId?: Maybe<Scalars['String']>;
  thumbnailUrl?: Maybe<Scalars['String']>;
  updatedTs: Scalars['DateTime'];
  userId: Scalars['String'];
};

export type ActionAcknowledgement = {
  __typename?: 'ActionAcknowledgement';
  key: Scalars['String'];
  updatedTs: Scalars['DateTime'];
};

export type Address = {
  __typename?: 'Address';
  addressLine1: Scalars['String'];
  addressLine2?: Maybe<Scalars['String']>;
  buildRegions?: Maybe<Array<BuildRegion>>;
  businessName?: Maybe<Scalars['String']>;
  city: Scalars['String'];
  createdTs: Scalars['DateTime'];
  id: Scalars['String'];
  latitude: Scalars['Float'];
  longitude: Scalars['Float'];
  phone?: Maybe<Scalars['String']>;
  state: Scalars['String'];
  updatedTs: Scalars['DateTime'];
  zipcode: Scalars['String'];
};

export type AddressPaginator = {
  cursor?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Float']>;
  sortBy?: InputMaybe<AddressesSortByEnum>;
  sortDirection?: InputMaybe<SortDirection>;
};

export enum AddressesSortByEnum {
  AddressLine_1 = 'ADDRESS_LINE_1',
  AddressLine_2 = 'ADDRESS_LINE_2',
  BusinessName = 'BUSINESS_NAME',
  City = 'CITY',
  CreatedAt = 'CREATED_AT',
  State = 'STATE',
  UpdatedAt = 'UPDATED_AT',
  Zipcode = 'ZIPCODE'
}

export type AssignAccountManagerInput = {
  buildProjectId: Scalars['String'];
  userId: Scalars['String'];
};

export type BriefElementsExportData = {
  __typename?: 'BriefElementsExportData';
  address: Scalars['String'];
  tableColumns: Array<BriefElementsExportRow>;
};

export type BriefElementsExportRow = {
  __typename?: 'BriefElementsExportRow';
  name: Scalars['String'];
  quantity: Scalars['Float'];
  totalCost: Scalars['String'];
  vendor: Scalars['String'];
};

export type BriefHeaderInformation = {
  __typename?: 'BriefHeaderInformation';
  address: Scalars['String'];
  contractorNotes?: Maybe<Scalars['String']>;
  fullName: Scalars['String'];
  revisionName?: Maybe<Scalars['String']>;
};

export type BriefMaterialExportData = {
  __typename?: 'BriefMaterialExportData';
  address: Scalars['String'];
  tableColumns: Array<BriefMaterialExportRow>;
};

export type BriefMaterialExportRow = {
  __typename?: 'BriefMaterialExportRow';
  color: Scalars['String'];
  materialName: Scalars['String'];
  pattern: Scalars['String'];
  quantity: Scalars['Float'];
  size: Scalars['String'];
  vendor: Scalars['String'];
};

export type BriefMedia = {
  __typename?: 'BriefMedia';
  fileName: Scalars['String'];
  mimeType: Scalars['String'];
  path: Scalars['String'];
  tag?: Maybe<Scalars['String']>;
  uploadedAt?: Maybe<Scalars['DateTime']>;
  variant?: Maybe<Scalars['String']>;
};

export type BriefPlantExportData = {
  __typename?: 'BriefPlantExportData';
  address: Scalars['String'];
  tableColumns: Array<BriefPlantExportRow>;
};

export type BriefPlantExportRow = {
  __typename?: 'BriefPlantExportRow';
  commonName: Scalars['String'];
  containerSize: Scalars['String'];
  lighting: Scalars['String'];
  quantity: Scalars['Float'];
  scientificName: Scalars['String'];
  type: Scalars['String'];
  waterNeeds: Scalars['String'];
};

export type BuildProject = {
  __typename?: 'BuildProject';
  account: Account;
  accountId: Scalars['String'];
  accountManager?: Maybe<AccountManager>;
  accountManagerId?: Maybe<Scalars['String']>;
  cards?: Maybe<Array<ProjectCard>>;
  createdTs: Scalars['DateTime'];
  designAssignment?: Maybe<DesignAssignment>;
  estimates: Array<Estimate>;
  firebaseProjectId?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  internalNotes?: Maybe<Scalars['String']>;
  pipefyClientCardId?: Maybe<Scalars['String']>;
  proFacingNotes?: Maybe<Scalars['String']>;
  projectBudgetEstimate?: Maybe<Array<Scalars['Float']>>;
  projectCards?: Maybe<Array<ResolvedProjectCard>>;
  projectElements: Array<ProjectElement>;
  surveyResponses: Array<SurveyResponse>;
  updatedTs: Scalars['DateTime'];
};


export type BuildProjectEstimatesArgs = {
  input?: InputMaybe<FindAllEstimatesInput>;
};


export type BuildProjectProjectCardsArgs = {
  input?: InputMaybe<ResolveBuildProjectPipefyCardsInput>;
};

export type BuildProjectPaginator = {
  cursor?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Float']>;
  sortBy?: InputMaybe<BuildProjectSortByEnum>;
  sortDirection?: InputMaybe<SortDirection>;
};

export enum BuildProjectSortByEnum {
  CreatedAt = 'CREATED_AT',
  UpdatedAt = 'UPDATED_AT'
}

export type BuildRegion = {
  __typename?: 'BuildRegion';
  accountManager?: Maybe<AccountManager>;
  accountManagerId?: Maybe<Scalars['String']>;
  archived: Scalars['Boolean'];
  areaGeometry: Scalars['String'];
  contractorId: Scalars['String'];
  createdTs: Scalars['DateTime'];
  displayName: Scalars['String'];
  id: Scalars['String'];
  internalName: Scalars['String'];
  isDefault: Scalars['Boolean'];
  lastUpdatedBy: Scalars['String'];
  maxLat: Scalars['Float'];
  maxLng: Scalars['Float'];
  minLat: Scalars['Float'];
  minLng: Scalars['Float'];
  updatedTs: Scalars['DateTime'];
};

export type Card = {
  __typename?: 'Card';
  brand?: Maybe<Scalars['String']>;
  last4?: Maybe<Scalars['String']>;
};

export type CardField = {
  __typename?: 'CardField';
  field?: Maybe<PipefyField>;
  id?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  value?: Maybe<Scalars['String']>;
};

export type CardPhase = {
  __typename?: 'CardPhase';
  done: Scalars['Boolean'];
  fieldConditions?: Maybe<Array<PhaseFieldCondition>>;
  fields?: Maybe<Array<PhaseField>>;
  id: Scalars['String'];
  name: Scalars['String'];
  value: Scalars['String'];
};

export type CityProjectElement = {
  __typename?: 'CityProjectElement';
  city: Scalars['String'];
  createdTs: Scalars['DateTime'];
  id: Scalars['String'];
  popularity: Scalars['Float'];
  projectElement: ProjectElement;
  updatedTs: Scalars['DateTime'];
  url: Scalars['String'];
};

export type ClientCard = {
  __typename?: 'ClientCard';
  fields?: Maybe<Array<CardField>>;
  id: Scalars['String'];
  title: Scalars['String'];
};

export type Contractor = {
  __typename?: 'Contractor';
  abilities: Array<Scalars['String']>;
  acceptingWork: Scalars['Boolean'];
  approvalStatus: Scalars['String'];
  approved: Scalars['Boolean'];
  businessName: Scalars['String'];
  city: Scalars['String'];
  closeRate?: Maybe<Scalars['Float']>;
  coordinates?: Maybe<Coordinates>;
  createdAt: Scalars['String'];
  currentBuildRegionId: Scalars['String'];
  dashboardAccessEmails?: Maybe<Array<Scalars['String']>>;
  email: Scalars['String'];
  firstName?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  initialBuildRegionId: Scalars['String'];
  lastName?: Maybe<Scalars['String']>;
  locations?: Maybe<Array<Scalars['String']>>;
  matchedUsers: Array<UserProfileEnhanced>;
  maxSuccessBudget?: Maybe<Scalars['Float']>;
  minSuccessBudget?: Maybe<Scalars['Float']>;
  notApprovedStatusReason?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  paused: Scalars['Boolean'];
  pausedAt?: Maybe<Scalars['String']>;
  pausedStatusReason?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  pipefyContractorCardId?: Maybe<Scalars['Float']>;
  pointOfContactEmail: Scalars['String'];
  pointOfContactName?: Maybe<Scalars['String']>;
  pointOfContactPhone?: Maybe<Scalars['String']>;
  preferred: Scalars['Boolean'];
  profile: ContractorProfile;
  state: Scalars['String'];
  street?: Maybe<Scalars['String']>;
  unpausedAt?: Maybe<Scalars['String']>;
  updatedAt: Scalars['String'];
  userId?: Maybe<Scalars['String']>;
  website?: Maybe<Scalars['String']>;
  zip?: Maybe<Scalars['String']>;
};


export type ContractorMatchedUsersArgs = {
  userProfileQuery: Scalars['String'];
};

export type ContractorAbilityLinkType = {
  __typename?: 'ContractorAbilityLinkType';
  contractorAbilityName?: Maybe<Scalars['String']>;
  contractorProfileId: Scalars['String'];
  name?: Maybe<Scalars['String']>;
};

export enum ContractorAttribute {
  BipocOwned = 'BIPOC_OWNED',
  Bonded = 'BONDED',
  BookingFast = 'BOOKING_FAST',
  EcoFriendly = 'ECO_FRIENDLY',
  FamilyOwned = 'FAMILY_OWNED',
  FemaleFounded = 'FEMALE_FOUNDED',
  FreeEstimates = 'FREE_ESTIMATES',
  Insured = 'INSURED',
  Licensed = 'LICENSED',
  OwnerOperated = 'OWNER_OPERATED',
  PremiumExperience = 'PREMIUM_EXPERIENCE',
  PtiCertifiedBuilder = 'PTI_CERTIFIED_BUILDER',
  PtiEliteBuilder = 'PTI_ELITE_BUILDER',
  ResponsiveCommunication = 'RESPONSIVE_COMMUNICATION',
  SuperPro = 'SUPER_PRO',
  ValuePro = 'VALUE_PRO',
  VeteranOwned = 'VETERAN_OWNED',
  YardzenApproved = 'YARDZEN_APPROVED',
  YearsInBusiness = 'YEARS_IN_BUSINESS'
}

export type ContractorContact = {
  __typename?: 'ContractorContact';
  contractorId: Scalars['String'];
  createdTs: Scalars['DateTime'];
  email: Scalars['String'];
  firstName?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  isPrimary: Scalars['Boolean'];
  lastName?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  updatedTs: Scalars['DateTime'];
};

export type ContractorDocument = {
  __typename?: 'ContractorDocument';
  confirmationLink?: Maybe<Scalars['String']>;
  createdTs: Scalars['DateTime'];
  expirationDate?: Maybe<Scalars['DateTime']>;
  id: Scalars['String'];
  kind: Scalars['String'];
  licenseNumber?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  policyNumber?: Maybe<Scalars['String']>;
  uri?: Maybe<Scalars['String']>;
};

export type ContractorImage = {
  __typename?: 'ContractorImage';
  id: Scalars['String'];
  uri: Scalars['String'];
};

export type ContractorMetrics = {
  __typename?: 'ContractorMetrics';
  avgContractRevenue: Scalars['String'];
  avgResponseTime: Scalars['String'];
  estimates: Scalars['Int'];
  estimatesToSignedContractsRate: Scalars['String'];
  introToSignedContractsRate: Scalars['String'];
  introToSiteWalksRate: Scalars['String'];
  matches: Scalars['Int'];
  signedContracts: Scalars['Int'];
  siteWalksScheduled: Scalars['Int'];
  siteWalksToEstimatesRate: Scalars['String'];
  totalProjectsSignedYtd: Scalars['Int'];
  totalRevenueBooked: Scalars['String'];
};

export enum ContractorNotApprovedStatusReason {
  ArViolation = 'AR_VIOLATION',
  Blacklisted = 'BLACKLISTED',
  None = 'NONE',
  Requested = 'REQUESTED',
  Unengaged = 'UNENGAGED'
}

export enum ContractorPausedStatusReason {
  ArViolation = 'AR_VIOLATION',
  ContractorRequested = 'CONTRACTOR_REQUESTED',
  MissingLicense = 'MISSING_LICENSE',
  NegativeReviews = 'NEGATIVE_REVIEWS',
  None = 'NONE',
  NoOnlinePresence = 'NO_ONLINE_PRESENCE',
  PerformanceQualityIssues = 'PERFORMANCE_QUALITY_ISSUES',
  ProDesignOnly = 'PRO_DESIGN_ONLY',
  Requested = 'REQUESTED',
  UnresponsiveNoUpdates = 'UNRESPONSIVE_NO_UPDATES',
  UnresponsiveYardzen = 'UNRESPONSIVE_YARDZEN',
  VettingIssue = 'VETTING_ISSUE'
}

export type ContractorProfile = {
  __typename?: 'ContractorProfile';
  abilities?: Maybe<Array<ContractorAbilityLinkType>>;
  aboutSummary?: Maybe<Scalars['String']>;
  acceptingWork?: Maybe<Scalars['Boolean']>;
  active: Scalars['Boolean'];
  address?: Maybe<Address>;
  addressId?: Maybe<Scalars['String']>;
  approved: Scalars['Boolean'];
  approvedTs?: Maybe<Scalars['DateTime']>;
  attributes?: Maybe<Array<ContractorAttribute>>;
  budgetRangeLowerBound?: Maybe<Scalars['Int']>;
  budgetRangeUpperBound?: Maybe<Scalars['Int']>;
  businessName?: Maybe<Scalars['String']>;
  calendlyEmail?: Maybe<Scalars['String']>;
  calendlyUrl?: Maybe<Scalars['String']>;
  contacts?: Maybe<Array<ContractorContact>>;
  contractorId: Scalars['String'];
  createdBy?: Maybe<Scalars['String']>;
  createdTs: Scalars['DateTime'];
  currentBuildRegionId?: Maybe<Scalars['String']>;
  documents: Array<ContractorDocument>;
  email?: Maybe<Scalars['String']>;
  galleryImages: Array<ContractorImage>;
  googleUrl?: Maybe<Scalars['String']>;
  headshotMediaUrl?: Maybe<Scalars['String']>;
  initialBuildRegionId?: Maybe<Scalars['String']>;
  isTest?: Maybe<Scalars['Boolean']>;
  licenseExpirationDate?: Maybe<Scalars['DateTime']>;
  licenseNumber?: Maybe<Scalars['String']>;
  loginHistory?: Maybe<Array<LoginHistory>>;
  matchedUsers: Array<UserProfileEnhanced>;
  maxSuccessBudget?: Maybe<Scalars['Int']>;
  media?: Maybe<Array<Media>>;
  minSuccessBudget?: Maybe<Scalars['Int']>;
  notApprovedStatusReason?: Maybe<ContractorNotApprovedStatusReason>;
  notes?: Maybe<Scalars['String']>;
  paused: Scalars['Boolean'];
  pausedStatusReason?: Maybe<ContractorPausedStatusReason>;
  pausedTs?: Maybe<Scalars['DateTime']>;
  phoneNumber?: Maybe<Scalars['String']>;
  pipefyContractorCardId?: Maybe<Scalars['Float']>;
  preferred?: Maybe<Scalars['Boolean']>;
  projectDigestFrequency?: Maybe<ProjectDigestFrequency>;
  promotionalMessage?: Maybe<Scalars['String']>;
  promotionalMessageEndDate?: Maybe<Scalars['DateTime']>;
  promotionalMessageStartDate?: Maybe<Scalars['DateTime']>;
  rating?: Maybe<Scalars['Float']>;
  reviews?: Maybe<Array<ContractorReview>>;
  revisions: Array<Revision>;
  stripeConnectedAccountId?: Maybe<Scalars['String']>;
  thumbnailMediaUrl?: Maybe<Scalars['String']>;
  unapprovedTs?: Maybe<Scalars['DateTime']>;
  unpausedTs?: Maybe<Scalars['DateTime']>;
  updatedBy?: Maybe<Scalars['String']>;
  updatedTs: Scalars['DateTime'];
  userId?: Maybe<Scalars['String']>;
  videos: Array<ContractorImage>;
  website?: Maybe<Scalars['String']>;
  whyYardzenLovesSummary?: Maybe<Scalars['String']>;
  yearsInBusiness?: Maybe<Scalars['Int']>;
  yelpUrl?: Maybe<Scalars['String']>;
};


export type ContractorProfileLoginHistoryArgs = {
  pagination?: InputMaybe<LoginHistoryPaginator>;
};


export type ContractorProfileMatchedUsersArgs = {
  userProfileQuery: Scalars['String'];
};

export type ContractorReview = {
  __typename?: 'ContractorReview';
  author: Scalars['String'];
  contractorId: Scalars['String'];
  createdTs: Scalars['DateTime'];
  id: Scalars['String'];
  reviewedTs: Scalars['DateTime'];
  source: ContractorReviewSource;
  summary: Scalars['String'];
  updatedTs: Scalars['DateTime'];
};

export enum ContractorReviewSource {
  Google = 'GOOGLE',
  Homeadvisor = 'HOMEADVISOR',
  Houzz = 'HOUZZ',
  Yardzen = 'YARDZEN',
  Yelp = 'YELP'
}

export type Conversation = {
  __typename?: 'Conversation';
  accountManager?: Maybe<AccountManager>;
  archived: Scalars['Boolean'];
  archivedTs?: Maybe<Scalars['DateTime']>;
  conversationParticipants: Array<ConversationParticipant>;
  createdTs: Scalars['DateTime'];
  customerInactive: Scalars['Boolean'];
  id: Scalars['String'];
  latestMessage?: Maybe<Message>;
  sid: Scalars['String'];
  sortByTimestamp?: Maybe<Scalars['DateTime']>;
  totalConversationCount?: Maybe<Scalars['Float']>;
  updatedTs: Scalars['DateTime'];
};

export type ConversationParticipant = {
  __typename?: 'ConversationParticipant';
  contractor?: Maybe<ContractorProfile>;
  contractorId?: Maybe<Scalars['String']>;
  conversationId: Scalars['String'];
  createdTs: Scalars['DateTime'];
  cursor?: Maybe<ConversationParticipantCursor>;
  id: Scalars['String'];
  logoUrl?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  role: ConversationRole;
  twilioId?: Maybe<Scalars['String']>;
  updatedTs: Scalars['DateTime'];
  userProfile?: Maybe<UserProfile>;
  userProfileId?: Maybe<Scalars['String']>;
};

export type ConversationParticipantCursor = {
  __typename?: 'ConversationParticipantCursor';
  conversationParticipantId: Scalars['String'];
  createdTs: Scalars['DateTime'];
  id: Scalars['String'];
  messageId: Scalars['String'];
  updatedTs: Scalars['DateTime'];
};

export enum ConversationRole {
  Admin = 'ADMIN',
  Contractor = 'CONTRACTOR',
  Customer = 'CUSTOMER'
}

export enum ConversationsPaginatorSortByEnum {
  CreatedTs = 'CREATED_TS',
  LastMessageCreatedTs = 'LAST_MESSAGE_CREATED_TS'
}

export type Coordinates = {
  __typename?: 'Coordinates';
  lat: Scalars['Float'];
  lng: Scalars['Float'];
};

export type CreateAccountInput = {
  userId: Scalars['String'];
};

export type CreateAccountManagerInput = {
  buildRegionIds: Array<Scalars['String']>;
  consultCallUrl?: InputMaybe<Scalars['String']>;
  email: Scalars['String'];
  isActive?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  projectManagerId: Scalars['String'];
  slackChannelId?: InputMaybe<Scalars['String']>;
  thumbnailMediaId?: InputMaybe<Scalars['String']>;
  userId: Scalars['String'];
};

export type CreateActionAcknowledgementInput = {
  key: Scalars['String'];
};

export type CreateAddressInput = {
  addressLine1: Scalars['String'];
  addressLine2?: InputMaybe<Scalars['String']>;
  businessName?: InputMaybe<Scalars['String']>;
  city: Scalars['String'];
  latitude: Scalars['Float'];
  longitude: Scalars['Float'];
  phone?: InputMaybe<Scalars['String']>;
  state: Scalars['String'];
  zipcode: Scalars['String'];
};

export type CreateBuildProjectInput = {
  accountId: Scalars['String'];
  members: Array<Scalars['String']>;
  projectElements?: InputMaybe<Array<ProjectElementsBatchInput>>;
};

export type CreateBuildRegionInput = {
  accountManagerId?: InputMaybe<Scalars['String']>;
  archived: Scalars['Boolean'];
  areaGeometry: Scalars['String'];
  contractorId: Scalars['String'];
  displayName: Scalars['String'];
  internalName: Scalars['String'];
  isDefault: Scalars['Boolean'];
  lastUpdatedBy: Scalars['String'];
};

export type CreateBuildStudioUserInput = {
  accountManagerId?: InputMaybe<Scalars['String']>;
  addressLine1: Scalars['String'];
  addressLine2?: InputMaybe<Scalars['String']>;
  businessName?: InputMaybe<Scalars['String']>;
  city: Scalars['String'];
  email: Scalars['String'];
  firebaseProjectId: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  latitude: Scalars['Float'];
  longitude: Scalars['Float'];
  phone?: InputMaybe<Scalars['String']>;
  state: Scalars['String'];
  userId: Scalars['String'];
  zipcode: Scalars['String'];
};

export type CreateContractorContactInput = {
  email: Scalars['String'];
  firstName?: InputMaybe<Scalars['String']>;
  isPrimary: Scalars['Boolean'];
  lastName?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
};

export type CreateContractorDocumentInput = {
  confirmationLink?: InputMaybe<Scalars['String']>;
  contractorId: Scalars['String'];
  expirationDate?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  kind: Scalars['String'];
  licenseNumber?: InputMaybe<Scalars['String']>;
  mimeType?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Float']>;
  policyNumber?: InputMaybe<Scalars['String']>;
  source?: InputMaybe<MediaSource>;
};

export type CreateContractorInput = {
  abilities?: InputMaybe<Array<Scalars['String']>>;
  acceptingWork: Scalars['Boolean'];
  approvalStatus?: InputMaybe<Scalars['String']>;
  approved: Scalars['Boolean'];
  businessName: Scalars['String'];
  city: Scalars['String'];
  closeRate?: InputMaybe<Scalars['Float']>;
  coordinates?: InputMaybe<InputCoordinates>;
  currentBuildRegionId?: InputMaybe<Scalars['String']>;
  dashboardAccessEmails?: InputMaybe<Array<Scalars['String']>>;
  email: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  locations?: InputMaybe<Array<Scalars['String']>>;
  maxSuccessBudget?: InputMaybe<Scalars['Float']>;
  minSuccessBudget?: InputMaybe<Scalars['Float']>;
  notes: Scalars['String'];
  paused: Scalars['Boolean'];
  pausedStatusReason?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  pipefyContractorCardId?: InputMaybe<Scalars['Float']>;
  pointOfContactEmail: Scalars['String'];
  pointOfContactName: Scalars['String'];
  pointOfContactPhone?: InputMaybe<Scalars['String']>;
  preferred: Scalars['Boolean'];
  state: Scalars['String'];
  street?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['String']>;
  website?: InputMaybe<Scalars['String']>;
  zip?: InputMaybe<Scalars['String']>;
};

export type CreateContractorMediaInput = {
  contractorId: Scalars['String'];
  id: Scalars['String'];
  mimeType: Scalars['String'];
  order?: InputMaybe<Scalars['Float']>;
  source?: InputMaybe<MediaSource>;
};

export type CreateContractorProfileInput = {
  abilities?: InputMaybe<Array<Scalars['String']>>;
  aboutSummary?: InputMaybe<Scalars['String']>;
  acceptingWork?: InputMaybe<Scalars['Boolean']>;
  active: Scalars['Boolean'];
  address: CreateAddressInput;
  addressId?: InputMaybe<Scalars['String']>;
  approved: Scalars['Boolean'];
  approvedTs?: InputMaybe<Scalars['DateTime']>;
  attributes?: InputMaybe<Array<ContractorAttribute>>;
  budgetRangeLowerBound?: InputMaybe<Scalars['Int']>;
  budgetRangeUpperBound?: InputMaybe<Scalars['Int']>;
  businessName?: InputMaybe<Scalars['String']>;
  calendlyEmail?: InputMaybe<Scalars['String']>;
  calendlyUrl?: InputMaybe<Scalars['String']>;
  contacts: Array<CreateContractorContactInput>;
  createdBy?: InputMaybe<Scalars['String']>;
  currentBuildRegionId?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  googleUrl?: InputMaybe<Scalars['String']>;
  headshotMediaUrl?: InputMaybe<Scalars['String']>;
  initialBuildRegionId?: InputMaybe<Scalars['String']>;
  isTest?: InputMaybe<Scalars['Boolean']>;
  licenseExpirationDate?: InputMaybe<Scalars['DateTime']>;
  licenseNumber?: InputMaybe<Scalars['String']>;
  maxSuccessBudget?: InputMaybe<Scalars['Int']>;
  minSuccessBudget?: InputMaybe<Scalars['Int']>;
  notApprovedStatusReason?: InputMaybe<ContractorNotApprovedStatusReason>;
  notes?: InputMaybe<Scalars['String']>;
  paused: Scalars['Boolean'];
  pausedStatusReason?: InputMaybe<ContractorPausedStatusReason>;
  pausedTs?: InputMaybe<Scalars['DateTime']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  pipefyContractorCardId?: InputMaybe<Scalars['Float']>;
  preferred?: InputMaybe<Scalars['Boolean']>;
  projectDigestFrequency?: InputMaybe<ProjectDigestFrequency>;
  promotionalMessage?: InputMaybe<Scalars['String']>;
  promotionalMessageEndDate?: InputMaybe<Scalars['DateTime']>;
  promotionalMessageStartDate?: InputMaybe<Scalars['DateTime']>;
  rating?: InputMaybe<Scalars['Float']>;
  stripeConnectedAccountId?: InputMaybe<Scalars['String']>;
  thumbnailMediaUrl?: InputMaybe<Scalars['String']>;
  unapprovedTs?: InputMaybe<Scalars['DateTime']>;
  unpausedTs?: InputMaybe<Scalars['DateTime']>;
  updatedBy?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['String']>;
  website?: InputMaybe<Scalars['String']>;
  whyYardzenLovesSummary?: InputMaybe<Scalars['String']>;
  yearsInBusiness?: InputMaybe<Scalars['Int']>;
  yelpUrl?: InputMaybe<Scalars['String']>;
};

export type CreateContractorReviewInput = {
  author: Scalars['String'];
  contractorId: Scalars['String'];
  reviewedTs: Scalars['DateTime'];
  source: ContractorReviewSource;
  summary: Scalars['String'];
};

export type CreateConversationInput = {
  archivedTs?: InputMaybe<Scalars['DateTime']>;
  conversationParticipants: Array<ParticipantInput>;
  name: Scalars['String'];
  sortByTimestamp?: InputMaybe<Scalars['DateTime']>;
  totalConversationCount?: InputMaybe<Scalars['Float']>;
};

export type CreateCurrentUserTermsOfServiceInput = {
  dateOfAgree: Scalars['DateTime'];
  tosAgreed: Scalars['Boolean'];
  userId: Scalars['String'];
};

export type CreateEstimateInput = {
  buildProjectId: Scalars['String'];
  clonedFromEstimateId?: InputMaybe<Scalars['String']>;
  contractorDeposit?: InputMaybe<Scalars['Int']>;
  contractorId: Scalars['String'];
  evaluationNotes?: InputMaybe<Scalars['String']>;
  expectedEndDate?: InputMaybe<Scalars['DateTime']>;
  expectedStartDate?: InputMaybe<Scalars['DateTime']>;
  platformFee?: InputMaybe<Scalars['Int']>;
  proEstimateNumber?: InputMaybe<Scalars['String']>;
  proTermDetails?: InputMaybe<Scalars['String']>;
  sentToClient: Scalars['Boolean'];
  sentToClientBy?: InputMaybe<Scalars['String']>;
  sentToClientTs?: InputMaybe<Scalars['DateTime']>;
  version: Scalars['Int'];
};

export type CreateEstimatePaymentLineItemInput = {
  estimateId: Scalars['String'];
  name: Scalars['String'];
  paymentDue: Scalars['String'];
  totalAmountDue: Scalars['Int'];
};

export type CreateEstimateWorkLineItemInput = {
  clientFeedbackNotes?: InputMaybe<Scalars['String']>;
  clientFeedbackTs?: InputMaybe<Scalars['DateTime']>;
  clonedFromEstimateWorkLineItemId?: InputMaybe<Scalars['String']>;
  description: Scalars['String'];
  estimateId: Scalars['String'];
  name: Scalars['String'];
  tags: Array<Scalars['String']>;
  totalCost: Scalars['Int'];
};

export type CreateInvoiceInput = {
  accountId: Scalars['String'];
  applicationFeeAmount?: InputMaybe<Scalars['Int']>;
  clientNotes?: InputMaybe<Scalars['String']>;
  connectedAccountId?: InputMaybe<Scalars['String']>;
  contractorId?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  estimateId?: InputMaybe<Scalars['String']>;
  internalNotes?: InputMaybe<Scalars['String']>;
  lastPaymentAttemptedTs?: InputMaybe<Scalars['DateTime']>;
  lineItems: Array<NestedCreateInvoiceLineItemInput>;
  name?: InputMaybe<Scalars['String']>;
  paid: Scalars['Boolean'];
  paymentDueTs?: InputMaybe<Scalars['DateTime']>;
  paymentMilestone?: InputMaybe<InvoicePaymentMilestone>;
  proInvoiceReference?: InputMaybe<Scalars['String']>;
  product?: InputMaybe<Scalars['String']>;
  receiptEmail?: InputMaybe<Scalars['String']>;
  sendGhostMessage?: InputMaybe<Scalars['Boolean']>;
  totalAmount: Scalars['Int'];
  yzFeeRate?: InputMaybe<Scalars['String']>;
};

export type CreateLoginHistoryInput = {
  contractorId?: InputMaybe<Scalars['String']>;
  ipAddress?: InputMaybe<Scalars['String']>;
  userAgent?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['String']>;
};

export type CreateMatchInput = {
  buildProjectId: Scalars['String'];
  contractorId: Scalars['String'];
  pipefyDtbCardId?: InputMaybe<Scalars['String']>;
  rank: Scalars['Int'];
  totalContractValue?: InputMaybe<Scalars['Int']>;
  userId: Scalars['String'];
};

export type CreatePipefyAttachmentUrlInput = {
  fileName: Scalars['String'];
};

export type CreatePipefyCardInput = {
  buildProjectId: Scalars['String'];
  contractorId: Scalars['String'];
  overrideIsTestAccount: Scalars['Boolean'];
  userEmail: Scalars['String'];
  userId: Scalars['String'];
};

export type CreatePipefyFormSubmissionInput = {
  phaseId: Scalars['String'];
  phaseName: Scalars['String'];
  pipefyCardId: Scalars['String'];
  questionsAndResponses: Scalars['String'];
};

export type CreateRevisionInput = {
  contractorId?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  shareMediaLink?: InputMaybe<Scalars['String']>;
};

export type CreateStyleProfileInput = {
  userId?: InputMaybe<Scalars['String']>;
};

export type CreateStyleProfileLikeImageInput = {
  galleryImageId?: InputMaybe<Scalars['String']>;
  galleryImageIds?: InputMaybe<Array<Scalars['String']>>;
  styleProfileId?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['String']>;
};

export type CreateSurveyInput = {
  surveyDesc: Scalars['String'];
  surveyKey: Scalars['String'];
  version: Scalars['Float'];
};

export type CreateSurveyQuestionInput = {
  format: Scalars['String'];
  index: Scalars['Float'];
  questionKey: Scalars['String'];
  required: Scalars['Boolean'];
  section: Scalars['Float'];
  surveyId: Scalars['String'];
  text: Scalars['String'];
};

export type CreateSurveyResponseInput = {
  buildProjectId: Scalars['String'];
  completed: Scalars['Boolean'];
  surveyId: Scalars['String'];
  userId: Scalars['String'];
};

export type CreateUserInput = {
  accountId: Scalars['String'];
  userId: Scalars['String'];
};

export type CreateUserProfileInput = {
  email?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  leadZipcode?: InputMaybe<Scalars['String']>;
  mailingAddress?: InputMaybe<CreateAddressInput>;
  optIn?: InputMaybe<Scalars['Boolean']>;
  phone?: InputMaybe<Scalars['String']>;
  segmentId?: InputMaybe<Scalars['String']>;
  testAccount?: InputMaybe<Scalars['Boolean']>;
  userId: Scalars['String'];
};

export type CreateUserTermsOfServiceInput = {
  dateOfAgree: Scalars['DateTime'];
  tosAgreed: Scalars['Boolean'];
  typeOfTos: Scalars['String'];
  userId: Scalars['String'];
};

export type DateFilter = {
  equals?: InputMaybe<Scalars['DateTime']>;
  gt?: InputMaybe<Scalars['DateTime']>;
  gte?: InputMaybe<Scalars['DateTime']>;
  in?: InputMaybe<Scalars['DateTime']>;
  lt?: InputMaybe<Scalars['DateTime']>;
  lte?: InputMaybe<Scalars['DateTime']>;
  not?: InputMaybe<Scalars['DateTime']>;
  notIn?: InputMaybe<Scalars['DateTime']>;
};

export type DeleteContractorInput = {
  id: Scalars['String'];
};

export type DesignAssignment = {
  __typename?: 'DesignAssignment';
  designPackage: Scalars['String'];
  info: Scalars['String'];
  status: Scalars['String'];
};

export enum DesignPackage {
  CurbAppeal = 'CURB_APPEAL',
  EntireYardStarter = 'ENTIRE_YARD_STARTER',
  FrontOrBackYardStarter = 'FRONT_OR_BACK_YARD_STARTER',
  FrontYard = 'FRONT_YARD',
  FullYard = 'FULL_YARD',
  PartialYard = 'PARTIAL_YARD',
  SmallSpace = 'SMALL_SPACE',
  WholeHome = 'WHOLE_HOME'
}

export type EnsureAccountSetupInput = {
  accountId?: InputMaybe<Scalars['String']>;
  createUserProfileInput?: InputMaybe<CreateUserProfileInput>;
  userId: Scalars['String'];
};

export type EnsureAccountSetupResponse = {
  __typename?: 'EnsureAccountSetupResponse';
  accountId: Scalars['String'];
  userId: Scalars['String'];
};

export type Estimate = {
  __typename?: 'Estimate';
  buildProject: BuildProject;
  buildProjectId: Scalars['String'];
  clonedFromEstimateId?: Maybe<Scalars['String']>;
  contractorDeposit?: Maybe<Scalars['Int']>;
  contractorId: Scalars['String'];
  contractorProfile: ContractorProfile;
  conversation?: Maybe<Conversation>;
  createdTs: Scalars['DateTime'];
  estimateBidFiles: Array<Media>;
  evaluationNotes?: Maybe<Scalars['String']>;
  expectedEndDate?: Maybe<Scalars['DateTime']>;
  expectedStartDate?: Maybe<Scalars['DateTime']>;
  id: Scalars['String'];
  paymentLineItems: Array<EstimatePaymentLineItem>;
  platformFee?: Maybe<Scalars['Int']>;
  proEstimateNumber?: Maybe<Scalars['String']>;
  proTermDetails?: Maybe<Scalars['String']>;
  proTermDocuments?: Maybe<Array<Media>>;
  sentToClient: Scalars['Boolean'];
  sentToClientBy?: Maybe<Scalars['String']>;
  sentToClientTs?: Maybe<Scalars['DateTime']>;
  updatedTs: Scalars['DateTime'];
  version: Scalars['Int'];
  workLineItems: Array<EstimateWorkLineItem>;
};


export type EstimatePaymentLineItemsArgs = {
  pagination?: InputMaybe<FindAllEstimatePaymentLineItemsPaginator>;
};


export type EstimateWorkLineItemsArgs = {
  pagination?: InputMaybe<FindAllEstimateWorkLineItemsPaginator>;
};

export type EstimatePaymentLineItem = {
  __typename?: 'EstimatePaymentLineItem';
  createdTs: Scalars['DateTime'];
  estimateId: Scalars['String'];
  id: Scalars['String'];
  name: Scalars['String'];
  paymentDue: Scalars['String'];
  totalAmountDue: Scalars['Int'];
  updatedTs: Scalars['DateTime'];
};

export enum EstimatePaymentLineItemsPaginatorSortByEnum {
  CreatedTs = 'CREATED_TS',
  TotalCost = 'TOTAL_COST',
  UpdatedTs = 'UPDATED_TS'
}

export type EstimateWorkLineItem = {
  __typename?: 'EstimateWorkLineItem';
  clientFeedbackNotes?: Maybe<Scalars['String']>;
  clientFeedbackTs?: Maybe<Scalars['DateTime']>;
  clonedFromEstimateWorkLineItemId?: Maybe<Scalars['String']>;
  createdTs: Scalars['DateTime'];
  description: Scalars['String'];
  estimateId: Scalars['String'];
  id: Scalars['String'];
  name: Scalars['String'];
  tags: Array<Scalars['String']>;
  totalCost: Scalars['Int'];
  updatedTs: Scalars['DateTime'];
};

export enum EstimateWorkLineItemsPaginatorSortByEnum {
  CreatedTs = 'CREATED_TS',
  TotalCost = 'TOTAL_COST',
  UpdatedTs = 'UPDATED_TS'
}

export enum EstimatesPaginatorSortByEnum {
  CreatedTs = 'CREATED_TS',
  UpdatedTs = 'UPDATED_TS'
}

export type FetchAdminConversationsInput = {
  userProfileId: Scalars['String'];
};

export type FieldCondition = {
  __typename?: 'FieldCondition';
  expressions: Array<FieldConditionExpression>;
};

export type FieldConditionAction = {
  __typename?: 'FieldConditionAction';
  actionId: Scalars['String'];
  phaseField?: Maybe<PhaseField>;
  whenEvaluator: Scalars['Boolean'];
};

export type FieldConditionExpression = {
  __typename?: 'FieldConditionExpression';
  field_address: Scalars['String'];
  operation: Scalars['String'];
  value: Scalars['String'];
};

export type FindAllAddressesInput = {
  addressLine1?: InputMaybe<StringFilter>;
  addressLine2?: InputMaybe<StringFilter>;
  businessName?: InputMaybe<StringFilter>;
  city?: InputMaybe<StringFilter>;
  createdTs?: InputMaybe<DateFilter>;
  latitude?: InputMaybe<FloatFilter>;
  longitude?: InputMaybe<FloatFilter>;
  pagination?: InputMaybe<AddressPaginator>;
  state?: InputMaybe<StringFilter>;
  updatedTs?: InputMaybe<DateFilter>;
  zipcode?: InputMaybe<StringFilter>;
};

export type FindAllBuildProjectsInput = {
  accountId: Scalars['String'];
  pagination?: InputMaybe<BuildProjectPaginator>;
};

export type FindAllBuildRegionInput = {
  accountManagerId?: InputMaybe<Scalars['String']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  contractorId?: InputMaybe<Scalars['String']>;
  /**
   *
   *     The geographical coordinates of the build region ordered [longitude, latitude].
   *
   */
  coordinates?: InputMaybe<Array<Scalars['Float']>>;
  isDefault?: InputMaybe<Scalars['Boolean']>;
};

export type FindAllContractorReviewsInput = {
  author?: InputMaybe<Scalars['String']>;
  contractorId?: InputMaybe<Scalars['String']>;
};

export type FindAllContractorsInput = {
  acceptingWork?: InputMaybe<Scalars['Boolean']>;
  approved?: InputMaybe<Scalars['Boolean']>;
  businessName?: InputMaybe<Scalars['String']>;
  ids?: InputMaybe<Array<Scalars['String']>>;
  limit?: InputMaybe<Scalars['Float']>;
  order?: InputMaybe<SortOrder>;
  orderBy?: InputMaybe<OrderBy>;
  paused?: InputMaybe<Scalars['Boolean']>;
  startAfterId?: InputMaybe<Scalars['String']>;
  startAfterValue?: InputMaybe<Scalars['String']>;
};

export type FindAllConversationParticipantsInput = {
  contractorId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  role?: InputMaybe<ConversationRole>;
  userProfileId?: InputMaybe<Scalars['String']>;
};

export type FindAllConversationsInput = {
  accountManagerId?: InputMaybe<Scalars['String']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  contractorId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  paginator?: InputMaybe<FindConversationsPaginator>;
  readMessagesSearchTerm?: InputMaybe<Scalars['String']>;
  role?: InputMaybe<ConversationRole>;
  searchTerm?: InputMaybe<Scalars['String']>;
  unreadOnly?: InputMaybe<Scalars['Boolean']>;
  userProfileId?: InputMaybe<Scalars['String']>;
};

export type FindAllEstimatePaymentLineItemsInput = {
  estimateId?: InputMaybe<Scalars['String']>;
  pagination?: InputMaybe<FindAllEstimatePaymentLineItemsPaginator>;
};

export type FindAllEstimatePaymentLineItemsPaginator = {
  cursor?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Float']>;
  sortBy?: InputMaybe<EstimatePaymentLineItemsPaginatorSortByEnum>;
  sortDirection?: InputMaybe<SortDirection>;
};

export type FindAllEstimateWorkLineItemsInput = {
  estimateId?: InputMaybe<Scalars['String']>;
  pagination?: InputMaybe<FindAllEstimateWorkLineItemsPaginator>;
};

export type FindAllEstimateWorkLineItemsPaginator = {
  cursor?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Float']>;
  sortBy?: InputMaybe<EstimateWorkLineItemsPaginatorSortByEnum>;
  sortDirection?: InputMaybe<SortDirection>;
};

export type FindAllEstimatesInput = {
  buildProjectId?: InputMaybe<Scalars['String']>;
  clientSearchTerm?: InputMaybe<Scalars['String']>;
  contractorId?: InputMaybe<Scalars['String']>;
  paginator?: InputMaybe<FindAllEstimatesPaginator>;
  userId?: InputMaybe<Scalars['String']>;
};

export type FindAllEstimatesPaginator = {
  cursor?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Float']>;
  sortBy?: InputMaybe<EstimatesPaginatorSortByEnum>;
  sortDirection?: InputMaybe<SortDirection>;
};

export type FindAllGalleryImageInput = {
  galleryFilters?: InputMaybe<GalleryFilter>;
  page?: InputMaybe<Scalars['Int']>;
  perPage?: InputMaybe<Scalars['Int']>;
  styleProfileIdFilter?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['String']>;
};

export type FindAllLoginHistoryInput = {
  contractorId?: InputMaybe<Scalars['String']>;
  ipAddress?: InputMaybe<Scalars['String']>;
  pagination?: InputMaybe<LoginHistoryPaginator>;
  userAgent?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['String']>;
};

export type FindAllMarketsInput = {
  displayName?: InputMaybe<Scalars['String']>;
  ids?: InputMaybe<Array<Scalars['String']>>;
  internalName?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Float']>;
  order?: InputMaybe<MarketOrder>;
  orderBy?: InputMaybe<MarketOrderBy>;
  startAfterId?: InputMaybe<Scalars['String']>;
  startAfterValue?: InputMaybe<Scalars['String']>;
  zipCode?: InputMaybe<Scalars['String']>;
};

export type FindAllMatchesInput = {
  clientSearchTerm?: InputMaybe<Scalars['String']>;
  contractorId?: InputMaybe<Scalars['String']>;
  page: Scalars['Int'];
  perPage: Scalars['Int'];
  sortByField?: InputMaybe<Scalars['String']>;
  sortDirection?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['String']>;
};

export type FindAllMessagesInput = {
  author?: InputMaybe<Scalars['String']>;
  conversationId?: InputMaybe<Scalars['String']>;
};

export type FindAllPipefyFormSubmissionsInput = {
  phaseId?: InputMaybe<Scalars['String']>;
  pipefyCardId: Scalars['String'];
};

export type FindAllProjectElementsByCityInput = {
  city: Scalars['String'];
};

export type FindAllRevisionsInput = {
  contractorId: Scalars['String'];
  pagination?: InputMaybe<RevisionPagination>;
};

export type FindAllStyleProfileInput = {
  pagination?: InputMaybe<StyleProfilePaginator>;
  userId?: InputMaybe<Scalars['String']>;
  userIds?: InputMaybe<Array<Scalars['String']>>;
};

export type FindAllUserTermsOfServiceInput = {
  tosAgreed?: InputMaybe<Scalars['Boolean']>;
  typeOfTos?: InputMaybe<Scalars['String']>;
  userId: Scalars['String'];
};

export type FindAllUsersInput = {
  accountId: Scalars['String'];
  pagination?: InputMaybe<UsersPaginator>;
};

export type FindBuildProjectInput = {
  id: Scalars['String'];
  shareLinkId?: InputMaybe<Scalars['String']>;
};

export type FindByStyleProfileInput = {
  userId: Scalars['String'];
};

export type FindConversationsPaginator = {
  cursor?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Float']>;
  sortBy?: InputMaybe<ConversationsPaginatorSortByEnum>;
  sortDirection?: InputMaybe<SortDirection>;
};

export type FindInvoicesInput = {
  accountId?: InputMaybe<Scalars['String']>;
  contractorId?: InputMaybe<Scalars['String']>;
  /** Only used when contractorId is present. Returns invoices only for clients the contractor has an active match with */
  enforceContractorMatches?: InputMaybe<Scalars['Boolean']>;
  lastPaymentAttemptedTs?: InputMaybe<DateFilter>;
  paid?: InputMaybe<Scalars['Boolean']>;
  paymentMilestone?: InputMaybe<InvoicePaymentMilestone>;
  pendingPayback?: InputMaybe<Scalars['Boolean']>;
  userId?: InputMaybe<Scalars['String']>;
  voided?: InputMaybe<Scalars['Boolean']>;
};

export type FindMatchesInput = {
  accountId?: InputMaybe<Scalars['String']>;
  buildProjectId?: InputMaybe<Scalars['String']>;
  contractorId?: InputMaybe<Scalars['String']>;
  forceLegacyMatch?: InputMaybe<Scalars['Boolean']>;
  includeArchived?: InputMaybe<Scalars['Boolean']>;
  readCommitted?: InputMaybe<Scalars['Boolean']>;
  rematch?: InputMaybe<Scalars['Boolean']>;
};

export type FindOneAccountInput = {
  accountId: Scalars['String'];
};

export type FindOneBuildRegionInput = {
  id?: InputMaybe<Scalars['String']>;
  internalName?: InputMaybe<Scalars['String']>;
};

export type FindOneContractorInput = {
  id: Scalars['String'];
};

export type FindOneConversationInput = {
  id?: InputMaybe<Scalars['String']>;
  sid?: InputMaybe<Scalars['String']>;
};

export type FindOneGalleryImageInput = {
  airtableId?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['String']>;
};

export type FindOneUserProfileInput = {
  userId: Scalars['String'];
};

export type FindOneUserTermsOfServiceInput = {
  id: Scalars['String'];
};

export type FindProjectElementsInput = {
  buildProjectId?: InputMaybe<Scalars['String']>;
};

export type FindSurveyInput = {
  surveyKey: Scalars['String'];
};

export type FindSurveyResponseInput = {
  buildProjectId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  shareLinkId?: InputMaybe<Scalars['String']>;
  surveyId?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['String']>;
};

export type FloatFilter = {
  equals?: InputMaybe<Scalars['Float']>;
  gt?: InputMaybe<Scalars['Float']>;
  gte?: InputMaybe<Scalars['Float']>;
  in?: InputMaybe<Scalars['Float']>;
  lt?: InputMaybe<Scalars['Float']>;
  lte?: InputMaybe<Scalars['Float']>;
  not?: InputMaybe<Scalars['Float']>;
  notIn?: InputMaybe<Scalars['Float']>;
};

export type GalleryFilter = {
  amenities?: InputMaybe<Array<Scalars['String']>>;
  region?: InputMaybe<Array<Scalars['String']>>;
  styles?: InputMaybe<Array<Scalars['String']>>;
  yardAttributes?: InputMaybe<Array<Scalars['String']>>;
};

export type GalleryImage = {
  __typename?: 'GalleryImage';
  airtableId: Scalars['Float'];
  amenities?: Maybe<Array<Scalars['String']>>;
  city: Scalars['String'];
  designPackage: Scalars['String'];
  id: Scalars['String'];
  state: Scalars['String'];
  styles?: Maybe<Array<Scalars['String']>>;
  url: Scalars['String'];
};

export type GetLatestConversationMessageInput = {
  contractorId?: InputMaybe<Scalars['String']>;
  conversationIds: Array<Scalars['String']>;
  userId?: InputMaybe<Scalars['String']>;
};

export type GetNextRenderFeedbackSetInput = {
  designPackages?: InputMaybe<Array<DesignPackage>>;
  elements?: InputMaybe<Array<YardElement>>;
  featured?: InputMaybe<Scalars['Boolean']>;
  liked?: InputMaybe<Scalars['Boolean']>;
  likedFrom?: InputMaybe<Scalars['String']>;
  page: Scalars['Float'];
  regions?: InputMaybe<Array<Region>>;
  segmentId: Scalars['String'];
  styles?: InputMaybe<Array<Style>>;
  yardLocation?: InputMaybe<Array<YardDesignLocation>>;
  zip?: InputMaybe<Scalars['String']>;
};

export type GetProjectBriefMediaInput = {
  revisionId: Scalars['String'];
  shareLinkId?: InputMaybe<Scalars['String']>;
  userId: Scalars['String'];
};

export type GetShareLinkId = {
  __typename?: 'GetShareLinkId';
  shareLinkId: Scalars['String'];
};

export type GetUnreadMessagesInput = {
  contractorId?: InputMaybe<Scalars['String']>;
  userProfileId?: InputMaybe<Scalars['String']>;
};

export type InitPaymentDto = {
  invoiceId: Scalars['String'];
};

export type InputCoordinates = {
  lat: Scalars['Float'];
  lng: Scalars['Float'];
};

export type Invoice = {
  __typename?: 'Invoice';
  accountId: Scalars['String'];
  applicationFeeAmount?: Maybe<Scalars['Int']>;
  clientNotes?: Maybe<Scalars['String']>;
  connectedAccountId?: Maybe<Scalars['String']>;
  contractorId?: Maybe<Scalars['String']>;
  contractorProfile?: Maybe<ContractorProfile>;
  conversationId?: Maybe<Scalars['String']>;
  createdBy?: Maybe<Scalars['String']>;
  createdByUser?: Maybe<UserProfile>;
  createdByYzAdmin?: Maybe<Scalars['Boolean']>;
  createdTs: Scalars['DateTime'];
  description?: Maybe<Scalars['String']>;
  estimate?: Maybe<Estimate>;
  estimateId?: Maybe<Scalars['String']>;
  estimateInvoiceNumber?: Maybe<Scalars['Int']>;
  id: Scalars['String'];
  incrementalInvoiceNumber?: Maybe<Scalars['Int']>;
  internalNotes?: Maybe<Scalars['String']>;
  isRefunded: Scalars['Boolean'];
  lastPaymentAttemptedTs?: Maybe<Scalars['DateTime']>;
  lineItems: Array<InvoiceLineItem>;
  name: Scalars['String'];
  paid: Scalars['Boolean'];
  paybackTransfers?: Maybe<Array<InvoicePaybackTransfer>>;
  paymentDueTs?: Maybe<Scalars['DateTime']>;
  paymentIntents?: Maybe<Array<PaymentIntent>>;
  paymentMilestone?: Maybe<InvoicePaymentMilestone>;
  paymentType?: Maybe<Scalars['String']>;
  proInvoiceReference?: Maybe<Scalars['String']>;
  product?: Maybe<Scalars['String']>;
  receiptEmail?: Maybe<Scalars['String']>;
  refundDate?: Maybe<Scalars['DateTime']>;
  stripeFee?: Maybe<Scalars['Float']>;
  stripeStatus?: Maybe<Scalars['String']>;
  totalAmount: Scalars['Int'];
  updatedBy?: Maybe<Scalars['String']>;
  updatedTs: Scalars['DateTime'];
  userProfiles?: Maybe<Array<UserProfile>>;
  voidedBy?: Maybe<Scalars['String']>;
  voidedTs?: Maybe<Scalars['DateTime']>;
  yzFeeRate?: Maybe<Scalars['String']>;
};

export type InvoiceLineItem = {
  __typename?: 'InvoiceLineItem';
  createdTs: Scalars['DateTime'];
  description: Scalars['String'];
  id: Scalars['String'];
  invoiceId: Scalars['String'];
  name: Scalars['String'];
  quantity: Scalars['Int'];
  unitAmount: Scalars['Int'];
  updatedTs: Scalars['DateTime'];
};

export type InvoicePaybackTransfer = {
  __typename?: 'InvoicePaybackTransfer';
  amount: Scalars['Float'];
  createdTs: Scalars['DateTime'];
  invoiceId: Scalars['String'];
  paid: Scalars['Boolean'];
  stripeChargeId: Scalars['String'];
  stripePaymentId: Scalars['String'];
  stripeTransferId: Scalars['String'];
};

export enum InvoicePaymentMilestone {
  AdditionalProgressPayment = 'ADDITIONAL_PROGRESS_PAYMENT',
  ChangeOrder = 'CHANGE_ORDER',
  Deposit = 'DEPOSIT',
  FinalPayment = 'FINAL_PAYMENT',
  FirstProgressPayment = 'FIRST_PROGRESS_PAYMENT',
  ProjectDeposit = 'PROJECT_DEPOSIT'
}

export type IsUnreadForCurrentParticipantInput = {
  contractorId?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['String']>;
};

export type LatestRevision = {
  __typename?: 'LatestRevision';
  revisionId?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
};

export type LikeGalleryImageInput = {
  galleryImageId: Scalars['String'];
  like: Scalars['Boolean'];
  styleProfileId: Scalars['String'];
};

export type LoginHistory = {
  __typename?: 'LoginHistory';
  contractorId?: Maybe<Scalars['String']>;
  createdTs: Scalars['String'];
  id: Scalars['String'];
  ipAddress?: Maybe<Scalars['String']>;
  userAgent?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
};

export type LoginHistoryPaginator = {
  cursor?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Float']>;
  sortBy?: InputMaybe<LoginHistorySortByEnum>;
  sortDirection?: InputMaybe<SortDirection>;
};

export enum LoginHistorySortByEnum {
  CreatedTs = 'CREATED_TS'
}

export type Market = {
  __typename?: 'Market';
  avgContractAmount18moUsd: Scalars['Float'];
  contractSigned18moQty: Scalars['Float'];
  createdAt: Scalars['DateTime'];
  createdBy: Scalars['String'];
  displayName: Scalars['String'];
  engaged18moQty: Scalars['Float'];
  id: Scalars['String'];
  internalName: Scalars['String'];
  introductionMade18moQty: Scalars['Float'];
  marketEngaged18moCloseRate: Scalars['Float'];
  marketIntroduction18moCloseRate: Scalars['Float'];
  project18moQty: Scalars['Float'];
  tier: Scalars['String'];
  updatedAt: Scalars['DateTime'];
  zipCodes?: Maybe<Array<Scalars['String']>>;
};

export enum MarketOrder {
  Asc = 'ASC',
  Desc = 'DESC'
}

export enum MarketOrderBy {
  CreatedAt = 'CREATED_AT',
  DisplayName = 'DISPLAY_NAME',
  InternalName = 'INTERNAL_NAME',
  UpdatedAt = 'UPDATED_AT'
}

export type Match = {
  __typename?: 'Match';
  buildProjectId: Scalars['String'];
  contractorId: Scalars['String'];
  contractorProfile: ContractorProfile;
  createdTs: Scalars['DateTime'];
  pipefyDtbCardId?: Maybe<Scalars['String']>;
  rank: Scalars['Int'];
  totalContractValue?: Maybe<Scalars['Int']>;
  updatedTs: Scalars['DateTime'];
  userProfile?: Maybe<UserProfileEnhanced>;
};

export type Media = {
  __typename?: 'Media';
  bucketName: Scalars['String'];
  buildProjectId?: Maybe<Scalars['String']>;
  contractorId?: Maybe<Scalars['String']>;
  createdTs: Scalars['DateTime'];
  designProjectId?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  messageId?: Maybe<Scalars['String']>;
  mimeType: Scalars['String'];
  notes?: Maybe<Scalars['String']>;
  objectName: Scalars['String'];
  order?: Maybe<Scalars['Float']>;
  revisionId: Scalars['String'];
  source?: Maybe<MediaSource>;
  tags?: Maybe<Array<MediaTag>>;
  uploadConfirmed: Scalars['Boolean'];
  uploaderId?: Maybe<Scalars['String']>;
  uri?: Maybe<Scalars['String']>;
};

export type MediaMessage = {
  __typename?: 'MediaMessage';
  id: Scalars['String'];
  mimeType: Scalars['String'];
};

export type MediaPagination = {
  cursor?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Float']>;
  sortBy?: InputMaybe<MediaSortByEnum>;
  sortDirection?: InputMaybe<SortDirection>;
};

export type MediaPangaea = {
  __typename?: 'MediaPangaea';
  downloadUrl: Scalars['String'];
  fileType: Scalars['String'];
  id: Scalars['String'];
  isClientVisible?: Maybe<Scalars['Boolean']>;
  isDesignerVisible?: Maybe<Scalars['Boolean']>;
  originalFileName?: Maybe<Scalars['String']>;
  path?: Maybe<Scalars['String']>;
  revisionId?: Maybe<Scalars['String']>;
  tag?: Maybe<Scalars['String']>;
  uploadedAt: Scalars['String'];
  userId?: Maybe<Scalars['String']>;
  variant?: Maybe<Scalars['String']>;
};

export enum MediaSortByEnum {
  CreatedAt = 'CREATED_AT',
  Ordering = 'ORDERING'
}

export enum MediaSource {
  Messages = 'MESSAGES',
  NonYz = 'NON_YZ',
  Onboarding = 'ONBOARDING',
  Unknown = 'UNKNOWN',
  Yz = 'YZ'
}

export enum MediaTag {
  BackYardChattyVideo = 'BACK_YARD_CHATTY_VIDEO',
  BackYardHorizontal = 'BACK_YARD_HORIZONTAL',
  BackYardKeep = 'BACK_YARD_KEEP',
  BackYardRemove = 'BACK_YARD_REMOVE',
  BackYardSlope = 'BACK_YARD_SLOPE',
  BackYardSlowPanVideo = 'BACK_YARD_SLOW_PAN_VIDEO',
  DesignInspiration = 'DESIGN_INSPIRATION',
  ExteriorInspiration = 'EXTERIOR_INSPIRATION',
  FrontYardChattyVideo = 'FRONT_YARD_CHATTY_VIDEO',
  FrontYardHorizontal = 'FRONT_YARD_HORIZONTAL',
  FrontYardKeep = 'FRONT_YARD_KEEP',
  FrontYardRemove = 'FRONT_YARD_REMOVE',
  FrontYardSlope = 'FRONT_YARD_SLOPE',
  FrontYardSlowPanVideo = 'FRONT_YARD_SLOW_PAN_VIDEO',
  Headshot = 'HEADSHOT',
  LeftSideYardChattyVideo = 'LEFT_SIDE_YARD_CHATTY_VIDEO',
  LeftSideYardHorizontal = 'LEFT_SIDE_YARD_HORIZONTAL',
  LeftSideYardKeep = 'LEFT_SIDE_YARD_KEEP',
  LeftSideYardRemove = 'LEFT_SIDE_YARD_REMOVE',
  LeftSideYardSlope = 'LEFT_SIDE_YARD_SLOPE',
  LeftSideYardSlowPanVideo = 'LEFT_SIDE_YARD_SLOW_PAN_VIDEO',
  PlansAndDrawings = 'PLANS_AND_DRAWINGS',
  RightSideYardChattyVideo = 'RIGHT_SIDE_YARD_CHATTY_VIDEO',
  RightSideYardHorizontal = 'RIGHT_SIDE_YARD_HORIZONTAL',
  RightSideYardKeep = 'RIGHT_SIDE_YARD_KEEP',
  RightSideYardRemove = 'RIGHT_SIDE_YARD_REMOVE',
  RightSideYardSlope = 'RIGHT_SIDE_YARD_SLOPE',
  RightSideYardSlowPanVideo = 'RIGHT_SIDE_YARD_SLOW_PAN_VIDEO',
  Thumbnail = 'THUMBNAIL'
}

export type Message = {
  __typename?: 'Message';
  author?: Maybe<Scalars['String']>;
  body: Scalars['String'];
  conversationId: Scalars['String'];
  createdTs: Scalars['DateTime'];
  fromAccountManager?: Maybe<Scalars['String']>;
  fromAccountManagerName?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  isUnreadForCurrentParticipant: Scalars['Boolean'];
  media: Array<MediaMessage>;
  updatedTs?: Maybe<Scalars['DateTime']>;
};


export type MessageIsUnreadForCurrentParticipantArgs = {
  input: IsUnreadForCurrentParticipantInput;
};

export type Mutation = {
  __typename?: 'Mutation';
  addContractorDocument?: Maybe<Scalars['String']>;
  addContractorMedia: Scalars['String'];
  applyMatchingAlgorithm: Array<Match>;
  assignAccountManager: BuildProject;
  clearContractorReviews: Scalars['Float'];
  createAccount: Account;
  createAccountManager: AccountManager;
  createActionAcknowledgement: ActionAcknowledgement;
  createAddress: Address;
  createApiKey: Scalars['String'];
  createBuildProject: BuildProject;
  createBuildRegion: BuildRegion;
  createBuildStudioUser?: Maybe<Scalars['String']>;
  createBuildStudioUserFromFirestoreData?: Maybe<Scalars['String']>;
  createContractor: Contractor;
  createContractorProfile: ContractorProfile;
  createContractorReview: ContractorReview;
  createConversation: Conversation;
  createCurrentUserTermsOfService: UserTermsOfService;
  createEstimate: Estimate;
  createEstimatePaymentLineItem: EstimatePaymentLineItem;
  createEstimateWorkLineItem: EstimateWorkLineItem;
  createInvoice: Invoice;
  createLoginHistory: LoginHistory;
  createMatch: Match;
  createPhaseFormLink: Scalars['String'];
  createPipefyCards?: Maybe<UpdatePipefyCardResponse>;
  createPipefyFormSubmission: PipefyFormSubmissionRecord;
  createPipefyWebhooks: Scalars['String'];
  createRevision: Revision;
  createStyleProfile: StyleProfile;
  createStyleProfileLikeGalleryImage: Array<GalleryImage>;
  createSurvey: Survey;
  createSurveyQuestion: Survey;
  createSurveyResponse: SurveyResponse;
  createTag: Scalars['String'];
  createUser: User;
  createUserProfile: UserProfile;
  createUserTermsOfService: UserTermsOfService;
  deleteContractorReview: ContractorReview;
  deleteEstimateBidFile: Estimate;
  ensureAccountSetup: EnsureAccountSetupResponse;
  getPresignedUrl: PresignedUrlResponse;
  getShareLink: GetShareLinkId;
  likeOrUnlikeImage: StatusObject;
  removeAccountManager: AccountManager;
  removeBuildProject: BuildProject;
  removeBuildRegion: StatusObject;
  removeContractor: Contractor;
  removeContractorContact: Scalars['Boolean'];
  removeContractorProfile: ContractorProfile;
  removeEstimate: Estimate;
  removeEstimatePaymentLineItem: EstimatePaymentLineItem;
  removeEstimateWorkLineItem: EstimateWorkLineItem;
  removeMedia: Scalars['String'];
  removeRevision: Revision;
  removeTag: Scalars['String'];
  removeUserTermsOfService: UserTermsOfService;
  sendFeedbackSubmittedNotificationToSlack?: Maybe<Scalars['Boolean']>;
  sendGhostMessageFormSubmission: Message;
  sendOnboardingSurveyNotificationToSlack?: Maybe<Scalars['Boolean']>;
  sendPasswordResetEmail: Scalars['String'];
  setContractorProfileHeadshot: Scalars['String'];
  setContractorProfileThumbnail: Scalars['String'];
  setContractorProfileVideo: Scalars['String'];
  setContractorUserClaims: Scalars['String'];
  signUpAndSendMessageSubmission: Message;
  smsEvent: Scalars['String'];
  startInitialYardzenConversation?: Maybe<Conversation>;
  startLeadConvertedConversations?: Maybe<Array<Maybe<Conversation>>>;
  startPayment: PaymentRequest;
  submitEstimate: Estimate;
  submitRenderFeedback: RenderFeedback;
  submitRenderFeedbackSet: Array<RenderFeedback>;
  syncUserToCordial: SyncUserToCordialResponse;
  triggerScheduledMessages: Scalars['String'];
  updateAccount: Account;
  updateAccountManager: AccountManager;
  updateAddress: Address;
  updateBuildProject: BuildProject;
  updateBuildRegion: StatusObject;
  updateContractor: Contractor;
  updateContractorContact: ContractorContact;
  updateContractorDocument: Scalars['String'];
  updateContractorProfile: ContractorProfile;
  updateContractorReview: ContractorReview;
  updateConversation: Conversation;
  updateCustomClaims: Scalars['String'];
  updateEstimate: Estimate;
  updateEstimatePaymentLineItem: EstimatePaymentLineItem;
  updateEstimateWorkLineItem: EstimateWorkLineItem;
  updateGalleryImage: GalleryImage;
  updateInvoice?: Maybe<Invoice>;
  updateMediaOrdering: Scalars['String'];
  updatePipefyProjectCardOnPhaseFormSubmitted: UpdatePipefyCardResponse;
  updateProfile: StatusObject;
  updateRevision: Revision;
  updateStyleProfile: StyleProfile;
  updateTotalContractValue: StatusObject;
  updateUser: User;
  updateUserEmail: Scalars['String'];
  updateUserProfile: UserProfile;
  updateUserProjectElementsBatch: StatusObject;
  updateUserTermsOfService: UserTermsOfService;
  uploadMediaMessage: WriteableMedia;
  upsertSurveyQuestionResponses: Array<SurveyQuestionResponse>;
};


export type MutationAddContractorDocumentArgs = {
  input: CreateContractorDocumentInput;
};


export type MutationAddContractorMediaArgs = {
  input: CreateContractorMediaInput;
};


export type MutationApplyMatchingAlgorithmArgs = {
  input: FindMatchesInput;
};


export type MutationAssignAccountManagerArgs = {
  input: AssignAccountManagerInput;
};


export type MutationClearContractorReviewsArgs = {
  contractorId: Scalars['String'];
};


export type MutationCreateAccountArgs = {
  input: CreateAccountInput;
};


export type MutationCreateAccountManagerArgs = {
  input: CreateAccountManagerInput;
};


export type MutationCreateActionAcknowledgementArgs = {
  input: CreateActionAcknowledgementInput;
};


export type MutationCreateAddressArgs = {
  input: CreateAddressInput;
};


export type MutationCreateBuildProjectArgs = {
  input: CreateBuildProjectInput;
};


export type MutationCreateBuildRegionArgs = {
  createBuildRegionInput: CreateBuildRegionInput;
};


export type MutationCreateBuildStudioUserArgs = {
  input: CreateBuildStudioUserInput;
};


export type MutationCreateBuildStudioUserFromFirestoreDataArgs = {
  userId: Scalars['String'];
};


export type MutationCreateContractorArgs = {
  createProfile?: InputMaybe<Scalars['Boolean']>;
  input: CreateContractorInput;
};


export type MutationCreateContractorProfileArgs = {
  input: CreateContractorProfileInput;
};


export type MutationCreateContractorReviewArgs = {
  input: CreateContractorReviewInput;
};


export type MutationCreateConversationArgs = {
  input: CreateConversationInput;
};


export type MutationCreateCurrentUserTermsOfServiceArgs = {
  input: CreateCurrentUserTermsOfServiceInput;
};


export type MutationCreateEstimateArgs = {
  input: CreateEstimateInput;
};


export type MutationCreateEstimatePaymentLineItemArgs = {
  input: CreateEstimatePaymentLineItemInput;
};


export type MutationCreateEstimateWorkLineItemArgs = {
  input: CreateEstimateWorkLineItemInput;
};


export type MutationCreateInvoiceArgs = {
  input: CreateInvoiceInput;
};


export type MutationCreateLoginHistoryArgs = {
  input: CreateLoginHistoryInput;
};


export type MutationCreateMatchArgs = {
  input: CreateMatchInput;
};


export type MutationCreatePhaseFormLinkArgs = {
  input: PipefyPhaseFormLinkInput;
};


export type MutationCreatePipefyCardsArgs = {
  input: CreatePipefyCardInput;
};


export type MutationCreatePipefyFormSubmissionArgs = {
  input: CreatePipefyFormSubmissionInput;
};


export type MutationCreateRevisionArgs = {
  createRevisionInput: CreateRevisionInput;
};


export type MutationCreateStyleProfileArgs = {
  input: CreateStyleProfileInput;
};


export type MutationCreateStyleProfileLikeGalleryImageArgs = {
  input: CreateStyleProfileLikeImageInput;
};


export type MutationCreateSurveyArgs = {
  input: CreateSurveyInput;
};


export type MutationCreateSurveyQuestionArgs = {
  input: CreateSurveyQuestionInput;
};


export type MutationCreateSurveyResponseArgs = {
  input: CreateSurveyResponseInput;
};


export type MutationCreateTagArgs = {
  name: Scalars['String'];
};


export type MutationCreateUserArgs = {
  input: CreateUserInput;
};


export type MutationCreateUserProfileArgs = {
  input: CreateUserProfileInput;
};


export type MutationCreateUserTermsOfServiceArgs = {
  input: CreateUserTermsOfServiceInput;
};


export type MutationDeleteContractorReviewArgs = {
  id: Scalars['String'];
};


export type MutationDeleteEstimateBidFileArgs = {
  estimateId: Scalars['String'];
  mediaId: Scalars['String'];
};


export type MutationEnsureAccountSetupArgs = {
  input: EnsureAccountSetupInput;
};


export type MutationGetPresignedUrlArgs = {
  input: CreatePipefyAttachmentUrlInput;
};


export type MutationGetShareLinkArgs = {
  input: GetProjectBriefMediaInput;
};


export type MutationLikeOrUnlikeImageArgs = {
  input: LikeGalleryImageInput;
};


export type MutationRemoveAccountManagerArgs = {
  id: Scalars['String'];
};


export type MutationRemoveBuildProjectArgs = {
  id: Scalars['String'];
};


export type MutationRemoveBuildRegionArgs = {
  id: Scalars['String'];
};


export type MutationRemoveContractorArgs = {
  input: DeleteContractorInput;
};


export type MutationRemoveContractorContactArgs = {
  id: Scalars['String'];
};


export type MutationRemoveContractorProfileArgs = {
  id: Scalars['String'];
};


export type MutationRemoveEstimateArgs = {
  id: Scalars['String'];
};


export type MutationRemoveEstimatePaymentLineItemArgs = {
  id: Scalars['String'];
};


export type MutationRemoveEstimateWorkLineItemArgs = {
  id: Scalars['String'];
};


export type MutationRemoveMediaArgs = {
  id: Scalars['String'];
};


export type MutationRemoveRevisionArgs = {
  id: Scalars['String'];
};


export type MutationRemoveTagArgs = {
  name: Scalars['String'];
};


export type MutationRemoveUserTermsOfServiceArgs = {
  id: Scalars['String'];
};


export type MutationSendFeedbackSubmittedNotificationToSlackArgs = {
  input: SendFeedbackSubmittedNotificationToSlackInput;
};


export type MutationSendGhostMessageFormSubmissionArgs = {
  input: SendGhostMessageFormSubmissionInput;
};


export type MutationSendOnboardingSurveyNotificationToSlackArgs = {
  input: SendOnboardingSurveyNotificationToSlackInput;
};


export type MutationSendPasswordResetEmailArgs = {
  input: SendPasswordResetEmailInput;
};


export type MutationSetContractorProfileHeadshotArgs = {
  contractorId: Scalars['String'];
  mimeType: Scalars['String'];
};


export type MutationSetContractorProfileThumbnailArgs = {
  contractorId: Scalars['String'];
  mimeType: Scalars['String'];
};


export type MutationSetContractorProfileVideoArgs = {
  contractorId: Scalars['String'];
  mimeType: Scalars['String'];
};


export type MutationSetContractorUserClaimsArgs = {
  input: SetContractorUserClaimsInput;
};


export type MutationSignUpAndSendMessageSubmissionArgs = {
  input: SignUpAndSendMessageSubmissionInput;
};


export type MutationSmsEventArgs = {
  event: SmsEventInput;
};


export type MutationStartInitialYardzenConversationArgs = {
  input: CreateConversationInput;
};


export type MutationStartLeadConvertedConversationsArgs = {
  input: StartLeadConversationsInput;
};


export type MutationStartPaymentArgs = {
  input: InitPaymentDto;
};


export type MutationSubmitEstimateArgs = {
  id: Scalars['String'];
};


export type MutationSubmitRenderFeedbackArgs = {
  input: RenderFeedbackInput;
};


export type MutationSubmitRenderFeedbackSetArgs = {
  input: RenderFeedbackSetInput;
};


export type MutationSyncUserToCordialArgs = {
  input: SyncUserToCordialInput;
};


export type MutationUpdateAccountArgs = {
  input: UpdateAccountInput;
};


export type MutationUpdateAccountManagerArgs = {
  input: UpdateAccountManagerInput;
};


export type MutationUpdateAddressArgs = {
  input: UpdateAddressInput;
};


export type MutationUpdateBuildProjectArgs = {
  input: UpdateBuildProjectInput;
};


export type MutationUpdateBuildRegionArgs = {
  updateBuildRegionInput: UpdateBuildRegionInput;
};


export type MutationUpdateContractorArgs = {
  input: UpdateContractorInput;
};


export type MutationUpdateContractorContactArgs = {
  updateContractorContactInput: UpdateContractorContactInput;
};


export type MutationUpdateContractorDocumentArgs = {
  input: UpdateContractorDocumentInput;
};


export type MutationUpdateContractorProfileArgs = {
  input: UpdateContractorProfileInput;
};


export type MutationUpdateContractorReviewArgs = {
  input: UpdateContractorReviewInput;
};


export type MutationUpdateConversationArgs = {
  input: UpdateConversationInput;
};


export type MutationUpdateCustomClaimsArgs = {
  userId: Scalars['String'];
};


export type MutationUpdateEstimateArgs = {
  input: UpdateEstimateInput;
};


export type MutationUpdateEstimatePaymentLineItemArgs = {
  input: UpdateEstimatePaymentLineItemInput;
};


export type MutationUpdateEstimateWorkLineItemArgs = {
  input: UpdateEstimateWorkLineItemInput;
};


export type MutationUpdateGalleryImageArgs = {
  input: UpdateGalleryImageInput;
};


export type MutationUpdateInvoiceArgs = {
  input: UpdateInvoiceInput;
};


export type MutationUpdateMediaOrderingArgs = {
  input: UpdateContractorMediaOrderInput;
};


export type MutationUpdatePipefyProjectCardOnPhaseFormSubmittedArgs = {
  input: PipefyCardFieldsUpdateInput;
};


export type MutationUpdateProfileArgs = {
  input: UpdateProfileInput;
};


export type MutationUpdateRevisionArgs = {
  updateRevisionInput: UpdateRevisionInput;
};


export type MutationUpdateStyleProfileArgs = {
  input: UpdateStyleProfileInput;
};


export type MutationUpdateTotalContractValueArgs = {
  input: UpdateTotalContractValueInput;
};


export type MutationUpdateUserArgs = {
  input: UpdateUserInput;
};


export type MutationUpdateUserEmailArgs = {
  input: UpdateUserEmailInput;
};


export type MutationUpdateUserProfileArgs = {
  input: UpdateUserProfileInput;
};


export type MutationUpdateUserProjectElementsBatchArgs = {
  input: UpdateUserProjectElementsBatchInput;
};


export type MutationUpdateUserTermsOfServiceArgs = {
  input: UpdateUserTermsOfServiceInput;
};


export type MutationUploadMediaMessageArgs = {
  input: UploadMediaMessageInput;
};


export type MutationUpsertSurveyQuestionResponsesArgs = {
  input: UpsertSurveyQuestionResponsesInput;
};

export type NestedCreateInvoiceLineItemInput = {
  description: Scalars['String'];
  name: Scalars['String'];
  quantity: Scalars['Int'];
  unitAmount: Scalars['Int'];
};

export enum OrderBy {
  BusinessName = 'BUSINESS_NAME',
  CreatedAt = 'CREATED_AT',
  UpdatedAt = 'UPDATED_AT'
}

export type ParticipantInput = {
  contractorId?: InputMaybe<Scalars['String']>;
  logoUrl?: InputMaybe<Scalars['String']>;
  role: ConversationRole;
  twilioId?: InputMaybe<Scalars['String']>;
  userProfileId?: InputMaybe<Scalars['String']>;
};

export type Payment = {
  __typename?: 'Payment';
  clientSecret: Scalars['String'];
  connectedAccountId?: Maybe<Scalars['String']>;
  hasFailed?: Maybe<Scalars['Boolean']>;
  paymentIntentId: Scalars['String'];
  paymentRequestId: Scalars['String'];
  status?: Maybe<Scalars['String']>;
};

export type PaymentIntent = {
  __typename?: 'PaymentIntent';
  amount: Scalars['Float'];
  amountCapturable: Scalars['Float'];
  amountReceived: Scalars['Float'];
  application?: Maybe<Scalars['String']>;
  applicationFeeAmount?: Maybe<Scalars['Float']>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationReason?: Maybe<Scalars['String']>;
  captureMethod: Scalars['String'];
  clientSecret: Scalars['String'];
  confirmationMethod: Scalars['String'];
  created: Scalars['Float'];
  currency: Scalars['String'];
  customer?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  invoiceId?: Maybe<Scalars['String']>;
  latestCharge?: Maybe<Scalars['String']>;
  livemode: Scalars['Boolean'];
  onBehalfOf?: Maybe<Scalars['String']>;
  paymentMethod?: Maybe<PaymentMethod>;
  paymentMethodId?: Maybe<Scalars['String']>;
  paymentMethodTypes: Array<Scalars['String']>;
  receiptEmail?: Maybe<Scalars['String']>;
  review?: Maybe<Scalars['String']>;
  setupFutureUsage?: Maybe<Scalars['String']>;
  source?: Maybe<Scalars['String']>;
  statementDescriptor?: Maybe<Scalars['String']>;
  statementDescriptorSuffix?: Maybe<Scalars['String']>;
  status: Scalars['String'];
  stripeCharge?: Maybe<StripeCharge>;
  transferGroup?: Maybe<Scalars['String']>;
};

export type PaymentMethod = {
  __typename?: 'PaymentMethod';
  card?: Maybe<Card>;
  type?: Maybe<Scalars['String']>;
};

export type PaymentMethodDetails = {
  __typename?: 'PaymentMethodDetails';
  card?: Maybe<Card>;
};

export type PaymentRequest = {
  __typename?: 'PaymentRequest';
  paid: Scalars['Boolean'];
  payment?: Maybe<Payment>;
};

export type PhaseField = {
  __typename?: 'PhaseField';
  custom_validation?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  editable?: Maybe<Scalars['Boolean']>;
  id: Scalars['String'];
  internal_id?: Maybe<Scalars['String']>;
  is_multiple?: Maybe<Scalars['Boolean']>;
  label?: Maybe<Scalars['String']>;
  options?: Maybe<Array<Scalars['String']>>;
  required?: Maybe<Scalars['Boolean']>;
  type?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

export type PhaseFieldCondition = {
  __typename?: 'PhaseFieldCondition';
  actions?: Maybe<Array<FieldConditionAction>>;
  condition?: Maybe<FieldCondition>;
  name: Scalars['String'];
  phase?: Maybe<CardPhase>;
};

export type Pipe = {
  __typename?: 'Pipe';
  fieldConditions?: Maybe<Array<PhaseFieldCondition>>;
  id: Scalars['String'];
  phases?: Maybe<Array<CardPhase>>;
};

export type PipefyCardFieldsUpdateInput = {
  cardId: Scalars['Int'];
  fields: Array<PipefyFieldValueInput>;
};

export type PipefyField = {
  __typename?: 'PipefyField';
  id: Scalars['String'];
};

export type PipefyFieldValueInput = {
  fieldId: Scalars['String'];
  fieldValue: Array<Scalars['String']>;
};

export type PipefyFormSubmissionRecord = {
  __typename?: 'PipefyFormSubmissionRecord';
  contractorId: Scalars['String'];
  createdTs: Scalars['DateTime'];
  id: Scalars['String'];
  phaseId: Scalars['String'];
  phaseName: Scalars['String'];
  pipefyCardId: Scalars['String'];
  questionsAndResponses: Scalars['String'];
  updatedTs: Scalars['DateTime'];
};

export type PipefyPhaseFormLinkInput = {
  cardId: Scalars['Float'];
};

export type PresignedUrlResponse = {
  __typename?: 'PresignedUrlResponse';
  url: Scalars['String'];
};

export type ProDesignCard = {
  __typename?: 'ProDesignCard';
  buildProject?: Maybe<BuildProject>;
  cardCreatedDataTeam?: Maybe<Scalars['DateTime']>;
  ccAuthPending?: Maybe<Array<Scalars['String']>>;
  ccAuthorizationCompleted?: Maybe<Array<Scalars['String']>>;
  clientCard?: Maybe<ClientCard>;
  clientNameStreet?: Maybe<Scalars['String']>;
  contractor?: Maybe<Array<Scalars['String']>>;
  contractorCompany?: Maybe<Scalars['String']>;
  contractorEmail?: Maybe<Scalars['String']>;
  contractorPhoneNumber?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currentPhase?: Maybe<CardPhase>;
  dealValue?: Maybe<Scalars['Float']>;
  done?: Maybe<Scalars['Boolean']>;
  dueDate?: Maybe<Scalars['DateTime']>;
  fields?: Maybe<Array<CardField>>;
  finalContractAmount?: Maybe<Scalars['Float']>;
  finishedAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['String'];
  invoiceNumber?: Maybe<Scalars['String']>;
  liisaLink?: Maybe<Scalars['String']>;
  liisaLoginEmail?: Maybe<Scalars['String']>;
  linkToShareMedia?: Maybe<Scalars['String']>;
  packageType?: Maybe<Scalars['String']>;
  proVettedAndApproved?: Maybe<Array<Scalars['String']>>;
  projectOutcome?: Maybe<Scalars['String']>;
  title: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
  yzBuild?: Maybe<Scalars['String']>;
};

export type Profile = {
  __typename?: 'Profile';
  createdAt: Scalars['String'];
  email: Scalars['String'];
  firstName: Scalars['String'];
  id: Scalars['String'];
  lastName: Scalars['String'];
  shareableLink?: Maybe<ShareableLink>;
  updatedAt: Scalars['String'];
  userId: Scalars['String'];
};

export type ProjectCard = {
  __typename?: 'ProjectCard';
  buildProject?: Maybe<BuildProject>;
  clientCard?: Maybe<ClientCard>;
  clientId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdBy?: Maybe<Scalars['String']>;
  currentPhase?: Maybe<CardPhase>;
  done?: Maybe<Scalars['Boolean']>;
  dueDate?: Maybe<Scalars['DateTime']>;
  emailMessagingAddress?: Maybe<Scalars['String']>;
  fields?: Maybe<Array<CardField>>;
  finishedAt?: Maybe<Scalars['DateTime']>;
  fullAddress?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  linkToShareMedia?: Maybe<Scalars['String']>;
  matchingType?: Maybe<Scalars['String']>;
  pipe: Pipe;
  surveyResponses?: Maybe<Array<SurveyResponse>>;
  title: Scalars['String'];
  updatePhaseLink?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  uuid?: Maybe<Scalars['String']>;
};

export enum ProjectDigestFrequency {
  Daily = 'DAILY',
  None = 'NONE',
  Weekly = 'WEEKLY'
}

export type ProjectElement = {
  __typename?: 'ProjectElement';
  budgetLowerBound?: Maybe<Scalars['Int']>;
  budgetUpperBound?: Maybe<Scalars['Int']>;
  category: Scalars['String'];
  id: Scalars['String'];
  isSelected?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  notes?: Maybe<Scalars['String']>;
  rankingInCategory: Scalars['Float'];
};


export type ProjectElementIsSelectedArgs = {
  styleProfileId: Scalars['String'];
};

export type ProjectElementsBatchInput = {
  projectElementId: Scalars['String'];
  select: Scalars['Boolean'];
};

export type PublicAccount = {
  __typename?: 'PublicAccount';
  id: Scalars['String'];
  users?: Maybe<Array<PublicUser>>;
};

export type PublicAddress = {
  __typename?: 'PublicAddress';
  city?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  state?: Maybe<Scalars['String']>;
};

export type PublicBuildProject = {
  __typename?: 'PublicBuildProject';
  account?: Maybe<PublicAccount>;
  id: Scalars['String'];
};

export type PublicContractorProfile = {
  __typename?: 'PublicContractorProfile';
  address?: Maybe<PublicAddress>;
  businessName: Scalars['String'];
  contacts?: Maybe<Array<ContractorContact>>;
  contractorId?: Maybe<Scalars['String']>;
};

export type PublicEstimate = {
  __typename?: 'PublicEstimate';
  buildProject?: Maybe<PublicBuildProject>;
  contractorId: Scalars['String'];
  contractorProfile?: Maybe<PublicContractorProfile>;
  estimateBidFiles?: Maybe<Array<PublicMedia>>;
};

export type PublicMedia = {
  __typename?: 'PublicMedia';
  id: Scalars['String'];
  uri?: Maybe<Scalars['String']>;
};

export type PublicUser = {
  __typename?: 'PublicUser';
  id: Scalars['String'];
  userProfile?: Maybe<PublicUserProfile>;
};

export type PublicUserProfile = {
  __typename?: 'PublicUserProfile';
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  mailingAddress?: Maybe<Address>;
};

export type Query = {
  __typename?: 'Query';
  acceptedCurrentTermsOfService: Array<UserTermsOfService>;
  account: Account;
  accountManager: AccountManager;
  accountManagerByAccountId: AccountManager;
  accountManagers: Array<AccountManager>;
  actionAcknowledgement: ActionAcknowledgement;
  address?: Maybe<Address>;
  addresses?: Maybe<Array<Address>>;
  adminConversations: Array<Conversation>;
  allMatches: Array<Match>;
  availableWorkLineItemTags: Array<Scalars['String']>;
  buildProject: BuildProject;
  buildProjects: Array<BuildProject>;
  buildRegion: BuildRegion;
  buildRegions: Array<BuildRegion>;
  checkInvoicePayable: StatusObject;
  checkPaymentIntentForInvoice: StatusObject;
  cityProjectElements: Array<CityProjectElement>;
  contractor?: Maybe<Contractor>;
  contractorContact: ContractorContact;
  contractorContacts: Array<ContractorContact>;
  contractorInvoice: Invoice;
  contractorMetrics: ContractorMetrics;
  contractorProfile?: Maybe<ContractorProfile>;
  contractorReviews: Array<ContractorReview>;
  contractors: Array<Contractor>;
  conversation: Conversation;
  conversationParticipants: Array<ConversationParticipant>;
  conversations: Array<Conversation>;
  estimate: Estimate;
  estimatePaymentLineItems: Array<EstimatePaymentLineItem>;
  estimateWorkLineItem: EstimateWorkLineItem;
  estimateWorkLineItems: Array<EstimateWorkLineItem>;
  estimates?: Maybe<Array<Estimate>>;
  fetchAllContractorIds: Array<ContractorProfile>;
  findAllPipefyFormSubmissions: Array<PipefyFormSubmissionRecord>;
  findClassicBuildProjectsForContractor: Array<ProjectCard>;
  findMarketplaceBuildProjectsForContractor: Array<ProjectCard>;
  findProDesignCards: Array<ProDesignCard>;
  findTermsOfService: Array<UserTermsOfService>;
  findUser: User;
  galleryImage?: Maybe<GalleryImage>;
  galleryImages: Array<GalleryImage>;
  getLikedRenders: Array<RenderFeedback>;
  getRenderFeedback: Array<RenderFeedback>;
  invoice: Invoice;
  invoices: Array<Invoice>;
  latestBuildProject?: Maybe<BuildProject>;
  latestConversationMessage?: Maybe<Array<Message>>;
  latestDeliveredRevision?: Maybe<LatestRevision>;
  likedGalleryImages: Array<GalleryImage>;
  loginHistory: Array<LoginHistory>;
  markets: Array<Market>;
  matches: Array<Match>;
  messages: Array<Message>;
  payableContractorProfiles: Array<ContractorProfile>;
  profile?: Maybe<Profile>;
  projectBriefElementsExportData: BriefElementsExportData;
  projectBriefHeaderInformation: BriefHeaderInformation;
  projectBriefMaterialExportData: BriefMaterialExportData;
  projectBriefMedia: Array<BriefMedia>;
  projectBriefPlantExportData: BriefPlantExportData;
  projectElements: Array<ProjectElement>;
  publicEstimate: PublicEstimate;
  publicProjectElements: Array<ProjectElement>;
  readMediaMessage: Media;
  renderFeedbacks: Array<RenderFeedback>;
  revision: Revision;
  revisions: Array<Revision>;
  searchContractorProfiles: Array<ContractorProfile>;
  searchInvoices: Array<Invoice>;
  searchUserProfiles?: Maybe<Array<UserProfile>>;
  searchUsers: UserSearchResponse;
  shareableLink: ShareableLink;
  styleProfile: StyleProfile;
  styleProfiles: Array<StyleProfile>;
  survey: Survey;
  surveyResponse: Array<SurveyResponse>;
  unreadMessagesCountByConversationParticipant: Scalars['Float'];
  url?: Maybe<Url>;
  userProfile?: Maybe<UserProfile>;
  userTermsOfService: UserTermsOfService;
  users?: Maybe<Array<User>>;
};


export type QueryAcceptedCurrentTermsOfServiceArgs = {
  input: FindAllUserTermsOfServiceInput;
};


export type QueryAccountArgs = {
  input: FindOneAccountInput;
};


export type QueryAccountManagerArgs = {
  id: Scalars['String'];
};


export type QueryAccountManagerByAccountIdArgs = {
  accountId: Scalars['String'];
};


export type QueryActionAcknowledgementArgs = {
  key: Scalars['String'];
};


export type QueryAddressArgs = {
  id: Scalars['String'];
};


export type QueryAddressesArgs = {
  input: FindAllAddressesInput;
};


export type QueryAdminConversationsArgs = {
  input: FetchAdminConversationsInput;
};


export type QueryAllMatchesArgs = {
  input: FindAllMatchesInput;
};


export type QueryBuildProjectArgs = {
  input: FindBuildProjectInput;
};


export type QueryBuildProjectsArgs = {
  input: FindAllBuildProjectsInput;
};


export type QueryBuildRegionArgs = {
  input: FindOneBuildRegionInput;
};


export type QueryBuildRegionsArgs = {
  input: FindAllBuildRegionInput;
};


export type QueryCheckInvoicePayableArgs = {
  invoiceId: Scalars['String'];
};


export type QueryCheckPaymentIntentForInvoiceArgs = {
  invoiceId: Scalars['String'];
  paymentIntentId: Scalars['String'];
};


export type QueryCityProjectElementsArgs = {
  input: FindAllProjectElementsByCityInput;
};


export type QueryContractorArgs = {
  input: FindOneContractorInput;
};


export type QueryContractorContactArgs = {
  id: Scalars['String'];
};


export type QueryContractorContactsArgs = {
  contractorId: Scalars['String'];
};


export type QueryContractorInvoiceArgs = {
  id: Scalars['String'];
};


export type QueryContractorMetricsArgs = {
  contractorId: Scalars['String'];
  endDate?: InputMaybe<Scalars['DateTime']>;
  startDate?: InputMaybe<Scalars['DateTime']>;
};


export type QueryContractorProfileArgs = {
  contractorId: Scalars['String'];
};


export type QueryContractorReviewsArgs = {
  input: FindAllContractorReviewsInput;
};


export type QueryContractorsArgs = {
  input: FindAllContractorsInput;
};


export type QueryConversationArgs = {
  input: FindOneConversationInput;
};


export type QueryConversationParticipantsArgs = {
  input: FindAllConversationParticipantsInput;
};


export type QueryConversationsArgs = {
  input: FindAllConversationsInput;
};


export type QueryEstimateArgs = {
  id: Scalars['String'];
};


export type QueryEstimatePaymentLineItemsArgs = {
  input: FindAllEstimatePaymentLineItemsInput;
};


export type QueryEstimateWorkLineItemArgs = {
  id: Scalars['String'];
};


export type QueryEstimateWorkLineItemsArgs = {
  input: FindAllEstimateWorkLineItemsInput;
};


export type QueryEstimatesArgs = {
  input: FindAllEstimatesInput;
};


export type QueryFindAllPipefyFormSubmissionsArgs = {
  input: FindAllPipefyFormSubmissionsInput;
};


export type QueryFindProDesignCardsArgs = {
  contractorId: Scalars['String'];
};


export type QueryFindTermsOfServiceArgs = {
  input: FindAllUserTermsOfServiceInput;
};


export type QueryFindUserArgs = {
  id: Scalars['String'];
};


export type QueryGalleryImageArgs = {
  input: FindOneGalleryImageInput;
};


export type QueryGalleryImagesArgs = {
  input: FindAllGalleryImageInput;
};


export type QueryGetLikedRendersArgs = {
  segmentId: Scalars['String'];
};


export type QueryGetRenderFeedbackArgs = {
  segmentId: Scalars['String'];
};


export type QueryInvoiceArgs = {
  id: Scalars['String'];
};


export type QueryInvoicesArgs = {
  input: FindInvoicesInput;
};


export type QueryLatestBuildProjectArgs = {
  accountId: Scalars['String'];
};


export type QueryLatestConversationMessageArgs = {
  input: GetLatestConversationMessageInput;
};


export type QueryLatestDeliveredRevisionArgs = {
  shareLinkId?: InputMaybe<Scalars['String']>;
  userId: Scalars['String'];
};


export type QueryLikedGalleryImagesArgs = {
  input: FindAllGalleryImageInput;
};


export type QueryLoginHistoryArgs = {
  input: FindAllLoginHistoryInput;
};


export type QueryMarketsArgs = {
  input: FindAllMarketsInput;
};


export type QueryMatchesArgs = {
  input: FindMatchesInput;
};


export type QueryMessagesArgs = {
  input: FindAllMessagesInput;
};


export type QueryProfileArgs = {
  id: Scalars['String'];
};


export type QueryProjectBriefElementsExportDataArgs = {
  input: GetProjectBriefMediaInput;
};


export type QueryProjectBriefHeaderInformationArgs = {
  input: GetProjectBriefMediaInput;
};


export type QueryProjectBriefMaterialExportDataArgs = {
  input: GetProjectBriefMediaInput;
};


export type QueryProjectBriefMediaArgs = {
  input: GetProjectBriefMediaInput;
};


export type QueryProjectBriefPlantExportDataArgs = {
  input: GetProjectBriefMediaInput;
};


export type QueryProjectElementsArgs = {
  input: FindProjectElementsInput;
};


export type QueryPublicEstimateArgs = {
  id: Scalars['String'];
};


export type QueryReadMediaMessageArgs = {
  input: ReadMediaMessageInput;
};


export type QueryRenderFeedbacksArgs = {
  input: GetNextRenderFeedbackSetInput;
};


export type QueryRevisionArgs = {
  id: Scalars['String'];
};


export type QueryRevisionsArgs = {
  input: FindAllRevisionsInput;
};


export type QuerySearchContractorProfilesArgs = {
  input: SearchContractorProfilesInput;
};


export type QuerySearchInvoicesArgs = {
  input: SearchInvoicesInput;
};


export type QuerySearchUserProfilesArgs = {
  input: SearchUserProfilesInput;
};


export type QuerySearchUsersArgs = {
  input: SearchUsersInput;
};


export type QueryShareableLinkArgs = {
  id: Scalars['String'];
};


export type QueryStyleProfileArgs = {
  input: FindByStyleProfileInput;
};


export type QueryStyleProfilesArgs = {
  input: FindAllStyleProfileInput;
};


export type QuerySurveyArgs = {
  input: FindSurveyInput;
};


export type QuerySurveyResponseArgs = {
  input: FindSurveyResponseInput;
};


export type QueryUnreadMessagesCountByConversationParticipantArgs = {
  input: GetUnreadMessagesInput;
};


export type QueryUrlArgs = {
  id: Scalars['String'];
};


export type QueryUserProfileArgs = {
  input: FindOneUserProfileInput;
};


export type QueryUserTermsOfServiceArgs = {
  input: FindOneUserTermsOfServiceInput;
};


export type QueryUsersArgs = {
  input: FindAllUsersInput;
};

export type ReadMediaMessageInput = {
  id: Scalars['String'];
};

export enum Region {
  Midwest = 'MIDWEST',
  MidAtlantic = 'MID_ATLANTIC',
  Northeast = 'NORTHEAST',
  Pacific = 'PACIFIC',
  PacificNorthwest = 'PACIFIC_NORTHWEST',
  RockyMountain = 'ROCKY_MOUNTAIN',
  Southeast = 'SOUTHEAST',
  Southwest = 'SOUTHWEST'
}

export type RenderFeedback = {
  __typename?: 'RenderFeedback';
  city?: Maybe<Scalars['String']>;
  comments?: Maybe<Scalars['String']>;
  dislikedAt?: Maybe<Scalars['DateTime']>;
  externalId: Scalars['Float'];
  id?: Maybe<Scalars['String']>;
  imageUrl?: Maybe<Scalars['String']>;
  isLiked?: Maybe<Scalars['Boolean']>;
  isNew?: Maybe<Scalars['Boolean']>;
  likedAt?: Maybe<Scalars['DateTime']>;
  likedFrom?: Maybe<Scalars['String']>;
  package?: Maybe<Scalars['String']>;
  segmentId?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  style?: Maybe<Scalars['String']>;
};

export type RenderFeedbackInput = {
  comments?: InputMaybe<Scalars['String']>;
  dislikedAt?: InputMaybe<Scalars['DateTime']>;
  externalId: Scalars['Float'];
  imageUrl?: InputMaybe<Scalars['String']>;
  isLiked?: InputMaybe<Scalars['Boolean']>;
  isNew?: InputMaybe<Scalars['Boolean']>;
  likedAt?: InputMaybe<Scalars['DateTime']>;
  likedFrom?: InputMaybe<Scalars['String']>;
  package?: InputMaybe<Scalars['String']>;
  segmentId?: InputMaybe<Scalars['String']>;
  style?: InputMaybe<Scalars['String']>;
};

export type RenderFeedbackSetInput = {
  feedbackSet: Array<RenderFeedbackInput>;
};

export type ResolveBuildProjectPipefyCardsInput = {
  contractorId: Scalars['String'];
};

export type ResolvedProjectCard = {
  __typename?: 'ResolvedProjectCard';
  buildProjectId: Scalars['String'];
  cardId?: Maybe<Scalars['String']>;
  cardPhaseId?: Maybe<Scalars['String']>;
  cardPhaseName?: Maybe<Scalars['String']>;
  cardPipeId?: Maybe<Scalars['String']>;
  cardPipeName?: Maybe<Scalars['String']>;
  contractorId: Scalars['String'];
};

export type Revision = {
  __typename?: 'Revision';
  clientFirstName: Scalars['String'];
  clientLastName: Scalars['String'];
  contractorId?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  media: Array<Media>;
  projectCity: Scalars['String'];
  projectPackage: Scalars['String'];
  projectState: Scalars['String'];
  shareMediaLink?: Maybe<Scalars['String']>;
};


export type RevisionMediaArgs = {
  pagination?: InputMaybe<MediaPagination>;
};

export type RevisionPagination = {
  cursor?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Float']>;
  sortBy?: InputMaybe<RevisionSortByEnum>;
  sortDirection?: InputMaybe<SortDirection>;
};

export enum RevisionSortByEnum {
  ContractorId = 'CONTRACTOR_ID'
}

export type SearchContractorProfilesInput = {
  approved?: InputMaybe<Scalars['Boolean']>;
  paused?: InputMaybe<Scalars['Boolean']>;
  pausedReason?: InputMaybe<ContractorPausedStatusReason>;
  superPro?: InputMaybe<Scalars['Boolean']>;
  term: Scalars['String'];
};

export type SearchInvoicesInput = {
  contractorId?: InputMaybe<Scalars['String']>;
  searchTerm?: InputMaybe<Scalars['String']>;
};

export type SearchUserProfilesInput = {
  searchTerm: Scalars['String'];
};

export type SearchUsersInput = {
  page?: InputMaybe<Scalars['Float']>;
  pageSize?: InputMaybe<Scalars['Float']>;
  term: Scalars['String'];
};

export type SendFeedbackSubmittedNotificationToSlackInput = {
  message: Scalars['String'];
  userId: Scalars['String'];
};

export type SendGhostMessageFormSubmissionInput = {
  conversationId: Scalars['String'];
  fromAccountManager?: InputMaybe<Scalars['String']>;
  message: Scalars['String'];
};

export type SendOnboardingSurveyNotificationToSlackInput = {
  message: Scalars['String'];
  userId: Scalars['String'];
};

export type SendPasswordResetEmailInput = {
  baseUrl?: InputMaybe<Scalars['String']>;
  email: Scalars['String'];
};

export type SetContractorUserClaimsInput = {
  contractorId: Scalars['String'];
  email: Scalars['String'];
};

export type ShareableLink = {
  __typename?: 'ShareableLink';
  createdAt: Scalars['String'];
  createdBy?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  isContractorOnly?: Maybe<Scalars['Boolean']>;
  media?: Maybe<Array<MediaPangaea>>;
  updatedAt: Scalars['String'];
};

export type SignUpAndSendMessageSubmissionInput = {
  contractorId: Scalars['String'];
  message: Scalars['String'];
  userProfileId: Scalars['String'];
};

export type SmsEventInput = {
  sid: Scalars['String'];
  status: Scalars['String'];
};

export enum SortDirection {
  Asc = 'ASC',
  Desc = 'DESC'
}

export enum SortOrder {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type StartLeadConversationsInput = {
  userId: Scalars['String'];
};

export type StatusObject = {
  __typename?: 'StatusObject';
  ok: Scalars['Boolean'];
};

export type StringFilter = {
  contains?: InputMaybe<Scalars['String']>;
  endsWith?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Scalars['String']>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  not?: InputMaybe<Scalars['String']>;
  notIn?: InputMaybe<Scalars['String']>;
  startsWith?: InputMaybe<Scalars['String']>;
};

export type StripeCharge = {
  __typename?: 'StripeCharge';
  amount: Scalars['Float'];
  amountCaptured: Scalars['Float'];
  amountRefunded: Scalars['Float'];
  application?: Maybe<Scalars['String']>;
  applicationFee?: Maybe<Scalars['String']>;
  applicationFeeAmount?: Maybe<Scalars['Float']>;
  balanceTransaction: Scalars['String'];
  calculatedStatementDescriptor: Scalars['String'];
  captured: Scalars['Boolean'];
  created: Scalars['Float'];
  currency: Scalars['String'];
  customer?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  disputed: Scalars['Boolean'];
  failureBalanceTransaction?: Maybe<Scalars['String']>;
  failureCode?: Maybe<Scalars['String']>;
  failureMessage?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  invoice?: Maybe<Scalars['String']>;
  invoiceId?: Maybe<Scalars['String']>;
  livemode: Scalars['Boolean'];
  object: Scalars['String'];
  onBehalfOf?: Maybe<Scalars['String']>;
  paid: Scalars['Boolean'];
  paymentIntent?: Maybe<Scalars['String']>;
  paymentMethod: Scalars['String'];
  paymentMethodDetails?: Maybe<PaymentMethodDetails>;
  receiptEmail?: Maybe<Scalars['String']>;
  receiptNumber?: Maybe<Scalars['String']>;
  receiptUrl: Scalars['String'];
  refunded: Scalars['Boolean'];
  review?: Maybe<Scalars['String']>;
  sourceTransfer?: Maybe<Scalars['String']>;
  statementDescriptor?: Maybe<Scalars['String']>;
  statementDescriptorSuffix?: Maybe<Scalars['String']>;
  status: Scalars['String'];
  tranferData?: Maybe<Scalars['String']>;
  transferGroup?: Maybe<Scalars['String']>;
};

export enum Style {
  Contemporary = 'CONTEMPORARY',
  Cottage = 'COTTAGE',
  ModernBoho = 'MODERN_BOHO',
  ModernFarmhouse = 'MODERN_FARMHOUSE',
  Moditerranean = 'MODITERRANEAN',
  Rustic = 'RUSTIC',
  Southwest = 'SOUTHWEST',
  Traditional = 'TRADITIONAL'
}

export type StyleProfile = {
  __typename?: 'StyleProfile';
  galleryImages?: Maybe<Array<GalleryImage>>;
  id: Scalars['String'];
  maxBudget?: Maybe<Scalars['Float']>;
  styleResults: Array<StyleResult>;
  timeline?: Maybe<Scalars['String']>;
  userId: Scalars['String'];
  yardLocation?: Maybe<YardLocation>;
};

export type StyleProfilePaginator = {
  cursor?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Float']>;
  sortBy?: InputMaybe<StyleProfilesPaginatorSortByEnum>;
  sortDirection?: InputMaybe<SortDirection>;
};

export enum StyleProfilesPaginatorSortByEnum {
  CreatedTs = 'CREATED_TS'
}

export type StyleResult = {
  __typename?: 'StyleResult';
  imageUrl: Scalars['String'];
  percentage: Scalars['Float'];
  styleDescription: Scalars['String'];
  styleName: Scalars['String'];
};

export type Survey = {
  __typename?: 'Survey';
  createdTs: Scalars['DateTime'];
  id: Scalars['String'];
  surveyDesc: Scalars['String'];
  surveyKey: Scalars['String'];
  surveyQuestions: Array<SurveyQuestion>;
  updatedTs?: Maybe<Scalars['DateTime']>;
  version: Scalars['Float'];
};


export type SurveySurveyQuestionsArgs = {
  input?: InputMaybe<SurveyQuestionsInput>;
};

export type SurveyQuestion = {
  __typename?: 'SurveyQuestion';
  createdTs: Scalars['DateTime'];
  format: Scalars['String'];
  id: Scalars['String'];
  index: Scalars['Float'];
  questionKey: Scalars['String'];
  required: Scalars['Boolean'];
  section: Scalars['Float'];
  surveyId: Scalars['String'];
  text: Scalars['String'];
  updatedTs?: Maybe<Scalars['DateTime']>;
};

export type SurveyQuestionResponse = {
  __typename?: 'SurveyQuestionResponse';
  createdTs: Scalars['DateTime'];
  response: Scalars['String'];
  surveyQuestion?: Maybe<SurveyQuestion>;
  surveyQuestionId: Scalars['String'];
  surveyResponseId: Scalars['String'];
  updatedTs?: Maybe<Scalars['DateTime']>;
};

export type SurveyQuestionsInput = {
  onlyActiveQuestions?: InputMaybe<Scalars['Boolean']>;
};

export type SurveyResponse = {
  __typename?: 'SurveyResponse';
  buildProjectId: Scalars['String'];
  completed: Scalars['Boolean'];
  createdTs: Scalars['DateTime'];
  id: Scalars['String'];
  surveyId: Scalars['String'];
  surveyQuestionReponses: Array<SurveyQuestionResponse>;
  updatedTs?: Maybe<Scalars['DateTime']>;
  userId?: Maybe<Scalars['String']>;
};

export type SyncUserToCordialInput = {
  email: Scalars['String'];
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
};

export type SyncUserToCordialResponse = {
  __typename?: 'SyncUserToCordialResponse';
  email: Scalars['String'];
};

export type UpdateAccountInput = {
  id: Scalars['String'];
};

export type UpdateAccountManagerInput = {
  buildRegionIds?: InputMaybe<Array<Scalars['String']>>;
  consultCallUrl?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  isActive?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  projectManagerId?: InputMaybe<Scalars['String']>;
  slackChannelId?: InputMaybe<Scalars['String']>;
  thumbnailMediaId?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['String']>;
};

export type UpdateAddressInput = {
  addressLine1?: InputMaybe<Scalars['String']>;
  addressLine2?: InputMaybe<Scalars['String']>;
  businessName?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  latitude?: InputMaybe<Scalars['Float']>;
  longitude?: InputMaybe<Scalars['Float']>;
  phone?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  zipcode?: InputMaybe<Scalars['String']>;
};

export type UpdateBuildProjectInput = {
  accountId?: InputMaybe<Scalars['String']>;
  coordinates?: InputMaybe<Array<Scalars['Float']>>;
  id: Scalars['String'];
  internalNotes?: InputMaybe<Scalars['String']>;
  members?: InputMaybe<Array<Scalars['String']>>;
  proFacingNotes?: InputMaybe<Scalars['String']>;
  projectElements?: InputMaybe<Array<ProjectElementsBatchInput>>;
};

export type UpdateBuildRegionInput = {
  accountManagerId?: InputMaybe<Scalars['String']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  areaGeometry?: InputMaybe<Scalars['String']>;
  contractorId?: InputMaybe<Scalars['String']>;
  displayName?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  internalName?: InputMaybe<Scalars['String']>;
  isDefault?: InputMaybe<Scalars['Boolean']>;
  lastUpdatedBy?: InputMaybe<Scalars['String']>;
};

export type UpdateContractorContactInput = {
  email?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  isPrimary?: InputMaybe<Scalars['Boolean']>;
  lastName?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
};

export type UpdateContractorDocumentInput = {
  confirmationLink?: InputMaybe<Scalars['String']>;
  expirationDate?: InputMaybe<Scalars['DateTime']>;
  id: Scalars['String'];
  kind: Scalars['String'];
  licenseNumber?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Float']>;
  policyNumber?: InputMaybe<Scalars['String']>;
};

export type UpdateContractorInput = {
  abilities?: InputMaybe<Array<Scalars['String']>>;
  acceptingWork?: InputMaybe<Scalars['Boolean']>;
  approvalStatus?: InputMaybe<Scalars['String']>;
  approved?: InputMaybe<Scalars['Boolean']>;
  businessName?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  closeRate?: InputMaybe<Scalars['Float']>;
  coordinates?: InputMaybe<InputCoordinates>;
  currentBuildRegionId?: InputMaybe<Scalars['String']>;
  dashboardAccessEmails?: InputMaybe<Array<Scalars['String']>>;
  email?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  lastName?: InputMaybe<Scalars['String']>;
  locations?: InputMaybe<Array<Scalars['String']>>;
  maxSuccessBudget?: InputMaybe<Scalars['Float']>;
  minSuccessBudget?: InputMaybe<Scalars['Float']>;
  notes?: InputMaybe<Scalars['String']>;
  paused?: InputMaybe<Scalars['Boolean']>;
  pausedStatusReason?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  pipefyContractorCardId?: InputMaybe<Scalars['Float']>;
  pointOfContactEmail?: InputMaybe<Scalars['String']>;
  pointOfContactName?: InputMaybe<Scalars['String']>;
  pointOfContactPhone?: InputMaybe<Scalars['String']>;
  preferred?: InputMaybe<Scalars['Boolean']>;
  profile?: InputMaybe<UpdateContractorProfileInput>;
  state?: InputMaybe<Scalars['String']>;
  street?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['String']>;
  website?: InputMaybe<Scalars['String']>;
  zip?: InputMaybe<Scalars['String']>;
};

export type UpdateContractorMediaOrderInput = {
  mediaId: Scalars['String'];
  order: Scalars['Float'];
};

export type UpdateContractorProfileInput = {
  abilities?: InputMaybe<Array<Scalars['String']>>;
  aboutSummary?: InputMaybe<Scalars['String']>;
  acceptingWork?: InputMaybe<Scalars['Boolean']>;
  active?: InputMaybe<Scalars['Boolean']>;
  address?: InputMaybe<CreateAddressInput>;
  addressId?: InputMaybe<Scalars['String']>;
  approved?: InputMaybe<Scalars['Boolean']>;
  approvedTs?: InputMaybe<Scalars['DateTime']>;
  attributes?: InputMaybe<Array<ContractorAttribute>>;
  budgetRangeLowerBound?: InputMaybe<Scalars['Int']>;
  budgetRangeUpperBound?: InputMaybe<Scalars['Int']>;
  businessName?: InputMaybe<Scalars['String']>;
  calendlyEmail?: InputMaybe<Scalars['String']>;
  calendlyUrl?: InputMaybe<Scalars['String']>;
  contacts?: InputMaybe<Array<CreateContractorContactInput>>;
  contractorId: Scalars['String'];
  createdBy?: InputMaybe<Scalars['String']>;
  currentBuildRegionId?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  googleUrl?: InputMaybe<Scalars['String']>;
  headshotMediaUrl?: InputMaybe<Scalars['String']>;
  initialBuildRegionId?: InputMaybe<Scalars['String']>;
  isTest?: InputMaybe<Scalars['Boolean']>;
  licenseExpirationDate?: InputMaybe<Scalars['DateTime']>;
  licenseNumber?: InputMaybe<Scalars['String']>;
  maxSuccessBudget?: InputMaybe<Scalars['Int']>;
  minSuccessBudget?: InputMaybe<Scalars['Int']>;
  notApprovedStatusReason?: InputMaybe<ContractorNotApprovedStatusReason>;
  notes?: InputMaybe<Scalars['String']>;
  paused?: InputMaybe<Scalars['Boolean']>;
  pausedStatusReason?: InputMaybe<ContractorPausedStatusReason>;
  pausedTs?: InputMaybe<Scalars['DateTime']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  pipefyContractorCardId?: InputMaybe<Scalars['Float']>;
  preferred?: InputMaybe<Scalars['Boolean']>;
  projectDigestFrequency?: InputMaybe<ProjectDigestFrequency>;
  promotionalMessage?: InputMaybe<Scalars['String']>;
  promotionalMessageEndDate?: InputMaybe<Scalars['DateTime']>;
  promotionalMessageStartDate?: InputMaybe<Scalars['DateTime']>;
  rating?: InputMaybe<Scalars['Float']>;
  stripeConnectedAccountId?: InputMaybe<Scalars['String']>;
  thumbnailMediaUrl?: InputMaybe<Scalars['String']>;
  unapprovedTs?: InputMaybe<Scalars['DateTime']>;
  unpausedTs?: InputMaybe<Scalars['DateTime']>;
  updatedBy?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['String']>;
  website?: InputMaybe<Scalars['String']>;
  whyYardzenLovesSummary?: InputMaybe<Scalars['String']>;
  yearsInBusiness?: InputMaybe<Scalars['Int']>;
  yelpUrl?: InputMaybe<Scalars['String']>;
};

export type UpdateContractorReviewInput = {
  author?: InputMaybe<Scalars['String']>;
  contractorId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  reviewedTs?: InputMaybe<Scalars['DateTime']>;
  source?: InputMaybe<ContractorReviewSource>;
  summary?: InputMaybe<Scalars['String']>;
};

export type UpdateConversationInput = {
  archived?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['String']>;
  sid?: InputMaybe<Scalars['String']>;
};

export type UpdateEstimateInput = {
  buildProjectId?: InputMaybe<Scalars['String']>;
  clonedFromEstimateId?: InputMaybe<Scalars['String']>;
  contractorDeposit?: InputMaybe<Scalars['Int']>;
  contractorId?: InputMaybe<Scalars['String']>;
  evaluationNotes?: InputMaybe<Scalars['String']>;
  expectedEndDate?: InputMaybe<Scalars['DateTime']>;
  expectedStartDate?: InputMaybe<Scalars['DateTime']>;
  id: Scalars['String'];
  platformFee?: InputMaybe<Scalars['Int']>;
  proEstimateNumber?: InputMaybe<Scalars['String']>;
  proTermDetails?: InputMaybe<Scalars['String']>;
  sentToClient?: InputMaybe<Scalars['Boolean']>;
  sentToClientBy?: InputMaybe<Scalars['String']>;
  sentToClientTs?: InputMaybe<Scalars['DateTime']>;
  version?: InputMaybe<Scalars['Int']>;
};

export type UpdateEstimatePaymentLineItemInput = {
  id: Scalars['String'];
  name?: InputMaybe<Scalars['String']>;
  paymentDue?: InputMaybe<Scalars['String']>;
  totalAmountDue?: InputMaybe<Scalars['Int']>;
};

export type UpdateEstimateWorkLineItemInput = {
  clientFeedbackNotes?: InputMaybe<Scalars['String']>;
  clientFeedbackTs?: InputMaybe<Scalars['DateTime']>;
  clonedFromEstimateWorkLineItemId?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  name?: InputMaybe<Scalars['String']>;
  tags?: InputMaybe<Array<Scalars['String']>>;
  totalCost?: InputMaybe<Scalars['Int']>;
};

export type UpdateGalleryImageInput = {
  amenities?: InputMaybe<Array<Scalars['String']>>;
  city: Scalars['String'];
  designPackage: Scalars['String'];
  id: Scalars['String'];
  ranking: Scalars['Float'];
  region: Scalars['String'];
  state: Scalars['String'];
  styles?: InputMaybe<Array<Scalars['String']>>;
  yardAttributes?: InputMaybe<Array<Scalars['String']>>;
};

export type UpdateInvoiceInput = {
  applicationFeeAmount?: InputMaybe<Scalars['Int']>;
  clientNotes?: InputMaybe<Scalars['String']>;
  connectedAccountId?: InputMaybe<Scalars['String']>;
  contractorId: Scalars['String'];
  description?: InputMaybe<Scalars['String']>;
  estimateId?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  internalNotes?: InputMaybe<Scalars['String']>;
  lastPaymentAttemptedTs?: InputMaybe<Scalars['DateTime']>;
  name?: InputMaybe<Scalars['String']>;
  paid?: InputMaybe<Scalars['Boolean']>;
  paymentDueTs?: InputMaybe<Scalars['DateTime']>;
  paymentMilestone?: InputMaybe<InvoicePaymentMilestone>;
  proInvoiceReference?: InputMaybe<Scalars['String']>;
  product?: InputMaybe<Scalars['String']>;
  receiptEmail?: InputMaybe<Scalars['String']>;
  totalAmount?: InputMaybe<Scalars['Int']>;
  voidInvoice?: InputMaybe<Scalars['Boolean']>;
  yzFeeRate?: InputMaybe<Scalars['String']>;
};

export type UpdateMailingAddressInput = {
  addressLine1?: InputMaybe<Scalars['String']>;
  addressLine2?: InputMaybe<Scalars['String']>;
  businessName?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  latitude?: InputMaybe<Scalars['Float']>;
  longitude?: InputMaybe<Scalars['Float']>;
  phone?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  zipcode?: InputMaybe<Scalars['String']>;
};

export type UpdatePipefyCardResponse = {
  __typename?: 'UpdatePipefyCardResponse';
  pipefyCardId: Scalars['String'];
};

export type UpdateProfileInput = {
  email?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  lastName?: InputMaybe<Scalars['String']>;
};

export type UpdateRevisionInput = {
  contractorId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  shareMediaLink?: InputMaybe<Scalars['String']>;
};

export type UpdateStyleProfileInput = {
  id: Scalars['String'];
  maxBudget?: InputMaybe<Scalars['Float']>;
  timeline?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['String']>;
  yardLocation?: InputMaybe<YardLocation>;
};

export type UpdateTotalContractValueInput = {
  buildProjectId: Scalars['String'];
  contractorId: Scalars['String'];
  totalContractValue: Scalars['Float'];
};

export type UpdateUserEmailInput = {
  email: Scalars['String'];
  userId: Scalars['String'];
};

export type UpdateUserInput = {
  accountId: Scalars['String'];
  email: Scalars['String'];
  userId: Scalars['String'];
};

export type UpdateUserProfileInput = {
  email?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  leadZipcode?: InputMaybe<Scalars['String']>;
  mailingAddress?: InputMaybe<UpdateMailingAddressInput>;
  newMailingAddress?: InputMaybe<CreateAddressInput>;
  optIn?: InputMaybe<Scalars['Boolean']>;
  phone?: InputMaybe<Scalars['String']>;
  segmentId?: InputMaybe<Scalars['String']>;
  testAccount?: InputMaybe<Scalars['Boolean']>;
  userId: Scalars['String'];
};

export type UpdateUserProjectElementsBatchInput = {
  buildProjectId: Scalars['String'];
  projectElements: Array<ProjectElementsBatchInput>;
};

export type UpdateUserTermsOfServiceInput = {
  dateOfAgree?: InputMaybe<Scalars['DateTime']>;
  id: Scalars['String'];
  tosAgreed?: InputMaybe<Scalars['Boolean']>;
  typeOfTos?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['String']>;
};

export type UploadMediaMessageInput = {
  buildProjectId?: InputMaybe<Scalars['String']>;
  fileName: Scalars['String'];
  messageId?: InputMaybe<Scalars['String']>;
  mimeType: Scalars['String'];
  source?: InputMaybe<MediaSource>;
};

export type UpsertSurveyQuestionResponseInput = {
  response: Scalars['String'];
  surveyQuestionId: Scalars['String'];
  surveyResponseId: Scalars['String'];
};

export type UpsertSurveyQuestionResponsesInput = {
  completed?: InputMaybe<Scalars['Boolean']>;
  questionResponses: Array<UpsertSurveyQuestionResponseInput>;
  userId: Scalars['String'];
};

export type Url = {
  __typename?: 'Url';
  createdTs: Scalars['DateTime'];
  longUrl: Scalars['String'];
  requiredPath?: Maybe<Scalars['String']>;
  shortUrl: Scalars['String'];
  updatedTs: Scalars['DateTime'];
};

export type User = {
  __typename?: 'User';
  account: Account;
  accountId: Scalars['String'];
  hasRevisonDelivered: Scalars['Boolean'];
  id: Scalars['String'];
  isBuildStudioClient?: Maybe<Scalars['Boolean']>;
  isDesignClient: Scalars['Boolean'];
  isProjectClient?: Maybe<Scalars['Boolean']>;
  loginHistory?: Maybe<Array<LoginHistory>>;
  mustAcceptTerms: Scalars['Boolean'];
  styleProfile?: Maybe<StyleProfile>;
  userProfile?: Maybe<UserProfile>;
};


export type UserLoginHistoryArgs = {
  pagination?: InputMaybe<LoginHistoryPaginator>;
};

export type UserProfile = {
  __typename?: 'UserProfile';
  createdTs: Scalars['DateTime'];
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  leadZipcode?: Maybe<Scalars['String']>;
  mailingAddress?: Maybe<Address>;
  mailingAddressId: Scalars['String'];
  optIn?: Maybe<Scalars['Boolean']>;
  phone?: Maybe<Scalars['String']>;
  segmentId?: Maybe<Scalars['String']>;
  testAccount?: Maybe<Scalars['Boolean']>;
  updatedTs: Scalars['DateTime'];
  userId: Scalars['String'];
};

export type UserProfileEnhanced = {
  __typename?: 'UserProfileEnhanced';
  accountId?: Maybe<Scalars['String']>;
  createdTs: Scalars['DateTime'];
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  isDesignClient?: Maybe<Scalars['Boolean']>;
  lastName?: Maybe<Scalars['String']>;
  leadZipcode?: Maybe<Scalars['String']>;
  mailingAddress?: Maybe<Address>;
  mailingAddressId: Scalars['String'];
  optIn?: Maybe<Scalars['Boolean']>;
  phone?: Maybe<Scalars['String']>;
  segmentId?: Maybe<Scalars['String']>;
  testAccount?: Maybe<Scalars['Boolean']>;
  updatedTs: Scalars['DateTime'];
  userId: Scalars['String'];
};

export type UserSearchResponse = {
  __typename?: 'UserSearchResponse';
  page: Scalars['Float'];
  pageCount: Scalars['Float'];
  pageSize: Scalars['Float'];
  results: Array<UserSearchResult>;
};

export type UserSearchResult = {
  __typename?: 'UserSearchResult';
  email: Scalars['String'];
  fromContractorConnect: Scalars['Boolean'];
  fromLegacy: Scalars['Boolean'];
  user?: Maybe<User>;
  userProfile?: Maybe<UserProfile>;
  user_id: Scalars['String'];
};

export enum UserSortByEnum {
  CreatedTs = 'CREATED_TS',
  UpdatedTs = 'UPDATED_TS'
}

export type UserTermsOfService = {
  __typename?: 'UserTermsOfService';
  createdTs: Scalars['DateTime'];
  dateOfAgree: Scalars['DateTime'];
  id: Scalars['String'];
  tosAgreed: Scalars['Boolean'];
  typeOfTos: Scalars['String'];
  updatedTs: Scalars['DateTime'];
  userId: Scalars['String'];
};

export type UsersPaginator = {
  cursor?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Float']>;
  sortBy?: InputMaybe<UserSortByEnum>;
  sortDirection?: InputMaybe<SortDirection>;
};

export type WriteableMedia = {
  __typename?: 'WriteableMedia';
  bucketName: Scalars['String'];
  buildProjectId?: Maybe<Scalars['String']>;
  contractorId?: Maybe<Scalars['String']>;
  createdTs: Scalars['DateTime'];
  designProjectId?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  messageId?: Maybe<Scalars['String']>;
  mimeType: Scalars['String'];
  notes?: Maybe<Scalars['String']>;
  objectName: Scalars['String'];
  order?: Maybe<Scalars['Float']>;
  revisionId: Scalars['String'];
  source?: Maybe<MediaSource>;
  tags?: Maybe<Array<MediaTag>>;
  uploadConfirmed: Scalars['Boolean'];
  uploaderId?: Maybe<Scalars['String']>;
  uri?: Maybe<Scalars['String']>;
  writeUrl: Scalars['String'];
};

export enum YardDesignLocation {
  Back = 'BACK',
  Front = 'FRONT',
  Side = 'SIDE'
}

export enum YardElement {
  BasketballCourt = 'BASKETBALL_COURT',
  Deck = 'DECK',
  Driveway = 'DRIVEWAY',
  Fence = 'FENCE',
  FirePit = 'FIRE_PIT',
  FirePlace = 'FIRE_PLACE',
  Grass = 'GRASS',
  Grill = 'GRILL',
  Hammock = 'HAMMOCK',
  HotTub = 'HOT_TUB',
  OutdoorKitchen = 'OUTDOOR_KITCHEN',
  Patio = 'PATIO',
  Pergola = 'PERGOLA',
  Planters = 'PLANTERS',
  Playground = 'PLAYGROUND',
  Pool = 'POOL',
  PoolHouse = 'POOL_HOUSE',
  RopeLights = 'ROPE_LIGHTS',
  Slope = 'SLOPE',
  Walkway = 'WALKWAY',
  WaterFountain = 'WATER_FOUNTAIN'
}

export enum YardLocation {
  BackYard = 'BACK_YARD',
  FrontYard = 'FRONT_YARD',
  FullYard = 'FULL_YARD',
  NotSure = 'NOT_SURE'
}

export type GetLongUrlQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetLongUrlQuery = { __typename?: 'Query', url?: { __typename?: 'Url', longUrl: string } | null };

export type GetEstimateDataQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetEstimateDataQuery = { __typename?: 'Query', publicEstimate: { __typename?: 'PublicEstimate', estimateBidFiles?: Array<{ __typename?: 'PublicMedia', id: string, uri?: string | null }> | null, contractorProfile?: { __typename?: 'PublicContractorProfile', businessName: string, address?: { __typename?: 'PublicAddress', city?: string | null, state?: string | null } | null, contacts?: Array<{ __typename?: 'ContractorContact', firstName?: string | null, lastName?: string | null, isPrimary: boolean }> | null } | null, buildProject?: { __typename?: 'PublicBuildProject', id: string, account?: { __typename?: 'PublicAccount', id: string, users?: Array<{ __typename?: 'PublicUser', id: string, userProfile?: { __typename?: 'PublicUserProfile', firstName?: string | null, lastName?: string | null, mailingAddress?: { __typename?: 'Address', addressLine1: string, addressLine2?: string | null, city: string, state: string, zipcode: string } | null } | null }> | null } | null } | null } };

export type GetEstimatePageDataQueryVariables = Exact<{
  estimateId: Scalars['String'];
}>;


export type GetEstimatePageDataQuery = { __typename?: 'Query', estimate: { __typename?: 'Estimate', id: string, expectedStartDate?: any | null, evaluationNotes?: string | null, proEstimateNumber?: string | null, proTermDetails?: string | null, expectedEndDate?: any | null, proTermDocuments?: Array<{ __typename?: 'Media', uri?: string | null, objectName: string }> | null, workLineItems: Array<{ __typename?: 'EstimateWorkLineItem', id: string, description: string, totalCost: number, name: string, clientFeedbackNotes?: string | null }>, contractorProfile: { __typename?: 'ContractorProfile', rating?: number | null, attributes?: Array<ContractorAttribute> | null, businessName?: string | null, media?: Array<{ __typename?: 'Media', uri?: string | null, tags?: Array<MediaTag> | null }> | null } } };

export type GetNextRenderGalleryPageQueryVariables = Exact<{
  input: GetNextRenderFeedbackSetInput;
}>;


export type GetNextRenderGalleryPageQuery = { __typename?: 'Query', renderFeedbacks: Array<{ __typename?: 'RenderFeedback', id?: string | null, externalId: number, imageUrl?: string | null, city?: string | null, state?: string | null, likedAt?: any | null, dislikedAt?: any | null, isLiked?: boolean | null, segmentId?: string | null, comments?: string | null, style?: string | null, isNew?: boolean | null, package?: string | null }> };

export type UpdateGalleryFeedbackMutationVariables = Exact<{
  input: RenderFeedbackInput;
}>;


export type UpdateGalleryFeedbackMutation = { __typename?: 'Mutation', submitRenderFeedback: { __typename?: 'RenderFeedback', id?: string | null, externalId: number, imageUrl?: string | null, city?: string | null, state?: string | null, likedAt?: any | null, dislikedAt?: any | null, style?: string | null, likedFrom?: string | null } };

export type GetLikedGalleryRendersQueryVariables = Exact<{
  segmentId: Scalars['String'];
}>;


export type GetLikedGalleryRendersQuery = { __typename?: 'Query', getLikedRenders: Array<{ __typename?: 'RenderFeedback', id?: string | null, externalId: number, imageUrl?: string | null, city?: string | null, state?: string | null, likedAt?: any | null, dislikedAt?: any | null, comments?: string | null, style?: string | null }> };

export type CreateStyleProfileMutationVariables = Exact<{
  input: CreateStyleProfileInput;
}>;


export type CreateStyleProfileMutation = { __typename?: 'Mutation', createStyleProfile: { __typename?: 'StyleProfile', id: string } };

export type CreateBuildProjectElementsMutationVariables = Exact<{
  input: UpdateUserProjectElementsBatchInput;
}>;


export type CreateBuildProjectElementsMutation = { __typename?: 'Mutation', updateUserProjectElementsBatch: { __typename?: 'StatusObject', ok: boolean } };

export type CreateStyleProfileLikeGalleryImageMutationVariables = Exact<{
  input: CreateStyleProfileLikeImageInput;
}>;


export type CreateStyleProfileLikeGalleryImageMutation = { __typename?: 'Mutation', createStyleProfileLikeGalleryImage: Array<{ __typename?: 'GalleryImage', id: string }> };

export type FindUserForLayoutQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type FindUserForLayoutQuery = { __typename?: 'Query', findUser: { __typename?: 'User', mustAcceptTerms: boolean } };

export type GetMatchingContractorsQueryVariables = Exact<{
  input: FindMatchesInput;
}>;


export type GetMatchingContractorsQuery = { __typename?: 'Query', matches: Array<{ __typename?: 'Match', pipefyDtbCardId?: string | null, contractorProfile: { __typename?: 'ContractorProfile', contractorId: string, businessName?: string | null } }> };

export type GetContractorThumbnailQueryVariables = Exact<{
  contractorId: Scalars['String'];
}>;


export type GetContractorThumbnailQuery = { __typename?: 'Query', contractorProfile?: { __typename?: 'ContractorProfile', media?: Array<{ __typename?: 'Media', uri?: string | null, tags?: Array<MediaTag> | null }> | null } | null };

export type GetLatestBuildProjectQueryVariables = Exact<{
  accountId: Scalars['String'];
}>;


export type GetLatestBuildProjectQuery = { __typename?: 'Query', latestBuildProject?: { __typename?: 'BuildProject', id: string } | null };

export type GetInvoiceQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetInvoiceQuery = { __typename?: 'Query', invoice: { __typename?: 'Invoice', id: string, name: string, description?: string | null, connectedAccountId?: string | null, contractorId?: string | null, paymentDueTs?: any | null, isRefunded: boolean, refundDate?: any | null, totalAmount: number, paid: boolean, voidedTs?: any | null, stripeStatus?: string | null, paymentMilestone?: InvoicePaymentMilestone | null, incrementalInvoiceNumber?: number | null, proInvoiceReference?: string | null, createdTs: any, lastPaymentAttemptedTs?: any | null, contractorProfile?: { __typename?: 'ContractorProfile', businessName?: string | null, stripeConnectedAccountId?: string | null, thumbnailMediaUrl?: string | null, address?: { __typename?: 'Address', addressLine1: string, city: string, state: string, zipcode: string } | null } | null, estimate?: { __typename?: 'Estimate', id: string, paymentLineItems: Array<{ __typename?: 'EstimatePaymentLineItem', name: string, totalAmountDue: number, paymentDue: string }> } | null, userProfiles?: Array<{ __typename?: 'UserProfile', firstName?: string | null, lastName?: string | null, mailingAddress?: { __typename?: 'Address', addressLine1: string, addressLine2?: string | null, city: string, state: string, zipcode: string } | null }> | null } };

export type RequestPaymentMutationVariables = Exact<{
  invoiceId: Scalars['String'];
}>;


export type RequestPaymentMutation = { __typename?: 'Mutation', startPayment: { __typename?: 'PaymentRequest', paid: boolean, payment?: { __typename?: 'Payment', hasFailed?: boolean | null, status?: string | null, paymentIntentId: string, paymentRequestId: string, clientSecret: string, connectedAccountId?: string | null } | null } };

export type CheckPaymentIntentForInvoiceQueryVariables = Exact<{
  invoiceId: Scalars['String'];
  paymentIntentId: Scalars['String'];
}>;


export type CheckPaymentIntentForInvoiceQuery = { __typename?: 'Query', checkPaymentIntentForInvoice: { __typename?: 'StatusObject', ok: boolean } };

export type CheckInvoicePayableQueryVariables = Exact<{
  invoiceId: Scalars['String'];
}>;


export type CheckInvoicePayableQuery = { __typename?: 'Query', checkInvoicePayable: { __typename?: 'StatusObject', ok: boolean } };

export type GetUserProfileQueryVariables = Exact<{
  input: FindOneUserProfileInput;
}>;


export type GetUserProfileQuery = { __typename?: 'Query', userProfile?: { __typename?: 'UserProfile', userId: string, email?: string | null, firstName?: string | null, lastName?: string | null, phone?: string | null, optIn?: boolean | null, mailingAddress?: { __typename?: 'Address', addressLine1: string, addressLine2?: string | null, city: string, state: string, zipcode: string, latitude: number, longitude: number } | null } | null };

export type CreateUserProfileMutationVariables = Exact<{
  input: CreateUserProfileInput;
}>;


export type CreateUserProfileMutation = { __typename?: 'Mutation', createUserProfile: { __typename?: 'UserProfile', userId: string, email?: string | null, firstName?: string | null, lastName?: string | null, phone?: string | null, mailingAddress?: { __typename?: 'Address', addressLine1: string, addressLine2?: string | null, city: string, state: string, zipcode: string, latitude: number, longitude: number } | null } };

export type UpdateUserProfileMutationVariables = Exact<{
  input: UpdateUserProfileInput;
}>;


export type UpdateUserProfileMutation = { __typename?: 'Mutation', updateUserProfile: { __typename?: 'UserProfile', userId: string, email?: string | null, firstName?: string | null, lastName?: string | null, phone?: string | null, mailingAddress?: { __typename?: 'Address', addressLine1: string, addressLine2?: string | null, city: string, state: string, zipcode: string, latitude: number, longitude: number } | null } };

export type StartLeadConvertedConversationsMutationVariables = Exact<{
  input: StartLeadConversationsInput;
}>;


export type StartLeadConvertedConversationsMutation = { __typename?: 'Mutation', startLeadConvertedConversations?: Array<{ __typename?: 'Conversation', id: string } | null> | null };

export type GetContractorProfilePageDataQueryVariables = Exact<{
  contractorId: Scalars['String'];
}>;


export type GetContractorProfilePageDataQuery = { __typename?: 'Query', contractorProfile?: { __typename?: 'ContractorProfile', contractorId: string, businessName?: string | null, thumbnailMediaUrl?: string | null, whyYardzenLovesSummary?: string | null, aboutSummary?: string | null, attributes?: Array<ContractorAttribute> | null, yearsInBusiness?: number | null, licenseNumber?: string | null, rating?: number | null, abilities?: Array<{ __typename?: 'ContractorAbilityLinkType', name?: string | null }> | null, contacts?: Array<{ __typename?: 'ContractorContact', firstName?: string | null, lastName?: string | null, isPrimary: boolean }> | null, address?: { __typename?: 'Address', city: string, state: string } | null, galleryImages: Array<{ __typename?: 'ContractorImage', uri: string }>, reviews?: Array<{ __typename?: 'ContractorReview', id: string, source: ContractorReviewSource, author: string, summary: string, reviewedTs: any }> | null, revisions: Array<{ __typename?: 'Revision', clientFirstName: string, clientLastName: string, projectCity: string, projectState: string, projectPackage: string, media: Array<{ __typename?: 'Media', bucketName: string, objectName: string, mimeType: string, uri?: string | null, buildProjectId?: string | null, source?: MediaSource | null, createdTs: any }> }> } | null };

export type GetAllProMatchesQueryVariables = Exact<{
  input: FindMatchesInput;
}>;


export type GetAllProMatchesQuery = { __typename?: 'Query', matches: Array<{ __typename?: 'Match', rank: number, contractorProfile: { __typename?: 'ContractorProfile', contractorId: string, businessName?: string | null, thumbnailMediaUrl?: string | null, whyYardzenLovesSummary?: string | null, aboutSummary?: string | null, attributes?: Array<ContractorAttribute> | null, yearsInBusiness?: number | null, licenseNumber?: string | null, rating?: number | null, abilities?: Array<{ __typename?: 'ContractorAbilityLinkType', name?: string | null }> | null, contacts?: Array<{ __typename?: 'ContractorContact', firstName?: string | null, lastName?: string | null, isPrimary: boolean }> | null, address?: { __typename?: 'Address', city: string, state: string } | null, galleryImages: Array<{ __typename?: 'ContractorImage', uri: string }>, reviews?: Array<{ __typename?: 'ContractorReview', id: string, source: ContractorReviewSource, author: string, summary: string, reviewedTs: any }> | null } }> };

export type GetContractorQueryVariables = Exact<{
  input: FindOneContractorInput;
}>;


export type GetContractorQuery = { __typename?: 'Query', contractor?: { __typename?: 'Contractor', id: string, businessName: string, abilities: Array<string>, firstName?: string | null, lastName?: string | null, city: string, state: string, userId?: string | null, profile: { __typename?: 'ContractorProfile', rating?: number | null, reviews?: Array<{ __typename?: 'ContractorReview', author: string, summary: string, source: ContractorReviewSource, reviewedTs: any }> | null } } | null };

export type GetCurrentConversationsQueryVariables = Exact<{
  input: FindAllConversationsInput;
}>;


export type GetCurrentConversationsQuery = { __typename?: 'Query', conversations: Array<{ __typename?: 'Conversation', id: string, conversationParticipants: Array<{ __typename?: 'ConversationParticipant', name?: string | null, role: ConversationRole, id: string, contractorId?: string | null, userProfileId?: string | null }> }> };

export type CreateNewConversationMutationVariables = Exact<{
  input: CreateConversationInput;
}>;


export type CreateNewConversationMutation = { __typename?: 'Mutation', createConversation: { __typename?: 'Conversation', id: string } };

export type GetProMatchesQueryVariables = Exact<{
  input: FindMatchesInput;
}>;


export type GetProMatchesQuery = { __typename?: 'Query', matches: Array<{ __typename?: 'Match', rank: number, contractorProfile: { __typename?: 'ContractorProfile', contractorId: string, businessName?: string | null, thumbnailMediaUrl?: string | null, headshotMediaUrl?: string | null, whyYardzenLovesSummary?: string | null, aboutSummary?: string | null, attributes?: Array<ContractorAttribute> | null, yearsInBusiness?: number | null, licenseNumber?: string | null, rating?: number | null, abilities?: Array<{ __typename?: 'ContractorAbilityLinkType', name?: string | null }> | null, address?: { __typename?: 'Address', city: string, state: string } | null, contacts?: Array<{ __typename?: 'ContractorContact', firstName?: string | null, lastName?: string | null, isPrimary: boolean }> | null, galleryImages: Array<{ __typename?: 'ContractorImage', uri: string }>, reviews?: Array<{ __typename?: 'ContractorReview', author: string, summary: string, reviewedTs: any }> | null } }> };

export type FindFirstBuildProjectQueryVariables = Exact<{
  input: FindAllBuildProjectsInput;
}>;


export type FindFirstBuildProjectQuery = { __typename?: 'Query', buildProjects: Array<{ __typename?: 'BuildProject', id: string, projectBudgetEstimate?: Array<number> | null, internalNotes?: string | null, proFacingNotes?: string | null, projectElements: Array<{ __typename?: 'ProjectElement', id: string, name: string, category: string, budgetLowerBound?: number | null, budgetUpperBound?: number | null, notes?: string | null }> }> };

export type StartInitialYardzenConversationMutationVariables = Exact<{
  input: CreateConversationInput;
}>;


export type StartInitialYardzenConversationMutation = { __typename?: 'Mutation', startInitialYardzenConversation?: { __typename?: 'Conversation', id: string } | null };

export type ApplyMathchingAlgorithmMutationVariables = Exact<{
  input: FindMatchesInput;
}>;


export type ApplyMathchingAlgorithmMutation = { __typename?: 'Mutation', applyMatchingAlgorithm: Array<{ __typename?: 'Match', rank: number, contractorProfile: { __typename?: 'ContractorProfile', contractorId: string, businessName?: string | null, thumbnailMediaUrl?: string | null, headshotMediaUrl?: string | null, whyYardzenLovesSummary?: string | null, aboutSummary?: string | null, attributes?: Array<ContractorAttribute> | null, yearsInBusiness?: number | null, licenseNumber?: string | null, rating?: number | null, abilities?: Array<{ __typename?: 'ContractorAbilityLinkType', name?: string | null }> | null, address?: { __typename?: 'Address', city: string, state: string } | null, contacts?: Array<{ __typename?: 'ContractorContact', firstName?: string | null, lastName?: string | null, isPrimary: boolean }> | null, galleryImages: Array<{ __typename?: 'ContractorImage', uri: string }>, reviews?: Array<{ __typename?: 'ContractorReview', author: string, summary: string, reviewedTs: any }> | null } }> };

export type CreateBuildStudioUserFromFirestoreDataMutationVariables = Exact<{
  userId: Scalars['String'];
}>;


export type CreateBuildStudioUserFromFirestoreDataMutation = { __typename?: 'Mutation', createBuildStudioUserFromFirestoreData?: string | null };

export type CreateBuildProjectMutationVariables = Exact<{
  input: CreateBuildProjectInput;
}>;


export type CreateBuildProjectMutation = { __typename?: 'Mutation', createBuildProject: { __typename?: 'BuildProject', id: string, projectBudgetEstimate?: Array<number> | null, internalNotes?: string | null, proFacingNotes?: string | null, firebaseProjectId?: string | null, accountManagerId?: string | null, accountManager?: { __typename?: 'AccountManager', id: string, name?: string | null, consultCallUrl?: string | null, thumbnailUrl?: string | null } | null, projectElements: Array<{ __typename?: 'ProjectElement', id: string, name: string, category: string, budgetLowerBound?: number | null, budgetUpperBound?: number | null, notes?: string | null }> } };

export type FetchAdminConversationsQueryVariables = Exact<{
  input: FetchAdminConversationsInput;
}>;


export type FetchAdminConversationsQuery = { __typename?: 'Query', adminConversations: Array<{ __typename?: 'Conversation', id: string, conversationParticipants: Array<{ __typename?: 'ConversationParticipant', id: string, contractorId?: string | null, userProfileId?: string | null, role: ConversationRole, conversationId: string }> }> };

export type AssignAccountManagerMutationVariables = Exact<{
  input: AssignAccountManagerInput;
}>;


export type AssignAccountManagerMutation = { __typename?: 'Mutation', assignAccountManager: { __typename?: 'BuildProject', id: string, accountManager?: { __typename?: 'AccountManager', id: string, name?: string | null, consultCallUrl?: string | null, thumbnailUrl?: string | null } | null } };

export type FindUserForMatchingQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type FindUserForMatchingQuery = { __typename?: 'Query', findUser: { __typename?: 'User', accountId: string, isProjectClient?: boolean | null, isDesignClient: boolean, hasRevisonDelivered: boolean, isBuildStudioClient?: boolean | null, userProfile?: { __typename?: 'UserProfile', userId: string, email?: string | null, phone?: string | null, firstName?: string | null, lastName?: string | null, leadZipcode?: string | null, mailingAddress?: { __typename?: 'Address', city: string, state: string } | null } | null, account: { __typename?: 'Account', buildProjects: Array<{ __typename?: 'BuildProject', surveyResponses: Array<{ __typename?: 'SurveyResponse', id: string, surveyId: string, completed: boolean, surveyQuestionReponses: Array<{ __typename?: 'SurveyQuestionResponse', response: string, surveyQuestionId: string, createdTs: any, updatedTs?: any | null }> }> }> } } };

export type FindPreMatchingSurveyQueryVariables = Exact<{
  input: FindSurveyInput;
}>;


export type FindPreMatchingSurveyQuery = { __typename?: 'Query', survey: { __typename?: 'Survey', id: string, surveyQuestions: Array<{ __typename?: 'SurveyQuestion', id: string, questionKey: string, text: string, section: number, index: number, format: string, required: boolean }> } };

export type CreateSurveyResponseMutationMutationVariables = Exact<{
  input: CreateSurveyResponseInput;
}>;


export type CreateSurveyResponseMutationMutation = { __typename?: 'Mutation', createSurveyResponse: { __typename?: 'SurveyResponse', id: string, surveyId: string, buildProjectId: string } };

export type UpsertSurveyQuestionResponsesMutationVariables = Exact<{
  input: UpsertSurveyQuestionResponsesInput;
}>;


export type UpsertSurveyQuestionResponsesMutation = { __typename?: 'Mutation', upsertSurveyQuestionResponses: Array<{ __typename?: 'SurveyQuestionResponse', surveyQuestionId: string, surveyResponseId: string, response: string }> };

export type FindSurveyResponsesQueryVariables = Exact<{
  input: FindSurveyResponseInput;
}>;


export type FindSurveyResponsesQuery = { __typename?: 'Query', surveyResponse: Array<{ __typename?: 'SurveyResponse', id: string, completed: boolean, surveyQuestionReponses: Array<{ __typename?: 'SurveyQuestionResponse', surveyQuestionId: string, surveyResponseId: string, response: string }> }> };

export type FindInvoicesForMatchingQueryVariables = Exact<{
  input: FindInvoicesInput;
}>;


export type FindInvoicesForMatchingQuery = { __typename?: 'Query', invoices: Array<{ __typename?: 'Invoice', id: string, paid: boolean, paymentMilestone?: InvoicePaymentMilestone | null }> };

export type CreateCurrentTermsOfServiceMutationVariables = Exact<{
  input: CreateCurrentUserTermsOfServiceInput;
}>;


export type CreateCurrentTermsOfServiceMutation = { __typename?: 'Mutation', createCurrentUserTermsOfService: { __typename?: 'UserTermsOfService', id: string } };

export type GetRenderFeedbackQueryVariables = Exact<{
  segmentId: Scalars['String'];
}>;


export type GetRenderFeedbackQuery = { __typename?: 'Query', getRenderFeedback: Array<{ __typename?: 'RenderFeedback', externalId: number, imageUrl?: string | null, likedAt?: any | null, likedFrom?: string | null }> };

export type SubmitRenderFeedbackSetMutationVariables = Exact<{
  input: RenderFeedbackSetInput;
}>;


export type SubmitRenderFeedbackSetMutation = { __typename?: 'Mutation', submitRenderFeedbackSet: Array<{ __typename?: 'RenderFeedback', id?: string | null }> };

export type SubmitRenderFeedbackMutationVariables = Exact<{
  input: RenderFeedbackInput;
}>;


export type SubmitRenderFeedbackMutation = { __typename?: 'Mutation', submitRenderFeedback: { __typename?: 'RenderFeedback', id?: string | null } };


export const GetLongUrlDocument = gql`
    query getLongUrl($id: String!) {
  url(id: $id) {
    longUrl
  }
}
    `;

/**
 * __useGetLongUrlQuery__
 *
 * To run a query within a React component, call `useGetLongUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLongUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLongUrlQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetLongUrlQuery(baseOptions: Apollo.QueryHookOptions<GetLongUrlQuery, GetLongUrlQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLongUrlQuery, GetLongUrlQueryVariables>(GetLongUrlDocument, options);
      }
export function useGetLongUrlLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLongUrlQuery, GetLongUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLongUrlQuery, GetLongUrlQueryVariables>(GetLongUrlDocument, options);
        }
export type GetLongUrlQueryHookResult = ReturnType<typeof useGetLongUrlQuery>;
export type GetLongUrlLazyQueryHookResult = ReturnType<typeof useGetLongUrlLazyQuery>;
export type GetLongUrlQueryResult = Apollo.QueryResult<GetLongUrlQuery, GetLongUrlQueryVariables>;
export const GetEstimateDataDocument = gql`
    query GetEstimateData($id: String!) {
  publicEstimate(id: $id) {
    estimateBidFiles {
      id
      uri
    }
    contractorProfile {
      businessName
      address {
        city
        state
      }
      contacts {
        firstName
        lastName
        isPrimary
      }
    }
    buildProject {
      id
      account {
        id
        users {
          id
          userProfile {
            firstName
            lastName
            mailingAddress {
              addressLine1
              addressLine2
              city
              state
              zipcode
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetEstimateDataQuery__
 *
 * To run a query within a React component, call `useGetEstimateDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEstimateDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEstimateDataQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetEstimateDataQuery(baseOptions: Apollo.QueryHookOptions<GetEstimateDataQuery, GetEstimateDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEstimateDataQuery, GetEstimateDataQueryVariables>(GetEstimateDataDocument, options);
      }
export function useGetEstimateDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEstimateDataQuery, GetEstimateDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEstimateDataQuery, GetEstimateDataQueryVariables>(GetEstimateDataDocument, options);
        }
export type GetEstimateDataQueryHookResult = ReturnType<typeof useGetEstimateDataQuery>;
export type GetEstimateDataLazyQueryHookResult = ReturnType<typeof useGetEstimateDataLazyQuery>;
export type GetEstimateDataQueryResult = Apollo.QueryResult<GetEstimateDataQuery, GetEstimateDataQueryVariables>;
export const GetEstimatePageDataDocument = gql`
    query GetEstimatePageData($estimateId: String!) {
  estimate(id: $estimateId) {
    id
    expectedStartDate
    evaluationNotes
    proEstimateNumber
    proTermDetails
    proTermDocuments {
      uri
      objectName
    }
    workLineItems {
      id
      description
      totalCost
      name
      clientFeedbackNotes
    }
    expectedEndDate
    contractorProfile {
      media {
        uri
        tags
      }
      rating
      attributes
      businessName
    }
  }
}
    `;

/**
 * __useGetEstimatePageDataQuery__
 *
 * To run a query within a React component, call `useGetEstimatePageDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEstimatePageDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEstimatePageDataQuery({
 *   variables: {
 *      estimateId: // value for 'estimateId'
 *   },
 * });
 */
export function useGetEstimatePageDataQuery(baseOptions: Apollo.QueryHookOptions<GetEstimatePageDataQuery, GetEstimatePageDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEstimatePageDataQuery, GetEstimatePageDataQueryVariables>(GetEstimatePageDataDocument, options);
      }
export function useGetEstimatePageDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEstimatePageDataQuery, GetEstimatePageDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEstimatePageDataQuery, GetEstimatePageDataQueryVariables>(GetEstimatePageDataDocument, options);
        }
export type GetEstimatePageDataQueryHookResult = ReturnType<typeof useGetEstimatePageDataQuery>;
export type GetEstimatePageDataLazyQueryHookResult = ReturnType<typeof useGetEstimatePageDataLazyQuery>;
export type GetEstimatePageDataQueryResult = Apollo.QueryResult<GetEstimatePageDataQuery, GetEstimatePageDataQueryVariables>;
export const GetNextRenderGalleryPageDocument = gql`
    query GetNextRenderGalleryPage($input: GetNextRenderFeedbackSetInput!) {
  renderFeedbacks(input: $input) {
    id
    externalId
    imageUrl
    city
    state
    likedAt
    dislikedAt
    isLiked
    segmentId
    comments
    style
    isNew
    package
  }
}
    `;

/**
 * __useGetNextRenderGalleryPageQuery__
 *
 * To run a query within a React component, call `useGetNextRenderGalleryPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNextRenderGalleryPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNextRenderGalleryPageQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetNextRenderGalleryPageQuery(baseOptions: Apollo.QueryHookOptions<GetNextRenderGalleryPageQuery, GetNextRenderGalleryPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetNextRenderGalleryPageQuery, GetNextRenderGalleryPageQueryVariables>(GetNextRenderGalleryPageDocument, options);
      }
export function useGetNextRenderGalleryPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetNextRenderGalleryPageQuery, GetNextRenderGalleryPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetNextRenderGalleryPageQuery, GetNextRenderGalleryPageQueryVariables>(GetNextRenderGalleryPageDocument, options);
        }
export type GetNextRenderGalleryPageQueryHookResult = ReturnType<typeof useGetNextRenderGalleryPageQuery>;
export type GetNextRenderGalleryPageLazyQueryHookResult = ReturnType<typeof useGetNextRenderGalleryPageLazyQuery>;
export type GetNextRenderGalleryPageQueryResult = Apollo.QueryResult<GetNextRenderGalleryPageQuery, GetNextRenderGalleryPageQueryVariables>;
export const UpdateGalleryFeedbackDocument = gql`
    mutation updateGalleryFeedback($input: RenderFeedbackInput!) {
  submitRenderFeedback(input: $input) {
    id
    externalId
    imageUrl
    city
    state
    likedAt
    dislikedAt
    style
    likedFrom
  }
}
    `;
export type UpdateGalleryFeedbackMutationFn = Apollo.MutationFunction<UpdateGalleryFeedbackMutation, UpdateGalleryFeedbackMutationVariables>;

/**
 * __useUpdateGalleryFeedbackMutation__
 *
 * To run a mutation, you first call `useUpdateGalleryFeedbackMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateGalleryFeedbackMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateGalleryFeedbackMutation, { data, loading, error }] = useUpdateGalleryFeedbackMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateGalleryFeedbackMutation(baseOptions?: Apollo.MutationHookOptions<UpdateGalleryFeedbackMutation, UpdateGalleryFeedbackMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateGalleryFeedbackMutation, UpdateGalleryFeedbackMutationVariables>(UpdateGalleryFeedbackDocument, options);
      }
export type UpdateGalleryFeedbackMutationHookResult = ReturnType<typeof useUpdateGalleryFeedbackMutation>;
export type UpdateGalleryFeedbackMutationResult = Apollo.MutationResult<UpdateGalleryFeedbackMutation>;
export type UpdateGalleryFeedbackMutationOptions = Apollo.BaseMutationOptions<UpdateGalleryFeedbackMutation, UpdateGalleryFeedbackMutationVariables>;
export const GetLikedGalleryRendersDocument = gql`
    query getLikedGalleryRenders($segmentId: String!) {
  getLikedRenders(segmentId: $segmentId) {
    id
    externalId
    imageUrl
    city
    state
    likedAt
    dislikedAt
    comments
    style
  }
}
    `;

/**
 * __useGetLikedGalleryRendersQuery__
 *
 * To run a query within a React component, call `useGetLikedGalleryRendersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLikedGalleryRendersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLikedGalleryRendersQuery({
 *   variables: {
 *      segmentId: // value for 'segmentId'
 *   },
 * });
 */
export function useGetLikedGalleryRendersQuery(baseOptions: Apollo.QueryHookOptions<GetLikedGalleryRendersQuery, GetLikedGalleryRendersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLikedGalleryRendersQuery, GetLikedGalleryRendersQueryVariables>(GetLikedGalleryRendersDocument, options);
      }
export function useGetLikedGalleryRendersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLikedGalleryRendersQuery, GetLikedGalleryRendersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLikedGalleryRendersQuery, GetLikedGalleryRendersQueryVariables>(GetLikedGalleryRendersDocument, options);
        }
export type GetLikedGalleryRendersQueryHookResult = ReturnType<typeof useGetLikedGalleryRendersQuery>;
export type GetLikedGalleryRendersLazyQueryHookResult = ReturnType<typeof useGetLikedGalleryRendersLazyQuery>;
export type GetLikedGalleryRendersQueryResult = Apollo.QueryResult<GetLikedGalleryRendersQuery, GetLikedGalleryRendersQueryVariables>;
export const CreateStyleProfileDocument = gql`
    mutation CreateStyleProfile($input: CreateStyleProfileInput!) {
  createStyleProfile(input: $input) {
    id
  }
}
    `;
export type CreateStyleProfileMutationFn = Apollo.MutationFunction<CreateStyleProfileMutation, CreateStyleProfileMutationVariables>;

/**
 * __useCreateStyleProfileMutation__
 *
 * To run a mutation, you first call `useCreateStyleProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateStyleProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createStyleProfileMutation, { data, loading, error }] = useCreateStyleProfileMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateStyleProfileMutation(baseOptions?: Apollo.MutationHookOptions<CreateStyleProfileMutation, CreateStyleProfileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateStyleProfileMutation, CreateStyleProfileMutationVariables>(CreateStyleProfileDocument, options);
      }
export type CreateStyleProfileMutationHookResult = ReturnType<typeof useCreateStyleProfileMutation>;
export type CreateStyleProfileMutationResult = Apollo.MutationResult<CreateStyleProfileMutation>;
export type CreateStyleProfileMutationOptions = Apollo.BaseMutationOptions<CreateStyleProfileMutation, CreateStyleProfileMutationVariables>;
export const CreateBuildProjectElementsDocument = gql`
    mutation createBuildProjectElements($input: UpdateUserProjectElementsBatchInput!) {
  updateUserProjectElementsBatch(input: $input) {
    ok
  }
}
    `;
export type CreateBuildProjectElementsMutationFn = Apollo.MutationFunction<CreateBuildProjectElementsMutation, CreateBuildProjectElementsMutationVariables>;

/**
 * __useCreateBuildProjectElementsMutation__
 *
 * To run a mutation, you first call `useCreateBuildProjectElementsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateBuildProjectElementsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createBuildProjectElementsMutation, { data, loading, error }] = useCreateBuildProjectElementsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateBuildProjectElementsMutation(baseOptions?: Apollo.MutationHookOptions<CreateBuildProjectElementsMutation, CreateBuildProjectElementsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateBuildProjectElementsMutation, CreateBuildProjectElementsMutationVariables>(CreateBuildProjectElementsDocument, options);
      }
export type CreateBuildProjectElementsMutationHookResult = ReturnType<typeof useCreateBuildProjectElementsMutation>;
export type CreateBuildProjectElementsMutationResult = Apollo.MutationResult<CreateBuildProjectElementsMutation>;
export type CreateBuildProjectElementsMutationOptions = Apollo.BaseMutationOptions<CreateBuildProjectElementsMutation, CreateBuildProjectElementsMutationVariables>;
export const CreateStyleProfileLikeGalleryImageDocument = gql`
    mutation createStyleProfileLikeGalleryImage($input: CreateStyleProfileLikeImageInput!) {
  createStyleProfileLikeGalleryImage(input: $input) {
    id
  }
}
    `;
export type CreateStyleProfileLikeGalleryImageMutationFn = Apollo.MutationFunction<CreateStyleProfileLikeGalleryImageMutation, CreateStyleProfileLikeGalleryImageMutationVariables>;

/**
 * __useCreateStyleProfileLikeGalleryImageMutation__
 *
 * To run a mutation, you first call `useCreateStyleProfileLikeGalleryImageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateStyleProfileLikeGalleryImageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createStyleProfileLikeGalleryImageMutation, { data, loading, error }] = useCreateStyleProfileLikeGalleryImageMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateStyleProfileLikeGalleryImageMutation(baseOptions?: Apollo.MutationHookOptions<CreateStyleProfileLikeGalleryImageMutation, CreateStyleProfileLikeGalleryImageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateStyleProfileLikeGalleryImageMutation, CreateStyleProfileLikeGalleryImageMutationVariables>(CreateStyleProfileLikeGalleryImageDocument, options);
      }
export type CreateStyleProfileLikeGalleryImageMutationHookResult = ReturnType<typeof useCreateStyleProfileLikeGalleryImageMutation>;
export type CreateStyleProfileLikeGalleryImageMutationResult = Apollo.MutationResult<CreateStyleProfileLikeGalleryImageMutation>;
export type CreateStyleProfileLikeGalleryImageMutationOptions = Apollo.BaseMutationOptions<CreateStyleProfileLikeGalleryImageMutation, CreateStyleProfileLikeGalleryImageMutationVariables>;
export const FindUserForLayoutDocument = gql`
    query findUserForLayout($id: String!) {
  findUser(id: $id) {
    mustAcceptTerms
  }
}
    `;

/**
 * __useFindUserForLayoutQuery__
 *
 * To run a query within a React component, call `useFindUserForLayoutQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindUserForLayoutQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindUserForLayoutQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useFindUserForLayoutQuery(baseOptions: Apollo.QueryHookOptions<FindUserForLayoutQuery, FindUserForLayoutQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindUserForLayoutQuery, FindUserForLayoutQueryVariables>(FindUserForLayoutDocument, options);
      }
export function useFindUserForLayoutLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindUserForLayoutQuery, FindUserForLayoutQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindUserForLayoutQuery, FindUserForLayoutQueryVariables>(FindUserForLayoutDocument, options);
        }
export type FindUserForLayoutQueryHookResult = ReturnType<typeof useFindUserForLayoutQuery>;
export type FindUserForLayoutLazyQueryHookResult = ReturnType<typeof useFindUserForLayoutLazyQuery>;
export type FindUserForLayoutQueryResult = Apollo.QueryResult<FindUserForLayoutQuery, FindUserForLayoutQueryVariables>;
export const GetMatchingContractorsDocument = gql`
    query GetMatchingContractors($input: FindMatchesInput!) {
  matches(input: $input) {
    pipefyDtbCardId
    contractorProfile {
      contractorId
      businessName
    }
  }
}
    `;

/**
 * __useGetMatchingContractorsQuery__
 *
 * To run a query within a React component, call `useGetMatchingContractorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMatchingContractorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMatchingContractorsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetMatchingContractorsQuery(baseOptions: Apollo.QueryHookOptions<GetMatchingContractorsQuery, GetMatchingContractorsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMatchingContractorsQuery, GetMatchingContractorsQueryVariables>(GetMatchingContractorsDocument, options);
      }
export function useGetMatchingContractorsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMatchingContractorsQuery, GetMatchingContractorsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMatchingContractorsQuery, GetMatchingContractorsQueryVariables>(GetMatchingContractorsDocument, options);
        }
export type GetMatchingContractorsQueryHookResult = ReturnType<typeof useGetMatchingContractorsQuery>;
export type GetMatchingContractorsLazyQueryHookResult = ReturnType<typeof useGetMatchingContractorsLazyQuery>;
export type GetMatchingContractorsQueryResult = Apollo.QueryResult<GetMatchingContractorsQuery, GetMatchingContractorsQueryVariables>;
export const GetContractorThumbnailDocument = gql`
    query GetContractorThumbnail($contractorId: String!) {
  contractorProfile(contractorId: $contractorId) {
    media {
      uri
      tags
    }
  }
}
    `;

/**
 * __useGetContractorThumbnailQuery__
 *
 * To run a query within a React component, call `useGetContractorThumbnailQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContractorThumbnailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContractorThumbnailQuery({
 *   variables: {
 *      contractorId: // value for 'contractorId'
 *   },
 * });
 */
export function useGetContractorThumbnailQuery(baseOptions: Apollo.QueryHookOptions<GetContractorThumbnailQuery, GetContractorThumbnailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetContractorThumbnailQuery, GetContractorThumbnailQueryVariables>(GetContractorThumbnailDocument, options);
      }
export function useGetContractorThumbnailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetContractorThumbnailQuery, GetContractorThumbnailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetContractorThumbnailQuery, GetContractorThumbnailQueryVariables>(GetContractorThumbnailDocument, options);
        }
export type GetContractorThumbnailQueryHookResult = ReturnType<typeof useGetContractorThumbnailQuery>;
export type GetContractorThumbnailLazyQueryHookResult = ReturnType<typeof useGetContractorThumbnailLazyQuery>;
export type GetContractorThumbnailQueryResult = Apollo.QueryResult<GetContractorThumbnailQuery, GetContractorThumbnailQueryVariables>;
export const GetLatestBuildProjectDocument = gql`
    query GetLatestBuildProject($accountId: String!) {
  latestBuildProject(accountId: $accountId) {
    id
  }
}
    `;

/**
 * __useGetLatestBuildProjectQuery__
 *
 * To run a query within a React component, call `useGetLatestBuildProjectQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLatestBuildProjectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLatestBuildProjectQuery({
 *   variables: {
 *      accountId: // value for 'accountId'
 *   },
 * });
 */
export function useGetLatestBuildProjectQuery(baseOptions: Apollo.QueryHookOptions<GetLatestBuildProjectQuery, GetLatestBuildProjectQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLatestBuildProjectQuery, GetLatestBuildProjectQueryVariables>(GetLatestBuildProjectDocument, options);
      }
export function useGetLatestBuildProjectLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLatestBuildProjectQuery, GetLatestBuildProjectQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLatestBuildProjectQuery, GetLatestBuildProjectQueryVariables>(GetLatestBuildProjectDocument, options);
        }
export type GetLatestBuildProjectQueryHookResult = ReturnType<typeof useGetLatestBuildProjectQuery>;
export type GetLatestBuildProjectLazyQueryHookResult = ReturnType<typeof useGetLatestBuildProjectLazyQuery>;
export type GetLatestBuildProjectQueryResult = Apollo.QueryResult<GetLatestBuildProjectQuery, GetLatestBuildProjectQueryVariables>;
export const GetInvoiceDocument = gql`
    query GetInvoice($id: String!) {
  invoice(id: $id) {
    id
    name
    description
    connectedAccountId
    contractorId
    paymentDueTs
    isRefunded
    refundDate
    contractorProfile {
      businessName
      address {
        addressLine1
        city
        state
        zipcode
      }
      stripeConnectedAccountId
      thumbnailMediaUrl
    }
    totalAmount
    paid
    voidedTs
    estimate {
      id
      paymentLineItems {
        name
        totalAmountDue
        paymentDue
      }
    }
    stripeStatus
    paymentMilestone
    incrementalInvoiceNumber
    proInvoiceReference
    createdTs
    lastPaymentAttemptedTs
    userProfiles {
      firstName
      lastName
      mailingAddress {
        addressLine1
        addressLine2
        city
        state
        zipcode
      }
    }
  }
}
    `;

/**
 * __useGetInvoiceQuery__
 *
 * To run a query within a React component, call `useGetInvoiceQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInvoiceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInvoiceQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetInvoiceQuery(baseOptions: Apollo.QueryHookOptions<GetInvoiceQuery, GetInvoiceQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetInvoiceQuery, GetInvoiceQueryVariables>(GetInvoiceDocument, options);
      }
export function useGetInvoiceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetInvoiceQuery, GetInvoiceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetInvoiceQuery, GetInvoiceQueryVariables>(GetInvoiceDocument, options);
        }
export type GetInvoiceQueryHookResult = ReturnType<typeof useGetInvoiceQuery>;
export type GetInvoiceLazyQueryHookResult = ReturnType<typeof useGetInvoiceLazyQuery>;
export type GetInvoiceQueryResult = Apollo.QueryResult<GetInvoiceQuery, GetInvoiceQueryVariables>;
export const RequestPaymentDocument = gql`
    mutation RequestPayment($invoiceId: String!) {
  startPayment(input: {invoiceId: $invoiceId}) {
    paid
    payment {
      hasFailed
      status
      paymentIntentId
      paymentRequestId
      clientSecret
      connectedAccountId
    }
  }
}
    `;
export type RequestPaymentMutationFn = Apollo.MutationFunction<RequestPaymentMutation, RequestPaymentMutationVariables>;

/**
 * __useRequestPaymentMutation__
 *
 * To run a mutation, you first call `useRequestPaymentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestPaymentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestPaymentMutation, { data, loading, error }] = useRequestPaymentMutation({
 *   variables: {
 *      invoiceId: // value for 'invoiceId'
 *   },
 * });
 */
export function useRequestPaymentMutation(baseOptions?: Apollo.MutationHookOptions<RequestPaymentMutation, RequestPaymentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RequestPaymentMutation, RequestPaymentMutationVariables>(RequestPaymentDocument, options);
      }
export type RequestPaymentMutationHookResult = ReturnType<typeof useRequestPaymentMutation>;
export type RequestPaymentMutationResult = Apollo.MutationResult<RequestPaymentMutation>;
export type RequestPaymentMutationOptions = Apollo.BaseMutationOptions<RequestPaymentMutation, RequestPaymentMutationVariables>;
export const CheckPaymentIntentForInvoiceDocument = gql`
    query CheckPaymentIntentForInvoice($invoiceId: String!, $paymentIntentId: String!) {
  checkPaymentIntentForInvoice(
    invoiceId: $invoiceId
    paymentIntentId: $paymentIntentId
  ) {
    ok
  }
}
    `;

/**
 * __useCheckPaymentIntentForInvoiceQuery__
 *
 * To run a query within a React component, call `useCheckPaymentIntentForInvoiceQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckPaymentIntentForInvoiceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckPaymentIntentForInvoiceQuery({
 *   variables: {
 *      invoiceId: // value for 'invoiceId'
 *      paymentIntentId: // value for 'paymentIntentId'
 *   },
 * });
 */
export function useCheckPaymentIntentForInvoiceQuery(baseOptions: Apollo.QueryHookOptions<CheckPaymentIntentForInvoiceQuery, CheckPaymentIntentForInvoiceQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CheckPaymentIntentForInvoiceQuery, CheckPaymentIntentForInvoiceQueryVariables>(CheckPaymentIntentForInvoiceDocument, options);
      }
export function useCheckPaymentIntentForInvoiceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CheckPaymentIntentForInvoiceQuery, CheckPaymentIntentForInvoiceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CheckPaymentIntentForInvoiceQuery, CheckPaymentIntentForInvoiceQueryVariables>(CheckPaymentIntentForInvoiceDocument, options);
        }
export type CheckPaymentIntentForInvoiceQueryHookResult = ReturnType<typeof useCheckPaymentIntentForInvoiceQuery>;
export type CheckPaymentIntentForInvoiceLazyQueryHookResult = ReturnType<typeof useCheckPaymentIntentForInvoiceLazyQuery>;
export type CheckPaymentIntentForInvoiceQueryResult = Apollo.QueryResult<CheckPaymentIntentForInvoiceQuery, CheckPaymentIntentForInvoiceQueryVariables>;
export const CheckInvoicePayableDocument = gql`
    query CheckInvoicePayable($invoiceId: String!) {
  checkInvoicePayable(invoiceId: $invoiceId) {
    ok
  }
}
    `;

/**
 * __useCheckInvoicePayableQuery__
 *
 * To run a query within a React component, call `useCheckInvoicePayableQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckInvoicePayableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckInvoicePayableQuery({
 *   variables: {
 *      invoiceId: // value for 'invoiceId'
 *   },
 * });
 */
export function useCheckInvoicePayableQuery(baseOptions: Apollo.QueryHookOptions<CheckInvoicePayableQuery, CheckInvoicePayableQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CheckInvoicePayableQuery, CheckInvoicePayableQueryVariables>(CheckInvoicePayableDocument, options);
      }
export function useCheckInvoicePayableLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CheckInvoicePayableQuery, CheckInvoicePayableQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CheckInvoicePayableQuery, CheckInvoicePayableQueryVariables>(CheckInvoicePayableDocument, options);
        }
export type CheckInvoicePayableQueryHookResult = ReturnType<typeof useCheckInvoicePayableQuery>;
export type CheckInvoicePayableLazyQueryHookResult = ReturnType<typeof useCheckInvoicePayableLazyQuery>;
export type CheckInvoicePayableQueryResult = Apollo.QueryResult<CheckInvoicePayableQuery, CheckInvoicePayableQueryVariables>;
export const GetUserProfileDocument = gql`
    query getUserProfile($input: FindOneUserProfileInput!) {
  userProfile(input: $input) {
    userId
    email
    firstName
    lastName
    mailingAddress {
      addressLine1
      addressLine2
      city
      state
      zipcode
      latitude
      longitude
    }
    phone
    optIn
  }
}
    `;

/**
 * __useGetUserProfileQuery__
 *
 * To run a query within a React component, call `useGetUserProfileQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserProfileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserProfileQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetUserProfileQuery(baseOptions: Apollo.QueryHookOptions<GetUserProfileQuery, GetUserProfileQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserProfileQuery, GetUserProfileQueryVariables>(GetUserProfileDocument, options);
      }
export function useGetUserProfileLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserProfileQuery, GetUserProfileQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserProfileQuery, GetUserProfileQueryVariables>(GetUserProfileDocument, options);
        }
export type GetUserProfileQueryHookResult = ReturnType<typeof useGetUserProfileQuery>;
export type GetUserProfileLazyQueryHookResult = ReturnType<typeof useGetUserProfileLazyQuery>;
export type GetUserProfileQueryResult = Apollo.QueryResult<GetUserProfileQuery, GetUserProfileQueryVariables>;
export const CreateUserProfileDocument = gql`
    mutation createUserProfile($input: CreateUserProfileInput!) {
  createUserProfile(input: $input) {
    userId
    email
    firstName
    lastName
    mailingAddress {
      addressLine1
      addressLine2
      city
      state
      zipcode
      latitude
      longitude
    }
    phone
  }
}
    `;
export type CreateUserProfileMutationFn = Apollo.MutationFunction<CreateUserProfileMutation, CreateUserProfileMutationVariables>;

/**
 * __useCreateUserProfileMutation__
 *
 * To run a mutation, you first call `useCreateUserProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateUserProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createUserProfileMutation, { data, loading, error }] = useCreateUserProfileMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateUserProfileMutation(baseOptions?: Apollo.MutationHookOptions<CreateUserProfileMutation, CreateUserProfileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateUserProfileMutation, CreateUserProfileMutationVariables>(CreateUserProfileDocument, options);
      }
export type CreateUserProfileMutationHookResult = ReturnType<typeof useCreateUserProfileMutation>;
export type CreateUserProfileMutationResult = Apollo.MutationResult<CreateUserProfileMutation>;
export type CreateUserProfileMutationOptions = Apollo.BaseMutationOptions<CreateUserProfileMutation, CreateUserProfileMutationVariables>;
export const UpdateUserProfileDocument = gql`
    mutation updateUserProfile($input: UpdateUserProfileInput!) {
  updateUserProfile(input: $input) {
    userId
    email
    firstName
    lastName
    mailingAddress {
      addressLine1
      addressLine2
      city
      state
      zipcode
      latitude
      longitude
    }
    phone
  }
}
    `;
export type UpdateUserProfileMutationFn = Apollo.MutationFunction<UpdateUserProfileMutation, UpdateUserProfileMutationVariables>;

/**
 * __useUpdateUserProfileMutation__
 *
 * To run a mutation, you first call `useUpdateUserProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserProfileMutation, { data, loading, error }] = useUpdateUserProfileMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateUserProfileMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserProfileMutation, UpdateUserProfileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserProfileMutation, UpdateUserProfileMutationVariables>(UpdateUserProfileDocument, options);
      }
export type UpdateUserProfileMutationHookResult = ReturnType<typeof useUpdateUserProfileMutation>;
export type UpdateUserProfileMutationResult = Apollo.MutationResult<UpdateUserProfileMutation>;
export type UpdateUserProfileMutationOptions = Apollo.BaseMutationOptions<UpdateUserProfileMutation, UpdateUserProfileMutationVariables>;
export const StartLeadConvertedConversationsDocument = gql`
    mutation startLeadConvertedConversations($input: StartLeadConversationsInput!) {
  startLeadConvertedConversations(input: $input) {
    id
  }
}
    `;
export type StartLeadConvertedConversationsMutationFn = Apollo.MutationFunction<StartLeadConvertedConversationsMutation, StartLeadConvertedConversationsMutationVariables>;

/**
 * __useStartLeadConvertedConversationsMutation__
 *
 * To run a mutation, you first call `useStartLeadConvertedConversationsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStartLeadConvertedConversationsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [startLeadConvertedConversationsMutation, { data, loading, error }] = useStartLeadConvertedConversationsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useStartLeadConvertedConversationsMutation(baseOptions?: Apollo.MutationHookOptions<StartLeadConvertedConversationsMutation, StartLeadConvertedConversationsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StartLeadConvertedConversationsMutation, StartLeadConvertedConversationsMutationVariables>(StartLeadConvertedConversationsDocument, options);
      }
export type StartLeadConvertedConversationsMutationHookResult = ReturnType<typeof useStartLeadConvertedConversationsMutation>;
export type StartLeadConvertedConversationsMutationResult = Apollo.MutationResult<StartLeadConvertedConversationsMutation>;
export type StartLeadConvertedConversationsMutationOptions = Apollo.BaseMutationOptions<StartLeadConvertedConversationsMutation, StartLeadConvertedConversationsMutationVariables>;
export const GetContractorProfilePageDataDocument = gql`
    query GetContractorProfilePageData($contractorId: String!) {
  contractorProfile(contractorId: $contractorId) {
    contractorId
    businessName
    abilities {
      name
    }
    contacts {
      firstName
      lastName
      isPrimary
    }
    address {
      city
      state
    }
    thumbnailMediaUrl
    whyYardzenLovesSummary
    aboutSummary
    attributes
    yearsInBusiness
    licenseNumber
    galleryImages {
      uri
    }
    reviews {
      id
      source
      author
      summary
      reviewedTs
    }
    rating
    revisions {
      clientFirstName
      clientLastName
      projectCity
      projectState
      projectPackage
      media {
        bucketName
        objectName
        mimeType
        uri
        buildProjectId
        source
        createdTs
      }
    }
  }
}
    `;

/**
 * __useGetContractorProfilePageDataQuery__
 *
 * To run a query within a React component, call `useGetContractorProfilePageDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContractorProfilePageDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContractorProfilePageDataQuery({
 *   variables: {
 *      contractorId: // value for 'contractorId'
 *   },
 * });
 */
export function useGetContractorProfilePageDataQuery(baseOptions: Apollo.QueryHookOptions<GetContractorProfilePageDataQuery, GetContractorProfilePageDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetContractorProfilePageDataQuery, GetContractorProfilePageDataQueryVariables>(GetContractorProfilePageDataDocument, options);
      }
export function useGetContractorProfilePageDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetContractorProfilePageDataQuery, GetContractorProfilePageDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetContractorProfilePageDataQuery, GetContractorProfilePageDataQueryVariables>(GetContractorProfilePageDataDocument, options);
        }
export type GetContractorProfilePageDataQueryHookResult = ReturnType<typeof useGetContractorProfilePageDataQuery>;
export type GetContractorProfilePageDataLazyQueryHookResult = ReturnType<typeof useGetContractorProfilePageDataLazyQuery>;
export type GetContractorProfilePageDataQueryResult = Apollo.QueryResult<GetContractorProfilePageDataQuery, GetContractorProfilePageDataQueryVariables>;
export const GetAllProMatchesDocument = gql`
    query GetAllProMatches($input: FindMatchesInput!) {
  matches(input: $input) {
    contractorProfile {
      contractorId
      businessName
      abilities {
        name
      }
      contacts {
        firstName
        lastName
        isPrimary
      }
      address {
        city
        state
      }
      thumbnailMediaUrl
      whyYardzenLovesSummary
      aboutSummary
      attributes
      yearsInBusiness
      licenseNumber
      galleryImages {
        uri
      }
      reviews {
        id
        source
        author
        summary
        reviewedTs
      }
      rating
    }
    rank
  }
}
    `;

/**
 * __useGetAllProMatchesQuery__
 *
 * To run a query within a React component, call `useGetAllProMatchesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllProMatchesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllProMatchesQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetAllProMatchesQuery(baseOptions: Apollo.QueryHookOptions<GetAllProMatchesQuery, GetAllProMatchesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllProMatchesQuery, GetAllProMatchesQueryVariables>(GetAllProMatchesDocument, options);
      }
export function useGetAllProMatchesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllProMatchesQuery, GetAllProMatchesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllProMatchesQuery, GetAllProMatchesQueryVariables>(GetAllProMatchesDocument, options);
        }
export type GetAllProMatchesQueryHookResult = ReturnType<typeof useGetAllProMatchesQuery>;
export type GetAllProMatchesLazyQueryHookResult = ReturnType<typeof useGetAllProMatchesLazyQuery>;
export type GetAllProMatchesQueryResult = Apollo.QueryResult<GetAllProMatchesQuery, GetAllProMatchesQueryVariables>;
export const GetContractorDocument = gql`
    query GetContractor($input: FindOneContractorInput!) {
  contractor(input: $input) {
    id
    businessName
    businessName
    abilities
    firstName
    lastName
    city
    state
    userId
    profile {
      rating
      reviews {
        author
        summary
        source
        reviewedTs
      }
    }
  }
}
    `;

/**
 * __useGetContractorQuery__
 *
 * To run a query within a React component, call `useGetContractorQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContractorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContractorQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetContractorQuery(baseOptions: Apollo.QueryHookOptions<GetContractorQuery, GetContractorQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetContractorQuery, GetContractorQueryVariables>(GetContractorDocument, options);
      }
export function useGetContractorLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetContractorQuery, GetContractorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetContractorQuery, GetContractorQueryVariables>(GetContractorDocument, options);
        }
export type GetContractorQueryHookResult = ReturnType<typeof useGetContractorQuery>;
export type GetContractorLazyQueryHookResult = ReturnType<typeof useGetContractorLazyQuery>;
export type GetContractorQueryResult = Apollo.QueryResult<GetContractorQuery, GetContractorQueryVariables>;
export const GetCurrentConversationsDocument = gql`
    query GetCurrentConversations($input: FindAllConversationsInput!) {
  conversations(input: $input) {
    conversationParticipants {
      name
      role
      id
      contractorId
      userProfileId
    }
    id
  }
}
    `;

/**
 * __useGetCurrentConversationsQuery__
 *
 * To run a query within a React component, call `useGetCurrentConversationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCurrentConversationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCurrentConversationsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetCurrentConversationsQuery(baseOptions: Apollo.QueryHookOptions<GetCurrentConversationsQuery, GetCurrentConversationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCurrentConversationsQuery, GetCurrentConversationsQueryVariables>(GetCurrentConversationsDocument, options);
      }
export function useGetCurrentConversationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCurrentConversationsQuery, GetCurrentConversationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCurrentConversationsQuery, GetCurrentConversationsQueryVariables>(GetCurrentConversationsDocument, options);
        }
export type GetCurrentConversationsQueryHookResult = ReturnType<typeof useGetCurrentConversationsQuery>;
export type GetCurrentConversationsLazyQueryHookResult = ReturnType<typeof useGetCurrentConversationsLazyQuery>;
export type GetCurrentConversationsQueryResult = Apollo.QueryResult<GetCurrentConversationsQuery, GetCurrentConversationsQueryVariables>;
export const CreateNewConversationDocument = gql`
    mutation CreateNewConversation($input: CreateConversationInput!) {
  createConversation(input: $input) {
    id
  }
}
    `;
export type CreateNewConversationMutationFn = Apollo.MutationFunction<CreateNewConversationMutation, CreateNewConversationMutationVariables>;

/**
 * __useCreateNewConversationMutation__
 *
 * To run a mutation, you first call `useCreateNewConversationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateNewConversationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createNewConversationMutation, { data, loading, error }] = useCreateNewConversationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateNewConversationMutation(baseOptions?: Apollo.MutationHookOptions<CreateNewConversationMutation, CreateNewConversationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateNewConversationMutation, CreateNewConversationMutationVariables>(CreateNewConversationDocument, options);
      }
export type CreateNewConversationMutationHookResult = ReturnType<typeof useCreateNewConversationMutation>;
export type CreateNewConversationMutationResult = Apollo.MutationResult<CreateNewConversationMutation>;
export type CreateNewConversationMutationOptions = Apollo.BaseMutationOptions<CreateNewConversationMutation, CreateNewConversationMutationVariables>;
export const GetProMatchesDocument = gql`
    query GetProMatches($input: FindMatchesInput!) {
  matches(input: $input) {
    rank
    contractorProfile {
      contractorId
      businessName
      abilities {
        name
      }
      address {
        city
        state
      }
      contacts {
        firstName
        lastName
        isPrimary
      }
      thumbnailMediaUrl
      headshotMediaUrl
      whyYardzenLovesSummary
      aboutSummary
      attributes
      yearsInBusiness
      licenseNumber
      galleryImages {
        uri
      }
      rating
      reviews {
        author
        summary
        reviewedTs
      }
    }
  }
}
    `;

/**
 * __useGetProMatchesQuery__
 *
 * To run a query within a React component, call `useGetProMatchesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProMatchesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProMatchesQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetProMatchesQuery(baseOptions: Apollo.QueryHookOptions<GetProMatchesQuery, GetProMatchesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProMatchesQuery, GetProMatchesQueryVariables>(GetProMatchesDocument, options);
      }
export function useGetProMatchesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProMatchesQuery, GetProMatchesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProMatchesQuery, GetProMatchesQueryVariables>(GetProMatchesDocument, options);
        }
export type GetProMatchesQueryHookResult = ReturnType<typeof useGetProMatchesQuery>;
export type GetProMatchesLazyQueryHookResult = ReturnType<typeof useGetProMatchesLazyQuery>;
export type GetProMatchesQueryResult = Apollo.QueryResult<GetProMatchesQuery, GetProMatchesQueryVariables>;
export const FindFirstBuildProjectDocument = gql`
    query findFirstBuildProject($input: FindAllBuildProjectsInput!) {
  buildProjects(input: $input) {
    id
    projectBudgetEstimate
    internalNotes
    proFacingNotes
    projectElements {
      id
      name
      category
      budgetLowerBound
      budgetUpperBound
      notes
    }
  }
}
    `;

/**
 * __useFindFirstBuildProjectQuery__
 *
 * To run a query within a React component, call `useFindFirstBuildProjectQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindFirstBuildProjectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindFirstBuildProjectQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useFindFirstBuildProjectQuery(baseOptions: Apollo.QueryHookOptions<FindFirstBuildProjectQuery, FindFirstBuildProjectQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindFirstBuildProjectQuery, FindFirstBuildProjectQueryVariables>(FindFirstBuildProjectDocument, options);
      }
export function useFindFirstBuildProjectLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindFirstBuildProjectQuery, FindFirstBuildProjectQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindFirstBuildProjectQuery, FindFirstBuildProjectQueryVariables>(FindFirstBuildProjectDocument, options);
        }
export type FindFirstBuildProjectQueryHookResult = ReturnType<typeof useFindFirstBuildProjectQuery>;
export type FindFirstBuildProjectLazyQueryHookResult = ReturnType<typeof useFindFirstBuildProjectLazyQuery>;
export type FindFirstBuildProjectQueryResult = Apollo.QueryResult<FindFirstBuildProjectQuery, FindFirstBuildProjectQueryVariables>;
export const StartInitialYardzenConversationDocument = gql`
    mutation StartInitialYardzenConversation($input: CreateConversationInput!) {
  startInitialYardzenConversation(input: $input) {
    id
  }
}
    `;
export type StartInitialYardzenConversationMutationFn = Apollo.MutationFunction<StartInitialYardzenConversationMutation, StartInitialYardzenConversationMutationVariables>;

/**
 * __useStartInitialYardzenConversationMutation__
 *
 * To run a mutation, you first call `useStartInitialYardzenConversationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStartInitialYardzenConversationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [startInitialYardzenConversationMutation, { data, loading, error }] = useStartInitialYardzenConversationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useStartInitialYardzenConversationMutation(baseOptions?: Apollo.MutationHookOptions<StartInitialYardzenConversationMutation, StartInitialYardzenConversationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StartInitialYardzenConversationMutation, StartInitialYardzenConversationMutationVariables>(StartInitialYardzenConversationDocument, options);
      }
export type StartInitialYardzenConversationMutationHookResult = ReturnType<typeof useStartInitialYardzenConversationMutation>;
export type StartInitialYardzenConversationMutationResult = Apollo.MutationResult<StartInitialYardzenConversationMutation>;
export type StartInitialYardzenConversationMutationOptions = Apollo.BaseMutationOptions<StartInitialYardzenConversationMutation, StartInitialYardzenConversationMutationVariables>;
export const ApplyMathchingAlgorithmDocument = gql`
    mutation ApplyMathchingAlgorithm($input: FindMatchesInput!) {
  applyMatchingAlgorithm(input: $input) {
    rank
    contractorProfile {
      contractorId
      businessName
      abilities {
        name
      }
      address {
        city
        state
      }
      contacts {
        firstName
        lastName
        isPrimary
      }
      thumbnailMediaUrl
      headshotMediaUrl
      whyYardzenLovesSummary
      aboutSummary
      attributes
      yearsInBusiness
      licenseNumber
      galleryImages {
        uri
      }
      rating
      reviews {
        author
        summary
        reviewedTs
      }
    }
  }
}
    `;
export type ApplyMathchingAlgorithmMutationFn = Apollo.MutationFunction<ApplyMathchingAlgorithmMutation, ApplyMathchingAlgorithmMutationVariables>;

/**
 * __useApplyMathchingAlgorithmMutation__
 *
 * To run a mutation, you first call `useApplyMathchingAlgorithmMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApplyMathchingAlgorithmMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [applyMathchingAlgorithmMutation, { data, loading, error }] = useApplyMathchingAlgorithmMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useApplyMathchingAlgorithmMutation(baseOptions?: Apollo.MutationHookOptions<ApplyMathchingAlgorithmMutation, ApplyMathchingAlgorithmMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ApplyMathchingAlgorithmMutation, ApplyMathchingAlgorithmMutationVariables>(ApplyMathchingAlgorithmDocument, options);
      }
export type ApplyMathchingAlgorithmMutationHookResult = ReturnType<typeof useApplyMathchingAlgorithmMutation>;
export type ApplyMathchingAlgorithmMutationResult = Apollo.MutationResult<ApplyMathchingAlgorithmMutation>;
export type ApplyMathchingAlgorithmMutationOptions = Apollo.BaseMutationOptions<ApplyMathchingAlgorithmMutation, ApplyMathchingAlgorithmMutationVariables>;
export const CreateBuildStudioUserFromFirestoreDataDocument = gql`
    mutation createBuildStudioUserFromFirestoreData($userId: String!) {
  createBuildStudioUserFromFirestoreData(userId: $userId)
}
    `;
export type CreateBuildStudioUserFromFirestoreDataMutationFn = Apollo.MutationFunction<CreateBuildStudioUserFromFirestoreDataMutation, CreateBuildStudioUserFromFirestoreDataMutationVariables>;

/**
 * __useCreateBuildStudioUserFromFirestoreDataMutation__
 *
 * To run a mutation, you first call `useCreateBuildStudioUserFromFirestoreDataMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateBuildStudioUserFromFirestoreDataMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createBuildStudioUserFromFirestoreDataMutation, { data, loading, error }] = useCreateBuildStudioUserFromFirestoreDataMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useCreateBuildStudioUserFromFirestoreDataMutation(baseOptions?: Apollo.MutationHookOptions<CreateBuildStudioUserFromFirestoreDataMutation, CreateBuildStudioUserFromFirestoreDataMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateBuildStudioUserFromFirestoreDataMutation, CreateBuildStudioUserFromFirestoreDataMutationVariables>(CreateBuildStudioUserFromFirestoreDataDocument, options);
      }
export type CreateBuildStudioUserFromFirestoreDataMutationHookResult = ReturnType<typeof useCreateBuildStudioUserFromFirestoreDataMutation>;
export type CreateBuildStudioUserFromFirestoreDataMutationResult = Apollo.MutationResult<CreateBuildStudioUserFromFirestoreDataMutation>;
export type CreateBuildStudioUserFromFirestoreDataMutationOptions = Apollo.BaseMutationOptions<CreateBuildStudioUserFromFirestoreDataMutation, CreateBuildStudioUserFromFirestoreDataMutationVariables>;
export const CreateBuildProjectDocument = gql`
    mutation createBuildProject($input: CreateBuildProjectInput!) {
  createBuildProject(input: $input) {
    id
    projectBudgetEstimate
    internalNotes
    proFacingNotes
    firebaseProjectId
    accountManagerId
    accountManager {
      id
      name
      consultCallUrl
      thumbnailUrl
    }
    projectElements {
      id
      name
      category
      budgetLowerBound
      budgetUpperBound
      notes
    }
  }
}
    `;
export type CreateBuildProjectMutationFn = Apollo.MutationFunction<CreateBuildProjectMutation, CreateBuildProjectMutationVariables>;

/**
 * __useCreateBuildProjectMutation__
 *
 * To run a mutation, you first call `useCreateBuildProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateBuildProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createBuildProjectMutation, { data, loading, error }] = useCreateBuildProjectMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateBuildProjectMutation(baseOptions?: Apollo.MutationHookOptions<CreateBuildProjectMutation, CreateBuildProjectMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateBuildProjectMutation, CreateBuildProjectMutationVariables>(CreateBuildProjectDocument, options);
      }
export type CreateBuildProjectMutationHookResult = ReturnType<typeof useCreateBuildProjectMutation>;
export type CreateBuildProjectMutationResult = Apollo.MutationResult<CreateBuildProjectMutation>;
export type CreateBuildProjectMutationOptions = Apollo.BaseMutationOptions<CreateBuildProjectMutation, CreateBuildProjectMutationVariables>;
export const FetchAdminConversationsDocument = gql`
    query fetchAdminConversations($input: FetchAdminConversationsInput!) {
  adminConversations(input: $input) {
    id
    conversationParticipants {
      id
      contractorId
      userProfileId
      role
      conversationId
    }
  }
}
    `;

/**
 * __useFetchAdminConversationsQuery__
 *
 * To run a query within a React component, call `useFetchAdminConversationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchAdminConversationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchAdminConversationsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useFetchAdminConversationsQuery(baseOptions: Apollo.QueryHookOptions<FetchAdminConversationsQuery, FetchAdminConversationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchAdminConversationsQuery, FetchAdminConversationsQueryVariables>(FetchAdminConversationsDocument, options);
      }
export function useFetchAdminConversationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchAdminConversationsQuery, FetchAdminConversationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchAdminConversationsQuery, FetchAdminConversationsQueryVariables>(FetchAdminConversationsDocument, options);
        }
export type FetchAdminConversationsQueryHookResult = ReturnType<typeof useFetchAdminConversationsQuery>;
export type FetchAdminConversationsLazyQueryHookResult = ReturnType<typeof useFetchAdminConversationsLazyQuery>;
export type FetchAdminConversationsQueryResult = Apollo.QueryResult<FetchAdminConversationsQuery, FetchAdminConversationsQueryVariables>;
export const AssignAccountManagerDocument = gql`
    mutation assignAccountManager($input: AssignAccountManagerInput!) {
  assignAccountManager(input: $input) {
    id
    accountManager {
      id
      name
      consultCallUrl
      thumbnailUrl
    }
  }
}
    `;
export type AssignAccountManagerMutationFn = Apollo.MutationFunction<AssignAccountManagerMutation, AssignAccountManagerMutationVariables>;

/**
 * __useAssignAccountManagerMutation__
 *
 * To run a mutation, you first call `useAssignAccountManagerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAssignAccountManagerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [assignAccountManagerMutation, { data, loading, error }] = useAssignAccountManagerMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAssignAccountManagerMutation(baseOptions?: Apollo.MutationHookOptions<AssignAccountManagerMutation, AssignAccountManagerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AssignAccountManagerMutation, AssignAccountManagerMutationVariables>(AssignAccountManagerDocument, options);
      }
export type AssignAccountManagerMutationHookResult = ReturnType<typeof useAssignAccountManagerMutation>;
export type AssignAccountManagerMutationResult = Apollo.MutationResult<AssignAccountManagerMutation>;
export type AssignAccountManagerMutationOptions = Apollo.BaseMutationOptions<AssignAccountManagerMutation, AssignAccountManagerMutationVariables>;
export const FindUserForMatchingDocument = gql`
    query findUserForMatching($id: String!) {
  findUser(id: $id) {
    accountId
    isProjectClient
    isDesignClient
    hasRevisonDelivered
    isBuildStudioClient
    userProfile {
      userId
      mailingAddress {
        city
        state
      }
      email
      phone
      firstName
      lastName
      leadZipcode
    }
    account {
      buildProjects {
        surveyResponses {
          id
          surveyId
          completed
          surveyQuestionReponses {
            response
            surveyQuestionId
            createdTs
            updatedTs
          }
        }
      }
    }
  }
}
    `;

/**
 * __useFindUserForMatchingQuery__
 *
 * To run a query within a React component, call `useFindUserForMatchingQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindUserForMatchingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindUserForMatchingQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useFindUserForMatchingQuery(baseOptions: Apollo.QueryHookOptions<FindUserForMatchingQuery, FindUserForMatchingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindUserForMatchingQuery, FindUserForMatchingQueryVariables>(FindUserForMatchingDocument, options);
      }
export function useFindUserForMatchingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindUserForMatchingQuery, FindUserForMatchingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindUserForMatchingQuery, FindUserForMatchingQueryVariables>(FindUserForMatchingDocument, options);
        }
export type FindUserForMatchingQueryHookResult = ReturnType<typeof useFindUserForMatchingQuery>;
export type FindUserForMatchingLazyQueryHookResult = ReturnType<typeof useFindUserForMatchingLazyQuery>;
export type FindUserForMatchingQueryResult = Apollo.QueryResult<FindUserForMatchingQuery, FindUserForMatchingQueryVariables>;
export const FindPreMatchingSurveyDocument = gql`
    query findPreMatchingSurvey($input: FindSurveyInput!) {
  survey(input: $input) {
    id
    surveyQuestions {
      id
      questionKey
      text
      section
      index
      format
      required
    }
  }
}
    `;

/**
 * __useFindPreMatchingSurveyQuery__
 *
 * To run a query within a React component, call `useFindPreMatchingSurveyQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindPreMatchingSurveyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindPreMatchingSurveyQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useFindPreMatchingSurveyQuery(baseOptions: Apollo.QueryHookOptions<FindPreMatchingSurveyQuery, FindPreMatchingSurveyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindPreMatchingSurveyQuery, FindPreMatchingSurveyQueryVariables>(FindPreMatchingSurveyDocument, options);
      }
export function useFindPreMatchingSurveyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindPreMatchingSurveyQuery, FindPreMatchingSurveyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindPreMatchingSurveyQuery, FindPreMatchingSurveyQueryVariables>(FindPreMatchingSurveyDocument, options);
        }
export type FindPreMatchingSurveyQueryHookResult = ReturnType<typeof useFindPreMatchingSurveyQuery>;
export type FindPreMatchingSurveyLazyQueryHookResult = ReturnType<typeof useFindPreMatchingSurveyLazyQuery>;
export type FindPreMatchingSurveyQueryResult = Apollo.QueryResult<FindPreMatchingSurveyQuery, FindPreMatchingSurveyQueryVariables>;
export const CreateSurveyResponseMutationDocument = gql`
    mutation CreateSurveyResponseMutation($input: CreateSurveyResponseInput!) {
  createSurveyResponse(input: $input) {
    id
    surveyId
    buildProjectId
  }
}
    `;
export type CreateSurveyResponseMutationMutationFn = Apollo.MutationFunction<CreateSurveyResponseMutationMutation, CreateSurveyResponseMutationMutationVariables>;

/**
 * __useCreateSurveyResponseMutationMutation__
 *
 * To run a mutation, you first call `useCreateSurveyResponseMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSurveyResponseMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSurveyResponseMutationMutation, { data, loading, error }] = useCreateSurveyResponseMutationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateSurveyResponseMutationMutation(baseOptions?: Apollo.MutationHookOptions<CreateSurveyResponseMutationMutation, CreateSurveyResponseMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSurveyResponseMutationMutation, CreateSurveyResponseMutationMutationVariables>(CreateSurveyResponseMutationDocument, options);
      }
export type CreateSurveyResponseMutationMutationHookResult = ReturnType<typeof useCreateSurveyResponseMutationMutation>;
export type CreateSurveyResponseMutationMutationResult = Apollo.MutationResult<CreateSurveyResponseMutationMutation>;
export type CreateSurveyResponseMutationMutationOptions = Apollo.BaseMutationOptions<CreateSurveyResponseMutationMutation, CreateSurveyResponseMutationMutationVariables>;
export const UpsertSurveyQuestionResponsesDocument = gql`
    mutation UpsertSurveyQuestionResponses($input: UpsertSurveyQuestionResponsesInput!) {
  upsertSurveyQuestionResponses(input: $input) {
    surveyQuestionId
    surveyResponseId
    response
  }
}
    `;
export type UpsertSurveyQuestionResponsesMutationFn = Apollo.MutationFunction<UpsertSurveyQuestionResponsesMutation, UpsertSurveyQuestionResponsesMutationVariables>;

/**
 * __useUpsertSurveyQuestionResponsesMutation__
 *
 * To run a mutation, you first call `useUpsertSurveyQuestionResponsesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertSurveyQuestionResponsesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertSurveyQuestionResponsesMutation, { data, loading, error }] = useUpsertSurveyQuestionResponsesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpsertSurveyQuestionResponsesMutation(baseOptions?: Apollo.MutationHookOptions<UpsertSurveyQuestionResponsesMutation, UpsertSurveyQuestionResponsesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertSurveyQuestionResponsesMutation, UpsertSurveyQuestionResponsesMutationVariables>(UpsertSurveyQuestionResponsesDocument, options);
      }
export type UpsertSurveyQuestionResponsesMutationHookResult = ReturnType<typeof useUpsertSurveyQuestionResponsesMutation>;
export type UpsertSurveyQuestionResponsesMutationResult = Apollo.MutationResult<UpsertSurveyQuestionResponsesMutation>;
export type UpsertSurveyQuestionResponsesMutationOptions = Apollo.BaseMutationOptions<UpsertSurveyQuestionResponsesMutation, UpsertSurveyQuestionResponsesMutationVariables>;
export const FindSurveyResponsesDocument = gql`
    query findSurveyResponses($input: FindSurveyResponseInput!) {
  surveyResponse(input: $input) {
    id
    completed
    surveyQuestionReponses {
      surveyQuestionId
      surveyResponseId
      response
    }
  }
}
    `;

/**
 * __useFindSurveyResponsesQuery__
 *
 * To run a query within a React component, call `useFindSurveyResponsesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindSurveyResponsesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindSurveyResponsesQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useFindSurveyResponsesQuery(baseOptions: Apollo.QueryHookOptions<FindSurveyResponsesQuery, FindSurveyResponsesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindSurveyResponsesQuery, FindSurveyResponsesQueryVariables>(FindSurveyResponsesDocument, options);
      }
export function useFindSurveyResponsesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindSurveyResponsesQuery, FindSurveyResponsesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindSurveyResponsesQuery, FindSurveyResponsesQueryVariables>(FindSurveyResponsesDocument, options);
        }
export type FindSurveyResponsesQueryHookResult = ReturnType<typeof useFindSurveyResponsesQuery>;
export type FindSurveyResponsesLazyQueryHookResult = ReturnType<typeof useFindSurveyResponsesLazyQuery>;
export type FindSurveyResponsesQueryResult = Apollo.QueryResult<FindSurveyResponsesQuery, FindSurveyResponsesQueryVariables>;
export const FindInvoicesForMatchingDocument = gql`
    query findInvoicesForMatching($input: FindInvoicesInput!) {
  invoices(input: $input) {
    id
    paid
    paymentMilestone
  }
}
    `;

/**
 * __useFindInvoicesForMatchingQuery__
 *
 * To run a query within a React component, call `useFindInvoicesForMatchingQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindInvoicesForMatchingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindInvoicesForMatchingQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useFindInvoicesForMatchingQuery(baseOptions: Apollo.QueryHookOptions<FindInvoicesForMatchingQuery, FindInvoicesForMatchingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindInvoicesForMatchingQuery, FindInvoicesForMatchingQueryVariables>(FindInvoicesForMatchingDocument, options);
      }
export function useFindInvoicesForMatchingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindInvoicesForMatchingQuery, FindInvoicesForMatchingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindInvoicesForMatchingQuery, FindInvoicesForMatchingQueryVariables>(FindInvoicesForMatchingDocument, options);
        }
export type FindInvoicesForMatchingQueryHookResult = ReturnType<typeof useFindInvoicesForMatchingQuery>;
export type FindInvoicesForMatchingLazyQueryHookResult = ReturnType<typeof useFindInvoicesForMatchingLazyQuery>;
export type FindInvoicesForMatchingQueryResult = Apollo.QueryResult<FindInvoicesForMatchingQuery, FindInvoicesForMatchingQueryVariables>;
export const CreateCurrentTermsOfServiceDocument = gql`
    mutation CreateCurrentTermsOfService($input: CreateCurrentUserTermsOfServiceInput!) {
  createCurrentUserTermsOfService(input: $input) {
    id
  }
}
    `;
export type CreateCurrentTermsOfServiceMutationFn = Apollo.MutationFunction<CreateCurrentTermsOfServiceMutation, CreateCurrentTermsOfServiceMutationVariables>;

/**
 * __useCreateCurrentTermsOfServiceMutation__
 *
 * To run a mutation, you first call `useCreateCurrentTermsOfServiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCurrentTermsOfServiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCurrentTermsOfServiceMutation, { data, loading, error }] = useCreateCurrentTermsOfServiceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateCurrentTermsOfServiceMutation(baseOptions?: Apollo.MutationHookOptions<CreateCurrentTermsOfServiceMutation, CreateCurrentTermsOfServiceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCurrentTermsOfServiceMutation, CreateCurrentTermsOfServiceMutationVariables>(CreateCurrentTermsOfServiceDocument, options);
      }
export type CreateCurrentTermsOfServiceMutationHookResult = ReturnType<typeof useCreateCurrentTermsOfServiceMutation>;
export type CreateCurrentTermsOfServiceMutationResult = Apollo.MutationResult<CreateCurrentTermsOfServiceMutation>;
export type CreateCurrentTermsOfServiceMutationOptions = Apollo.BaseMutationOptions<CreateCurrentTermsOfServiceMutation, CreateCurrentTermsOfServiceMutationVariables>;
export const GetRenderFeedbackDocument = gql`
    query GetRenderFeedback($segmentId: String!) {
  getRenderFeedback(segmentId: $segmentId) {
    externalId
    imageUrl
    likedAt
    likedFrom
  }
}
    `;

/**
 * __useGetRenderFeedbackQuery__
 *
 * To run a query within a React component, call `useGetRenderFeedbackQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRenderFeedbackQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRenderFeedbackQuery({
 *   variables: {
 *      segmentId: // value for 'segmentId'
 *   },
 * });
 */
export function useGetRenderFeedbackQuery(baseOptions: Apollo.QueryHookOptions<GetRenderFeedbackQuery, GetRenderFeedbackQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRenderFeedbackQuery, GetRenderFeedbackQueryVariables>(GetRenderFeedbackDocument, options);
      }
export function useGetRenderFeedbackLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRenderFeedbackQuery, GetRenderFeedbackQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRenderFeedbackQuery, GetRenderFeedbackQueryVariables>(GetRenderFeedbackDocument, options);
        }
export type GetRenderFeedbackQueryHookResult = ReturnType<typeof useGetRenderFeedbackQuery>;
export type GetRenderFeedbackLazyQueryHookResult = ReturnType<typeof useGetRenderFeedbackLazyQuery>;
export type GetRenderFeedbackQueryResult = Apollo.QueryResult<GetRenderFeedbackQuery, GetRenderFeedbackQueryVariables>;
export const SubmitRenderFeedbackSetDocument = gql`
    mutation SubmitRenderFeedbackSet($input: RenderFeedbackSetInput!) {
  submitRenderFeedbackSet(input: $input) {
    id
  }
}
    `;
export type SubmitRenderFeedbackSetMutationFn = Apollo.MutationFunction<SubmitRenderFeedbackSetMutation, SubmitRenderFeedbackSetMutationVariables>;

/**
 * __useSubmitRenderFeedbackSetMutation__
 *
 * To run a mutation, you first call `useSubmitRenderFeedbackSetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitRenderFeedbackSetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitRenderFeedbackSetMutation, { data, loading, error }] = useSubmitRenderFeedbackSetMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSubmitRenderFeedbackSetMutation(baseOptions?: Apollo.MutationHookOptions<SubmitRenderFeedbackSetMutation, SubmitRenderFeedbackSetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SubmitRenderFeedbackSetMutation, SubmitRenderFeedbackSetMutationVariables>(SubmitRenderFeedbackSetDocument, options);
      }
export type SubmitRenderFeedbackSetMutationHookResult = ReturnType<typeof useSubmitRenderFeedbackSetMutation>;
export type SubmitRenderFeedbackSetMutationResult = Apollo.MutationResult<SubmitRenderFeedbackSetMutation>;
export type SubmitRenderFeedbackSetMutationOptions = Apollo.BaseMutationOptions<SubmitRenderFeedbackSetMutation, SubmitRenderFeedbackSetMutationVariables>;
export const SubmitRenderFeedbackDocument = gql`
    mutation SubmitRenderFeedback($input: RenderFeedbackInput!) {
  submitRenderFeedback(input: $input) {
    id
  }
}
    `;
export type SubmitRenderFeedbackMutationFn = Apollo.MutationFunction<SubmitRenderFeedbackMutation, SubmitRenderFeedbackMutationVariables>;

/**
 * __useSubmitRenderFeedbackMutation__
 *
 * To run a mutation, you first call `useSubmitRenderFeedbackMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitRenderFeedbackMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitRenderFeedbackMutation, { data, loading, error }] = useSubmitRenderFeedbackMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSubmitRenderFeedbackMutation(baseOptions?: Apollo.MutationHookOptions<SubmitRenderFeedbackMutation, SubmitRenderFeedbackMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SubmitRenderFeedbackMutation, SubmitRenderFeedbackMutationVariables>(SubmitRenderFeedbackDocument, options);
      }
export type SubmitRenderFeedbackMutationHookResult = ReturnType<typeof useSubmitRenderFeedbackMutation>;
export type SubmitRenderFeedbackMutationResult = Apollo.MutationResult<SubmitRenderFeedbackMutation>;
export type SubmitRenderFeedbackMutationOptions = Apollo.BaseMutationOptions<SubmitRenderFeedbackMutation, SubmitRenderFeedbackMutationVariables>;